import React, { useRef, useState, useEffect, useContext } from 'react';
import { useDispatch, connect as connect$1, useSelector } from 'react-redux';
import { compose, applyMiddleware, createStore, combineReducers } from 'redux';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

var AbortProvider = /*#__PURE__*/function () {
  function AbortProvider() {
    var _this = this;

    _classCallCheck(this, AbortProvider);

    _defineProperty(this, "_aborted", false);

    _defineProperty(this, "_reason", undefined);

    _defineProperty(this, "_controller", void 0);

    _defineProperty(this, "_callbacks", []);

    _defineProperty(this, "abort", function (reason) {
      var _this$_controller;

      _this._aborted = true;
      _this._reason = reason;
      (_this$_controller = _this._controller) === null || _this$_controller === void 0 ? void 0 : _this$_controller.abort();

      _this._callbacks.forEach(function (c) {
        return c(reason);
      });
    });

    _defineProperty(this, "reset", function () {
      _this._aborted = false;
      _this._reason = undefined;
    });

    _defineProperty(this, "addListener", function (callback) {
      _this._callbacks.push(callback);
    });

    _defineProperty(this, "removeListener", function (callback) {
      _this._callbacks.filter(function (c) {
        return c !== callback;
      });
    });

    if (AbortController === undefined) return;
    this._controller = new AbortController();
  }

  _createClass(AbortProvider, [{
    key: "signal",
    get: function get() {
      var _this$_controller2;

      return (_this$_controller2 = this._controller) === null || _this$_controller2 === void 0 ? void 0 : _this$_controller2.signal;
    }
  }, {
    key: "aborted",
    get: function get() {
      return this._aborted;
    }
  }, {
    key: "reason",
    get: function get() {
      return this._reason;
    }
  }]);

  return AbortProvider;
}();

var NAMESPACE = "ABORT";
var ABORTABLE_PROVIDER = "".concat(NAMESPACE, "/PROVIDER");
var abortableApi = function abortableApi(action) {
  return {
    type: ABORTABLE_PROVIDER,
    abort: new AbortProvider(),
    action: action
  };
};

var defaultOptions = {
  lazy: true,
  actionSlowDelay: 200
};

/**
 * A hook to trigger an existing API action
 * @param {function} `action` API action creator
 * @param {object} `options` Additional options for the API request
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {number} `options.actionSlowDelay` Optional, time delay before the request indicates it is taking a long time, default 200ms
 * @param {*} `options.actionParams` Optional, additonal parameters to supply to the request action
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */
var useApiAction = function useApiAction(action) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _options = _objectSpread2(_objectSpread2({}, defaultOptions), options);

  var loadingKey = useRef(0);
  var loadingAbort = useRef(undefined);

  var _useState = useState({
    busy: false,
    aborted: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      requestState = _useState2[0],
      setRequestState = _useState2[1];

  var dispatch = useDispatch();

  var sendRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var actionParams,
          requestKey,
          requestAction,
          abort,
          slowTimeout,
          _yield$dispatch,
          success,
          response,
          error,
          aborted,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              actionParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : _options.actionParams;
              requestKey = loadingKey.current = Date.now();
              requestAction = abortableApi(action(actionParams));
              abort = requestAction.abort;
              loadingAbort.current = abort;
              setRequestState({
                busy: true,
                aborted: abort.aborted,
                sentAt: Date.now()
              });
              slowTimeout = setTimeout(function () {
                setRequestState(function (state) {
                  return _objectSpread2(_objectSpread2({}, state), {}, {
                    slow: true
                  });
                });
              }, _options.actionSlowDelay);
              _context.next = 9;
              return dispatch(requestAction);

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              response = _yield$dispatch.response;
              error = _yield$dispatch.error;
              aborted = abort.aborted;
              clearTimeout(slowTimeout); // prevent request race conditions

              if (!(requestKey !== loadingKey.current)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              setRequestState(function (state) {
                return _objectSpread2(_objectSpread2({}, state), {}, {
                  success: success,
                  response: response,
                  error: error,
                  busy: false,
                  slow: false,
                  aborted: aborted,
                  receivedAt: aborted ? undefined : Date.now(),
                  abortedAt: aborted ? Date.now() : undefined
                });
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendRequest() {
      return _ref.apply(this, arguments);
    };
  }();

  var abortRequest = function abortRequest() {
    var _loadingAbort$current;

    (_loadingAbort$current = loadingAbort.current) === null || _loadingAbort$current === void 0 ? void 0 : _loadingAbort$current.abort();
  };

  useEffect(function () {
    if (!_options.lazy) sendRequest();
  }, []);
  return [requestState, sendRequest, abortRequest];
};

var strictUriEncode = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

var stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

var EventType;

(function (EventType) {
  EventType["Success"] = "Success";
  EventType["Info"] = "Info";
  EventType["Warning"] = "Warning";
  EventType["Error"] = "Error";
})(EventType || (EventType = {}));

var AddMethod;

(function (AddMethod) {
  AddMethod["AddTop"] = "AddTop";
  AddMethod["AddOrReplaceTop"] = "AddOrReplaceTop";
})(AddMethod || (AddMethod = {}));

var ADD = "NOTIFICATIONS/ADD";
var REMOVE = "NOTIFICATIONS/REMOVE";
var REMOVE_ALL = "NOTIFICATIONS/REMOVE_ALL";

/**
 * Action creator for sending a notification
 * @param {Object} `options` Options for the notification
 * @param {string} `options.title` The notification title text
 * @param {string} `options.eventType` The type of notification
 * @param {string} `options.message` The notification message text
 * @param {*} `options.customData` Optional custom data about the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear
 * @param {string} `options.method` How the notification is added. Options are "AddTop" and "AddOrReplaceTop". Defaults to "AddOrReplaceTop"
 */
var addNotification = function addNotification(options) {
  return function (dispatch) {
    var _options$title, _options$type, _options$message, _options$expiry, _options$method;

    return dispatch({
      type: ADD,
      title: (_options$title = options.title) !== null && _options$title !== void 0 ? _options$title : "",
      eventType: (_options$type = options.type) !== null && _options$type !== void 0 ? _options$type : EventType.Info,
      message: (_options$message = options.message) !== null && _options$message !== void 0 ? _options$message : "",
      customData: options.customData !== undefined ? options.customData : null,
      expiry: (_options$expiry = options.expiry) !== null && _options$expiry !== void 0 ? _options$expiry : 0,
      method: (_options$method = options.method) !== null && _options$method !== void 0 ? _options$method : AddMethod.AddOrReplaceTop
    });
  };
};
/**
 * Action creator for removing a single notification
 * @param {number} `id` The unique id of the notification event to remove
 */

var removeNotification = function removeNotification(id) {
  return function (dispatch) {
    return dispatch({
      type: REMOVE,
      id: id
    });
  };
};
/**
 * Action creator for clearing all notifications
 */

var removeAllNotifications = function removeAllNotifications() {
  return function (dispatch) {
    return dispatch({
      type: REMOVE_ALL
    });
  };
};
/**
 * Action creator for sending a success message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */

var notifySuccess = function notifySuccess(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Success,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending an information message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */

var notifyInfo = function notifyInfo(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Info,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending a warning message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */

var notifyWarning = function notifyWarning(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Warning,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending an error message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear
 */

var notifyError = function notifyError(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Error
  }));
};

var getNotificationState = function getNotificationState(state) {
  return state.notifications;
};

var debounce = function debounce(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;
      if (!options.immediate) func.apply(context, args);
    };

    var callNow = options.immediate && !timeout;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
var DebounceMap = /*#__PURE__*/function () {
  function DebounceMap() {
    _classCallCheck(this, DebounceMap);

    _defineProperty(this, "_config", {});

    _defineProperty(this, "_debounces", {});
  }

  _createClass(DebounceMap, [{
    key: "_registerDebounce",
    value: function _registerDebounce(key) {
      var timeout;
      var config = this._config;
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var context = this;
        var options = config[key].options || {};

        var later = function later() {
          timeout = null;

          if (!options.immediate) {
            config[key].func.apply(context, args);
          }
        };

        var callNow = options.immediate && !timeout;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, config[key].wait);
        if (callNow) config[key].func.apply(context, args);
      };
    }
  }, {
    key: "debounce",
    value: function debounce(key, func, wait) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this._config[key] = {
        func: func,
        wait: wait,
        options: options
      };

      if (!this._debounces[key]) {
        this._debounces[key] = this._registerDebounce(key);
      }

      this._debounces[key]();
    }
  }]);

  return DebounceMap;
}();

var isPlainObject = function isPlainObject(value) {
  return value instanceof Object && Object.getPrototypeOf(value) == Object.prototype;
};

var applyObjectChanges = function applyObjectChanges(target, changes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.keys(changes).forEach(function (key) {
    if (!options.requireExistingKeys || target.hasOwnProperty(key)) {
      if (options.mergeValues && isPlainObject(changes[key])) {
        target[key] = target[key] || {};
        applyObjectChanges(target[key], changes[key]);
      } else {
        target[key] = changes[key];
      }
    }
  });
};

var ModuleConfig = /*#__PURE__*/function () {
  function ModuleConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ModuleConfig);

    _defineProperty(this, "_options", void 0);

    this._options = _objectSpread2({}, config);
  }

  _createClass(ModuleConfig, [{
    key: "exists",
    value: function exists(key) {
      return this._options.hasOwnProperty(key);
    }
  }, {
    key: "isNullOrWhitespace",
    value: function isNullOrWhitespace(key) {
      if (this.exists(key)) {
        var value = this.get(key);

        if (typeof value === "string") {
          return value.trim() === "";
        }

        return value === undefined || value === null;
      }

      return false;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._options[key];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._options;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this._options[key] = value;
    }
  }, {
    key: "setAll",
    value: function setAll(config) {
      var requireExistingKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var mergeValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      applyObjectChanges(this._options, config, {
        requireExistingKeys: requireExistingKeys,
        mergeValues: mergeValues
      });
    }
  }]);

  return ModuleConfig;
}();
var ModuleIntegration = /*#__PURE__*/function () {
  function ModuleIntegration(type) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ModuleIntegration);

    _defineProperty(this, "_type", void 0);

    _defineProperty(this, "_config", void 0);

    _defineProperty(this, "_actions", void 0);

    _defineProperty(this, "_events", void 0);

    this._type = type;
    this._config = config instanceof ModuleConfig ? config : new ModuleConfig(config);
    this._actions = {};
    this._events = {};
  }

  _createClass(ModuleIntegration, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "addAction",
    value: function addAction(key, action) {
      this._actions[key] = action;
    }
  }, {
    key: "addActions",
    value: function addActions(actions) {
      this._actions = _objectSpread2(_objectSpread2({}, this._actions), actions);
    }
  }, {
    key: "findAction",
    value: function findAction(key) {
      return this._actions.hasOwnProperty(key) ? this._actions[key] : undefined;
    }
  }, {
    key: "addEvent",
    value: function addEvent(key, event) {
      this._events[key] = event;
    }
  }, {
    key: "addEvents",
    value: function addEvents(events) {
      this._events = _objectSpread2(_objectSpread2({}, this._events), events);
    }
  }, {
    key: "findEvent",
    value: function findEvent(key) {
      return this._events.hasOwnProperty(key) ? this._events[key] : undefined;
    }
  }]);

  return ModuleIntegration;
}();
var ModuleIntegrationPipeline = /*#__PURE__*/function () {
  function ModuleIntegrationPipeline() {
    _classCallCheck(this, ModuleIntegrationPipeline);

    _defineProperty(this, "_integrations", void 0);

    _defineProperty(this, "_default", void 0);

    this._integrations = [];
    this._default = undefined;
  }

  _createClass(ModuleIntegrationPipeline, [{
    key: "exists",
    value: function exists(integration) {
      return this._integrations.some(function (i) {
        return integration.type === i.type;
      });
    }
  }, {
    key: "any",
    value: function any() {
      return this._integrations.length > 0;
    }
  }, {
    key: "add",
    value: function add(integration, setDefault) {
      if (!this.exists(integration)) this._integrations.push(integration);

      if (setDefault || this._integrations.length === 1) {
        this._default = integration;
      }
    }
  }, {
    key: "setDefault",
    value: function setDefault(integration) {
      if (this.exists(integration)) this._default = integration;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      return this._default;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _toConsumableArray(this._integrations);
    }
  }]);

  return ModuleIntegrationPipeline;
}();

var nameIdMap = {};
var createAutoName = function createAutoName(prefix) {
  var nextId = nameIdMap[prefix];

  if (!nextId) {
    nextId = 1;
  }

  nameIdMap[prefix] = nextId + 1;
  return "".concat(prefix).concat(nextId);
};

var getParamsKey = function getParamsKey(params) {
  var str = params ? JSON.stringify(params) : "";
  var len = str.length; // simple non-secure hashing
  // from https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript

  var key = 0;

  if (len === 0) {
    return key;
  }

  for (var i = 0; i < len; i++) {
    key = (key << 5) - key + str.charCodeAt(i);
    key = key & key; // Convert to 32bit integer
  }

  return key;
};
var compareParams = function compareParams(paramsA, paramsB) {
  return getParamsKey(paramsA) === getParamsKey(paramsB);
};

var concurrentPromise = function concurrentPromise() {
  var promise;
  return function (func) {
    if (!promise) promise = func();
    return promise.then(function (value) {
      promise = null;
      return Promise.resolve(value);
    }).catch(function (error) {
      promise = null;
      throw error;
    });
  };
};
var ConcurrentPromiseMap = /*#__PURE__*/function () {
  function ConcurrentPromiseMap() {
    _classCallCheck(this, ConcurrentPromiseMap);

    _defineProperty(this, "_promises", {});
  }

  _createClass(ConcurrentPromiseMap, [{
    key: "resolve",
    value: function resolve(key, func) {
      var _this = this;

      if (!this._promises[key]) {
        this._promises[key] = func();
      }

      return this._promises[key].then(function (value) {
        _this._promises[key] = null;
        return Promise.resolve(value);
      }).catch(function (error) {
        _this._promises[key] = null;
        throw error;
      });
    }
  }]);

  return ConcurrentPromiseMap;
}();

/**
 * Wrapper to create a simpler 'typed' version of react-redux connect()
 */
var createTypedConnect = function createTypedConnect() {
  return function (mapStateToProps, mapDispatchToProps) {
    return function (component) {
      return connect$1(mapStateToProps, mapDispatchToProps)(component);
    };
  };
};

var AjaxStatus;

(function (AjaxStatus) {
  AjaxStatus[AjaxStatus["Ready"] = 0] = "Ready";
  AjaxStatus[AjaxStatus["Loading"] = 1] = "Loading";
  AjaxStatus[AjaxStatus["Success"] = 2] = "Success";
  AjaxStatus[AjaxStatus["Error"] = 3] = "Error";
})(AjaxStatus || (AjaxStatus = {}));

var HttpStatus;

(function (HttpStatus) {
  HttpStatus[HttpStatus["OK"] = 200] = "OK";
  HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
  HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
  HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
  HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
  HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(HttpStatus || (HttpStatus = {}));

var ApiError = /*#__PURE__*/function () {
  function ApiError(response, status) {
    var _this = this;

    _classCallCheck(this, ApiError);

    _defineProperty(this, "status", void 0);

    _defineProperty(this, "response", void 0);

    _defineProperty(this, "format", function () {
      var omitCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var overrideMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof _this.response === "string" && _this.response.length > 0) {
        return [_this.response];
      } // takes an error message/code/data, shows only message if omitCodes=true
      // [{ code: 3, message: "foo", data: ["more", "details"] }];
      // becomes ["foo (more, details) [3]"];
      // [{ code: 3, message: "foo"}];
      // becomes ["foo [3]"];


      var prettyError = function prettyError(error) {
        var message = error.message,
            data = error.data,
            code = error.code;
        var messageStr = message !== undefined && overrideMessages.hasOwnProperty(message) ? overrideMessages[message] : code !== undefined && overrideMessages.hasOwnProperty(code) ? overrideMessages[code] : message;

        if (typeof messageStr === "function") {
          messageStr = messageStr(error);
        }

        if (typeof messageStr === "string") {
          var dataStr = typeof data === "string" ? " (".concat(data, ")") : Array.isArray(data) ? " (".concat(data.join(", "), ")") : "";
          var codeStr = omitCodes || code === null || code === undefined ? "" : " [".concat(code, "]");
          return "".concat(messageStr).concat(dataStr).concat(codeStr);
        }

        return /*#__PURE__*/React.isValidElement(messageStr) ? messageStr : null;
      };

      if (Array.isArray(_this.response)) {
        return _this.response.reduce(function (acc, e) {
          var msg = prettyError(e);
          return msg ? [].concat(_toConsumableArray(acc), [msg]) : acc;
        }, []);
      }

      if (_typeof(_this.response) === "object") {
        var msg = prettyError(_this.response);
        return msg ? [msg] : [];
      }

      return [];
    });

    this.status = status !== undefined ? status : HttpStatus.InternalServerError;
    this.response = response;
  }

  _createClass(ApiError, [{
    key: "message",
    get: function get() {
      var messages = this.format();
      return messages.length > 0 ? messages.join(" / ") : "An unexpected error has occurred";
    }
  }]);

  return ApiError;
}();

var defaultOptions$1 = {
  apiUrl: "",
  onErrorNotification: function onErrorNotification(message) {
    return notifyError(message);
  },
  preventErrorNotification: false,
  preventResponseHandling: false,
  fetchFailureError: "Network connection unavailable",
  onErrorResponse: function onErrorResponse(response) {
    return new Promise(function (resolve) {
      response.json().then(function (data) {
        return resolve(new ApiError(data, response.status));
      }).catch(function (error) {
        return resolve(new ApiError(error.message));
      });
    });
  }
};
var config = new ModuleConfig(defaultOptions$1);
var getApiOptions = function getApiOptions() {
  return config.getAll();
};
/**
 * Configures options for the api module
 * @param {object} `options` Options to set
 * @param {string} `options.apiUrl` Default host address for API calls
 * @param {function} `options.onErrorNotification` Redux action creator that will be dispatched whenever an error notification event occurs, default implementation is to send the error to the Notifications module
 * @param {boolean} `options.preventErrorNotification` Whether to disable error notification events as a result of failed API calls, default false
 * @param {boolean} `options.preventResponseHandling` Whether to disable response handling for requests, default false
 * @param {string} `options.fetchFailureError` Error message to display when a fetch request fails, default "Network connection unavailable"
 * @param {function} `options.onErrorResponse` The function used to convert a response to an ApiError when a fetch request returns an error
 */

var setApiOptions = function setApiOptions(options) {
  return config.setAll(options);
}; // internal module helpers

var getApiUrl = function getApiUrl() {
  if (config.isNullOrWhitespace("apiUrl")) console.error("apiUrl not configured in api module");
  return config.get("apiUrl");
};
var getOnErrorNotification = function getOnErrorNotification() {
  return config.get("onErrorNotification");
};
var getPreventErrorNotification = function getPreventErrorNotification() {
  return config.get("preventErrorNotification");
};
var getPreventResponseHandling = function getPreventResponseHandling() {
  return config.get("preventResponseHandling");
};
var getFetchFailureError = function getFetchFailureError() {
  return config.get("fetchFailureError");
};
var getOnErrorResponse = function getOnErrorResponse() {
  return config.get("onErrorResponse");
};

var NAMESPACE$1 = "API";
var API_REQUEST = "".concat(NAMESPACE$1, "/REQUEST");
var ApiRequestMethod;

(function (ApiRequestMethod) {
  ApiRequestMethod["GET"] = "GET";
  ApiRequestMethod["POST"] = "POST";
  ApiRequestMethod["PUT"] = "PUT";
  ApiRequestMethod["PATCH"] = "PATCH";
  ApiRequestMethod["DELETE"] = "DELETE";
})(ApiRequestMethod || (ApiRequestMethod = {}));

/**
 * Generic action creator for API requests
 * (use apiGet, apiPost etc, common methods below for most requests, use apiRequest for non-standard requests)
 * @param {Object} `options` Specification for the API request
 * @param {string} `options.type` Redux action type
 * @param {string} `options.method` Request method type, e.g. GET, POST, PUT, DELETE
 * @param {string} `options.path` Combines the base project API URL with this route for the API endpoint
 * @param {string} `options.url` Use this instead of path to override the full URL for the API endpoint
 * @param {Object} `options.params` Optional, query string parameters to append to the request URL
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {*} `options.body` Optional, the body of the request
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */
var apiRequest = function apiRequest(options) {
  var url = options.path && options.path !== undefined ? getApiUrl() + options.path : options.url || "";
  var urlWithParams = options.params && !!Object.keys(options.params).length ? "".concat(url).concat(url.indexOf("?") === -1 ? "?" : "&").concat(stringify(options.params)) : url;
  return {
    type: API_REQUEST,
    requestType: options.type,
    method: options.method,
    url: urlWithParams,
    contentType: options.contentType !== undefined ? options.contentType : "application/json",
    headers: options.headers,
    body: options.body !== undefined ? options.body : null,
    auth: options.auth !== undefined ? options.auth : true,
    actionCustomData: options.actionCustomData,
    actionSlowDelay: options.actionSlowDelay !== undefined ? options.actionSlowDelay : 200,
    preventErrorNotification: options.preventErrorNotification || false,
    preventResponseHandling: options.preventResponseHandling || false,
    debounce: typeof options.debounce === "number" ? options.debounce : false,
    abort: options.abort
  };
};
var ApiRequestsErrorPriority;

(function (ApiRequestsErrorPriority) {
  ApiRequestsErrorPriority["First"] = "first";
  ApiRequestsErrorPriority["Last"] = "last";
  ApiRequestsErrorPriority["Earliest"] = "earliest";
  ApiRequestsErrorPriority["Latest"] = "latest";
})(ApiRequestsErrorPriority || (ApiRequestsErrorPriority = {}));

/**
 * Action creator for combining multiple API requests
 * @param {Object|Array} `apiActions` One or more API actions to be requested. Can be a keyed-object (the final response will be an object with matching keyed responses), or an array (the final response will be an array of responses)
 * @param {Object} `options` Additional options for handling the requests
 * @param {string} `options.errorPriority` Optional, give priority to errors for specific requests, can be one of "first", "last", "earliest", "latest" (default is earliest)
 * @returns {function} Redux action thunk
 */
var apiRequests = function apiRequests(apiActions) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var isArray, mapActions, mapResponses, mapErrors, keys, mappedActions, requests, results, errorResults, response, error;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isArray = Array.isArray(apiActions);

              mapActions = function mapActions(a) {
                return a;
              };

              mapResponses = function mapResponses(r) {
                return r;
              };

              mapErrors = function mapErrors(e) {
                switch (options.errorPriority) {
                  case ApiRequestsErrorPriority.First:
                    return e[0].error;

                  case ApiRequestsErrorPriority.Last:
                    return e[e.length - 1].error;

                  case ApiRequestsErrorPriority.Earliest:
                  default:
                    return e.reduce(function (err, next) {
                      return !err || next.finish < err.finish ? next : err;
                    }).error;

                  case ApiRequestsErrorPriority.Latest:
                    return e.reduce(function (err, next) {
                      return !err || next.finish > err.finish ? next : err;
                    }).error;
                }
              };

              if (isArray) {
                mapResponses = function mapResponses(r) {
                  return r.map(function (x) {
                    return x.response;
                  });
                };
              } else {
                keys = Object.keys(apiActions);

                mapActions = function mapActions(a) {
                  return keys.map(function (k) {
                    return a[k];
                  });
                };

                mapResponses = function mapResponses(r) {
                  return r.reduce(function (acc, val, i) {
                    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, keys[i], val.response));
                  }, {});
                };
              }

              mappedActions = mapActions(apiActions);
              requests = mappedActions.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(a) {
                  var r;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return dispatch(a);

                        case 2:
                          r = _context.sent;
                          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, r), {}, {
                            finish: Date.now()
                          }));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context2.next = 9;
              return Promise.all(requests);

            case 9:
              results = _context2.sent;
              errorResults = results.filter(function (x) {
                return !!x.error;
              });

              if (!(errorResults.length === 0)) {
                _context2.next = 14;
                break;
              }

              response = mapResponses(results);
              return _context2.abrupt("return", {
                success: true,
                response: response
              });

            case 14:
              error = mapErrors(errorResults);
              return _context2.abrupt("return", {
                success: false,
                error: error
              });

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for HTTP "GET" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {Object} `params` Optional, query string parameters to append to the request URL
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var apiGet = function apiGet(type, path) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2(_objectSpread2({}, options), {}, {
    type: type,
    method: ApiRequestMethod.GET,
    path: path,
    params: params
  }));
};
/**
 * Action creator for HTTP "POST" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var apiPost = function apiPost(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2(_objectSpread2({}, options), {}, {
    type: type,
    method: ApiRequestMethod.POST,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "PUT" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var apiPut = function apiPut(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2(_objectSpread2({}, options), {}, {
    type: type,
    method: ApiRequestMethod.PUT,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "PATCH" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var apiPatch = function apiPatch(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2(_objectSpread2({}, options), {}, {
    type: type,
    method: ApiRequestMethod.PATCH,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "DELETE" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var apiDelete = function apiDelete(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2(_objectSpread2({}, options), {}, {
    type: type,
    method: ApiRequestMethod.DELETE,
    path: path,
    body: body
  }));
};

// ajax lower-level action helpers
var AJAX_START = "AJAX_START";
var AJAX_SUCCESS = "AJAX_SUCCESS";
var AJAX_ERROR = "AJAX_ERROR";
var AJAX_SLOW = "AJAX_SLOW";
var AJAX_RESET = "AJAX_RESET";
var AJAX_ABORT = "AJAX_ABORT";
// helper functions
var isAjaxStart = function isAjaxStart(action) {
  return action.subtype === AJAX_START;
};
var isAjaxSuccess = function isAjaxSuccess(action) {
  return action.subtype === AJAX_SUCCESS;
};
var isAjaxError = function isAjaxError(action) {
  return action.subtype === AJAX_ERROR;
};
var isAjaxSlow = function isAjaxSlow(action) {
  return action.subtype === AJAX_SLOW;
};
var isAjaxReset = function isAjaxReset(action) {
  return action.subtype === AJAX_RESET;
};
var isAjaxAbort = function isAjaxAbort(action) {
  return action.subtype === AJAX_ABORT;
};
var ajaxActionsFor = function ajaxActionsFor(type) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeout = null;
  return {
    reset: function reset() {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_RESET
      });
    },
    start: function start(request) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_START,
        sentAt: Date.now(),
        request: request
      });
    },
    slow: function slow(to) {
      return function (dispatch) {
        timeout = setTimeout(function () {
          dispatch(_objectSpread2(_objectSpread2({}, obj), {}, {
            type: type,
            subtype: AJAX_SLOW,
            slow: true
          }));
        }, to);
      };
    },
    success: function success(response) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_SUCCESS,
        receivedAt: Date.now(),
        response: response
      });
    },
    error: function error(_error) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_ERROR,
        receivedAt: Date.now(),
        error: _error
      });
    },
    abort: function abort(reason) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_ABORT,
        abortedAt: Date.now(),
        reason: reason
      });
    }
  };
};

/**
 * Returns a boolean to indicate whether an api request action is in progress
 * @param {object} `action` Reducer action to handle
 * @returns {boolean} True if the request is in progress, otherwise false
 */
var requestIsBusy = function requestIsBusy(action) {
  if (isAjaxStart(action) || isAjaxSlow(action)) return true;
  return false;
};
/**
 * Returns a boolean to indicate whether an api request is taking longer than expected
 * @param {object} `action` Reducer action to handle
 * @returns {boolean|null} True if a request is taking a long time, false if a request is not, or null if no request is in progress
 */

var requestIsSlow = function requestIsSlow(action) {
  if (isAjaxStart(action)) return false;
  if (isAjaxSlow(action)) return true;
  return null;
};
/**
 * Returns a boolean to indicate whether an api request was successful
 * @param {object} `action` Reducer action to handle
 * @returns {boolean|null} True if a request is successful, false if an error occurred, or null if a request is incomplete
 */

var requestIsSuccess = function requestIsSuccess(action) {
  if (isAjaxSuccess(action)) return true;
  if (isAjaxError(action)) return false;
  return null;
};
/**
 * Returns a boolean to indicate whether an api request was aborted
 * @param {object} `action` Reducer action to handle
 * @returns {boolean} True if the request has been aborted, otherwise false
 */

var requestIsAborted = function requestIsAborted(action) {
  if (isAjaxAbort(action)) return true;
  return false;
};
/**
 * Returns the response for a successful api request
 * @param {object} `action` Reducer action to handle
 * @returns {*} Returns the response from a request, or null if a request is incomplete or failed
 */

var requestResponse = function requestResponse(action) {
  if (isAjaxSuccess(action)) return action.response;
  return null;
};
/**
 * Returns the error for a failed api request
 * @param {object} `action` Reducer action to handle
 * @returns {*} Returns the error from a request, or null if a request is incomplete or successful
 */

var requestError = function requestError(action) {
  if (isAjaxError(action)) return action.error;
  return null;
};
/**
 * Returns a boolean to indicate whether a failed api request contained one or more error codes
 * @param {object} `action` Reducer action to handle
 * @param {number|number[]} `code` code or codes
 * @returns {boolean|null} Returns true if a failed request contains the code(s), false if it does not, or null if a request is incomplete or successful
 */

var requestErrorHasCode = function requestErrorHasCode(action, code) {
  if (isAjaxError(action)) {
    if (!action.error || !Array.isArray(action.error.response)) return false;
    var codes = Array.isArray(code) ? code : [code];
    return !!action.error.response.find(function (e) {
      return e.code !== undefined && ~codes.indexOf(e.code);
    });
  }

  return null;
};
/**
 * Returns a numeric status value that corresponds to the AjaxStatus type
 * @param {object} `action` Reducer action to handle
 * @returns {number} AjaxStatus type
 */

var requestStatus = function requestStatus(action) {
  if (isAjaxSuccess(action)) return AjaxStatus.Success;
  if (isAjaxError(action)) return AjaxStatus.Error;
  if (isAjaxStart(action) || isAjaxSlow(action)) return AjaxStatus.Loading;
  return AjaxStatus.Ready;
};
/**
 * Returns the date an API request was sent
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was sent, or null if the request is complete
 */

var requestSentAt = function requestSentAt(action) {
  if (isAjaxStart(action)) return action.sentAt;
  return null;
};
/**
 * Returns the date an API request response was received
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was received, or null if the request is incomplete
 */

var requestReceivedAt = function requestReceivedAt(action) {
  if (isAjaxSuccess(action) || isAjaxError(action)) return action.receivedAt;
  return null;
};
/**
 * Returns the date an API request was aborted
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was aborted, or null if the request hasn't been aborted
 */

var requestAbortedAt = function requestAbortedAt(action) {
  if (isAjaxAbort(action)) return action.abortedAt;
  return null;
};

// mock request action
var MOCK_REQUEST = "MOCK_REQUEST";

/**
 * Generic action creator for mocking API requests
 * @param {Object} `options` Specification for the mock request
 * @param {string} `options.type` Redux action type
 * @param {boolean} `options.success` Whether the mock request should return a success (HTTP 200) response
 * @param {*} `options.response` The response data to return for a successful mock request
 * @param {*} `options.error` The error to return
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */
var mockRequest = function mockRequest(options) {
  return {
    type: MOCK_REQUEST,
    requestType: options.type,
    success: options.success,
    response: options.response,
    error: options.error,
    delay: options.delay !== undefined ? options.delay : 100,
    actionCustomData: options.actionCustomData,
    actionSlowDelay: options.actionSlowDelay !== undefined ? options.actionSlowDelay : 200,
    preventErrorNotification: options.preventErrorNotification || false,
    preventResponseHandling: options.preventResponseHandling || false,
    debounce: typeof options.debounce === "number" ? options.debounce : false,
    abort: options.abort
  };
};

/**
 * Action creator for mocking a successful api request
 * @param {string} `type` Redux action type
 * @param {Object} `options` Optional, additional options to pass to the request
 * @param {*} `options.response` The response data to return
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */
var mockSuccess = function mockSuccess(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var response = options.response,
      delay = options.delay,
      actionCustomData = options.actionCustomData,
      debounce = options.debounce,
      abort = options.abort;
  return mockRequest({
    type: type,
    success: true,
    response: response,
    delay: delay,
    actionCustomData: actionCustomData,
    debounce: debounce,
    abort: abort
  });
};

/**
 * Action creator for mocking an error api request
 * @param {string} `type` Redux action type
 * @param {Object} `options` Optional, additional options to pass to the request
 * @param {number} `options.code` Numeric code which correlates to the type of error returned
 * @param {string} `options.message` Error message to return
 * @param {string|Array} `options.data` Additional data which correlates to the error
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {boolean} `options.preventNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */
var mockError = function mockError(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var code = options.code,
      message = options.message,
      data = options.data,
      delay = options.delay,
      preventNotification = options.preventNotification,
      debounce = options.debounce,
      abort = options.abort;
  var error = code || message || data ? [{
    code: code,
    message: message,
    data: data
  }] : "";
  return mockRequest({
    type: type,
    success: false,
    error: error,
    delay: delay,
    preventErrorNotification: preventNotification,
    debounce: debounce,
    abort: abort
  });
};
// helper for mocking array data
var MockArrayData = function MockArrayData() {
  var _this = this;

  var initialData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortFunc = arguments.length > 1 ? arguments[1] : undefined;

  _classCallCheck(this, MockArrayData);

  _defineProperty(this, "_data", void 0);

  _defineProperty(this, "_sort", void 0);

  _defineProperty(this, "get", function () {
    var data = _toConsumableArray(_this._data);

    if (_this._sort) data.sort(_this._sort);
    return data;
  });

  _defineProperty(this, "getPaged", function (pageSize, pageNumber) {
    var data = _this.get();

    return {
      results: _this._paginate(data, pageSize, pageNumber),
      totalResults: data.length
    };
  });

  _defineProperty(this, "filter", function (func) {
    var data = _this._data.filter(func);

    if (_this._sort) data.sort(_this._sort);
    return data;
  });

  _defineProperty(this, "filterPaged", function (func, pageSize, pageNumber) {
    var data = _this.filter(func);

    return {
      results: _this._paginate(data, pageSize, pageNumber),
      totalResults: data.length
    };
  });

  _defineProperty(this, "_paginate", function (array, pageSize, pageNumber) {
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  });

  _defineProperty(this, "add", function (item) {
    _this._data = [].concat(_toConsumableArray(_this._data), [item]);
  });

  _defineProperty(this, "addMany", function (items) {
    _this._data = [].concat(_toConsumableArray(_this._data), _toConsumableArray(items));
  });

  _defineProperty(this, "remove", function (item) {
    var i = _this._data.indexOf(item);

    if (i >= 0) {
      _this._data.splice(i, 1);
    }
  });

  _defineProperty(this, "removeWhere", function (func) {
    var i = _this._data.length;

    while (i--) {
      if (func(_this._data[i], i, _this._data)) {
        _this._data.splice(i, 1);
      }
    }
  });

  _defineProperty(this, "replaceFirst", function (func, item) {
    var i = 0;

    while (i < _this._data.length) {
      if (func(_this._data[i], i, _this._data)) {
        _this._data.splice(i, 1, item);

        return true;
      }

      i++;
    }

    return false;
  });

  _defineProperty(this, "update", function (searchFunc, updateFunc) {
    var i = _this._data.length;
    var updated = false;

    while (i--) {
      if (searchFunc(_this._data[i], i, _this._data)) {
        var updatedItem = updateFunc(_this._data[i], i);

        _this._data.splice(i, 1, updatedItem);

        updated = true;
      }
    }

    return updated;
  });

  _defineProperty(this, "find", function (func) {
    return _this._data.find(func);
  });

  this._data = initialData;
  this._sort = sortFunc;
};

var defaultOptions$2 = {
  method: ApiRequestMethod.GET,
  lazy: true,
  autoNamePrefix: "USE_API_REQUEST/"
};
/**
 * A hook to trigger a generic API request
 * @param {object} `options` Specification for the API request
 * @param {string} `options.method` Request method type, e.g. GET, POST, PUT, DELETE
 * @param {string} `options.path` Combines the base project API URL with this route for the API endpoint
 * @param {string} `options.url` Use this instead of path to override the full URL for the API endpoint
 * @param {object} `options.params` Optional, query string parameters to append to the request URL
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {*} `options.body` Optional, the body of the request
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiRequest = function useApiRequest(options) {
  var _options = _objectSpread2(_objectSpread2({}, defaultOptions$2), options);

  var actionCreator = useRef();

  if (!actionCreator.current) {
    var type = createAutoName(_options.autoNamePrefix);

    actionCreator.current = function () {
      return apiRequest(_objectSpread2(_objectSpread2({}, _options), {}, {
        type: type
      }));
    };
  }

  return useApiAction(actionCreator.current, _options);
};

/**
 * A hook to trigger HTTP "GET" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {object} `params` Optional, query string parameters to append to the request URL
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default false
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiGet = function useApiGet(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2(_objectSpread2({
    lazy: false,
    autoNamePrefix: "USE_API_GET/"
  }, options), {}, {
    method: ApiRequestMethod.GET,
    path: path,
    params: params
  }));
};

/**
 * A hook to trigger HTTP "POST" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiPost = function useApiPost(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2(_objectSpread2({
    autoNamePrefix: "USE_API_POST/"
  }, options), {}, {
    method: ApiRequestMethod.POST,
    path: path,
    body: body
  }));
};

/**
 * A hook to trigger HTTP "PUT" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiPut = function useApiPut(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2(_objectSpread2({
    autoNamePrefix: "USE_API_PUT/"
  }, options), {}, {
    method: ApiRequestMethod.PUT,
    path: path,
    body: body
  }));
};

/**
 * A hook to trigger HTTP "PATCH" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiPatch = function useApiPatch(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2(_objectSpread2({
    autoNamePrefix: "USE_API_PATCH/"
  }, options), {}, {
    method: ApiRequestMethod.PATCH,
    path: path,
    body: body
  }));
};

/**
 * A hook to trigger HTTP "DELETE" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiDelete = function useApiDelete(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2(_objectSpread2({
    autoNamePrefix: "USE_API_DELETE/"
  }, options), {}, {
    method: ApiRequestMethod.DELETE,
    path: path,
    body: body
  }));
};

var defaultOptions$3 = {
  tokenKey: "",
  useEmailVerification: false,
  jwtClaims: {},
  // all options must be declared even if undefined
  onRefreshJwt: undefined,
  onAuthenticate: undefined,
  onAuthenticated: undefined,
  onDeauthenticate: undefined,
  onDeauthenticated: undefined
};
var jwtConfig = new ModuleConfig(defaultOptions$3);
var getTokenKey = function getTokenKey() {
  if (jwtConfig.isNullOrWhitespace("tokenKey")) console.error("tokenKey not configured for JWT auth module");
  return jwtConfig.get("tokenKey");
};
var getJwtClaims = function getJwtClaims() {
  return jwtConfig.get("jwtClaims");
};
var getOnRefreshJwt = function getOnRefreshJwt() {
  if (jwtConfig.isNullOrWhitespace("onRefreshJwt")) console.error("onRefreshJwt not configured for JWT auth module");
  return jwtConfig.get("onRefreshJwt");
};
var getOnAuthenticate = function getOnAuthenticate() {
  return jwtConfig.get("onAuthenticate");
};
var getOnAuthenticated = function getOnAuthenticated() {
  return jwtConfig.get("onAuthenticated");
};
var getOnDeauthenticate = function getOnDeauthenticate() {
  return jwtConfig.get("onDeauthenticate");
};
var getOnDeauthenticated = function getOnDeauthenticated() {
  return jwtConfig.get("onDeauthenticated");
};

var defaultOptions$4 = {
  environment: "default",
  release: "1.0",
  debug: false,
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  stateTransformer: function stateTransformer(state) {
    return state;
  }
};
var config$1 = new ModuleConfig(defaultOptions$4);
var loggers = {};
var getLoggingOptions = function getLoggingOptions() {
  return config$1.getAll();
};
/**
 * Configures options for the logging module
 * @param {object} `options` Options to set
 * @param {string} `options.environment` Environment name to tag tracking events with
 * @param {string} `options.release` Release version to tag tracking events with
 * @param {boolean} `options.debug` Enables debug console log messages when tracking events occur, default false
 * @param {function} `options.actionTransformer` Transform function to optimise Redux action data saved against tracking events
 * @param {function} `options.stateTransformer` Transform function to optimise Redux state data saved against tracking events
 */

var setLoggingOptions = function setLoggingOptions(options) {
  return config$1.setAll(options);
}; // integration functions

var loggerExists = function loggerExists(type) {
  return !!loggers[type];
};
var addLogger = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(createFunc) {
    var logger;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createFunc();

          case 2:
            logger = _context.sent;

            if (!(!logger || loggerExists(logger.type))) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            if (logger.initialize) {
              logger.initialize();
            }

            loggers[logger.type] = logger;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addLogger(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Configures and enables a custom logging integration
 * @param {object} `logger` Logger configuration
 * @param {string} `logger.type` Unique type for the logger
 * @param {function} `logger.initialize` Optional, initialization function
 * @param {function} `logger.getMiddleware` Optional, allows the logger to use its own Redux middleware
 * @param {function} `logger.logNavigation` Optional, callback when a navigation event is triggered
 * @param {function} `logger.logError` Optional, callback when an error event is triggered
 * @param {function} `logger.setUserIdentity` Optional, callback when the current user has changed
 * @param {function} `logger.clearUserIdentity` Optional, callback when there is no longer a current user
 */

var enableCustomLogger = function enableCustomLogger(logger) {
  return addLogger(function () {
    return Promise.resolve(logger);
  });
}; // internal logging functions

var processLoggers = function processLoggers(loggerFunc) {
  Object.keys(loggers).forEach(function (key) {
    return loggerFunc(loggers[key]);
  });
};
var isDebuggingLogging = function isDebuggingLogging() {
  return config$1.get("debug");
};

var LoggerType;

(function (LoggerType) {
  LoggerType["Sentry"] = "Sentry";
  LoggerType["Segment"] = "Segment";
  LoggerType["Hotjar"] = "Hotjar";
  LoggerType["GoogleAnalytics"] = "GoogleAnalytics";
})(LoggerType || (LoggerType = {}));

/**
 * Logs an error event
 * @param {string} `error` Error message
 * @param {object} `data` Additional data for tbe event
 */

var logError = function logError(error, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logError event:", error, data);
  }

  processLoggers(function (logger) {
    if (logger.logError) {
      logger.logError(error, data);
    }
  });
};
/**
 * Logs a navigation event
 * @param {string} `location` New location
 * @param {object} `data` Additional data for tbe event
 */

var logNavigation = function logNavigation(location, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logNavigation event:", location, data);
  }

  processLoggers(function (logger) {
    if (logger.logNavigation) {
      logger.logNavigation(location, data);
    }
  });
};
/**
 * Sets the current user for logged events
 * @param {string} `id` User ID
 * @param {object} `data` Additional data for the user
 */

var setUserIdentity = function setUserIdentity(id, data) {
  if (isDebuggingLogging()) {
    console.log("logging module setUserIdentity event:", id, data);
  }

  processLoggers(function (logger) {
    if (logger.setUserIdentity) {
      logger.setUserIdentity(id, data);
    }
  });
};
/**
 * Resets the current user for logged events
 */

var clearUserIdentity = function clearUserIdentity() {
  if (isDebuggingLogging()) {
    console.log("logging module clearUserIdentity event");
  }

  processLoggers(function (logger) {
    if (logger.clearUserIdentity) {
      logger.clearUserIdentity();
    }
  });
};

var JwtClaimType;

(function (JwtClaimType) {
  JwtClaimType["String"] = "string";
  JwtClaimType["Number"] = "number";
  JwtClaimType["Boolean"] = "boolean";
  JwtClaimType["Join"] = "join";
  JwtClaimType["Object"] = "object";
  JwtClaimType["Array"] = "array";
})(JwtClaimType || (JwtClaimType = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var base64 = createCommonjsModule(function (module, exports) {
(function(root) {

	// Detect free variables `exports`.
	var freeExports = exports;

	// Detect free variable `module`.
	var freeModule = module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(commonjsGlobal));
});

var JWTExpiry = /*#__PURE__*/function () {
  function JWTExpiry(expiry) {
    _classCallCheck(this, JWTExpiry);

    _defineProperty(this, "expiry", void 0);

    this.expiry = expiry;
  }

  _createClass(JWTExpiry, [{
    key: "hasExpired",
    value: function hasExpired() {
      // convert expiry from seconds to milliseconds
      return this.expiry * 1000 <= Date.now();
    }
  }, {
    key: "willExpireSoon",
    value: function willExpireSoon() {
      var thresholdInSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
      // convert expiry from seconds to milliseconds
      return (this.expiry - thresholdInSeconds) * 1000 <= Date.now();
    }
  }]);

  return JWTExpiry;
}();
var JWT = /*#__PURE__*/function () {
  function JWT(token) {
    _classCallCheck(this, JWT);

    _defineProperty(this, "payload", void 0);

    this.payload = {};
    var jwtArray = token.split(".");

    if (jwtArray.length > 1) {
      var payloadBase64 = jwtArray[1].replace("-", "+").replace("_", "/");
      this.payload = JSON.parse(this.decodePayloadUtf8(payloadBase64));
    }
  }

  _createClass(JWT, [{
    key: "decodePayloadUtf8",
    value: function decodePayloadUtf8(str) {
      return decodeURIComponent(Array.prototype.map.call(base64.decode(str), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }
  }, {
    key: "hasExpired",
    value: function hasExpired() {
      if (this.payload.exp !== undefined) {
        var expiry = new JWTExpiry(this.payload.exp);
        return expiry.hasExpired();
      }

      return true;
    }
  }, {
    key: "getExpiry",
    value: function getExpiry() {
      return this.payload.exp !== undefined ? this.payload.exp : 0;
    }
  }, {
    key: "getSubject",
    value: function getSubject() {
      return this.payload.sub !== undefined ? this.payload.sub : "";
    } // dynamic claim handling

  }, {
    key: "parseClaims",
    value: function parseClaims(config) {
      var _this = this;

      return Object.keys(config).reduce(function (acc, key) {
        var options = config[key];
        if (options) acc[key] = _this._getClaim(options);
        return acc;
      }, {});
    }
  }, {
    key: "parseIdentityClaims",
    value: function parseIdentityClaims(config) {
      var _this2 = this;

      return Object.keys(config).reduce(function (acc, key) {
        var options = config[key];

        if (options && options.identity) {
          acc[options.identity] = _this2._getClaim(options);
        }

        return acc;
      }, {});
    }
  }, {
    key: "_getClaim",
    value: function _getClaim(options) {
      var type = options.type,
          key = options.key,
          keys = options.keys,
          separator = options.separator;

      if (type === JwtClaimType.String && key) {
        return this._getClaimOrDefault(key, "");
      }

      if (type === JwtClaimType.Number && key) {
        return this._getClaimAsNumber(key);
      }

      if (type === JwtClaimType.Boolean && key) {
        return this._getClaimAsBoolean(key);
      }

      if (type === JwtClaimType.Join && keys && separator) {
        return this._getClaimsAsJoin(keys, separator);
      }

      if (type === JwtClaimType.Object && key) {
        return this._getClaimOrDefault(key, {});
      }

      if (type === JwtClaimType.Object && keys) {
        return this._getClaimsAsObject(keys);
      }

      if (type === JwtClaimType.Array && key) {
        return this._getClaimOrDefault(key, []);
      }

      if (type === JwtClaimType.Array && keys) {
        return this._getClaimsAsArray(keys);
      }

      return null;
    }
  }, {
    key: "_getClaimOrDefault",
    value: function _getClaimOrDefault(key, defaultValue) {
      if (this.payload.hasOwnProperty(key)) {
        return this.payload[key];
      }

      return defaultValue;
    }
  }, {
    key: "_getClaimAsNumber",
    value: function _getClaimAsNumber(key) {
      if (this.payload.hasOwnProperty(key)) {
        var val = this.payload[key];

        if (!Number.isNaN(val)) {
          return Number(val);
        }
      }

      return 0;
    }
  }, {
    key: "_getClaimAsBoolean",
    value: function _getClaimAsBoolean(key) {
      if (this.payload.hasOwnProperty(key)) {
        var val = this.payload[key];

        if (typeof val === "string") {
          return val.toLowerCase() === "true";
        }

        return val === true;
      }

      return false;
    }
  }, {
    key: "_getClaimsAsJoin",
    value: function _getClaimsAsJoin(keys, separator) {
      var _this3 = this;

      var claims = this._findClaimKeys(keys);

      if (claims.length > 0) {
        var claimValues = claims.map(function (key) {
          return _this3.payload[key];
        });
        return claimValues.join(separator);
      }

      return "";
    }
  }, {
    key: "_getClaimsAsObject",
    value: function _getClaimsAsObject(keys) {
      var claims = this._getClaimsAsArray(keys);

      return claims.reduce(function (acc, claim) {
        acc[claim.key] = claim.value;
        return acc;
      }, {});
    }
  }, {
    key: "_getClaimsAsArray",
    value: function _getClaimsAsArray(keys) {
      var _this4 = this;

      var searchKeys = typeof keys === "string" ? new RegExp(keys) : keys;

      var claims = this._findClaimKeys(searchKeys);

      if (claims.length > 0) {
        return claims.map(function (key) {
          var claimKey = key; // match first parantheses in keys pattern if specified

          if (searchKeys instanceof RegExp) {
            var match = key.match(searchKeys);

            if (match && match[1]) {
              claimKey = match[1];
            }
          }

          return {
            key: claimKey,
            value: _this4.payload[key]
          };
        });
      }

      return [];
    }
  }, {
    key: "_findClaimKeys",
    value: function _findClaimKeys(keys) {
      var jwt = this.payload;

      if (Array.isArray(keys)) {
        return keys.filter(function (k) {
          return jwt.hasOwnProperty(k);
        });
      }

      if (typeof keys === "string" || keys instanceof RegExp) {
        var allKeys = Object.keys(jwt);
        return allKeys.filter(function (k) {
          return k.match(keys);
        });
      }

      return [];
    }
  }]);

  return JWT;
}();

/**
 * Selects Redux state for auth data
 * @param {Object} `state` Redux state
 */
var getAuthState = function getAuthState(state) {
  return state.auth;
};
/**
 * Selects Redux state for parsed JWT claim data
 * @param {Object} `state` Redux state
 */

var getAuthClaims = function getAuthClaims(state) {
  var authState = getAuthState(state);
  return authState.claims || {};
};
/**
 * Finds the jwt claim value for the given claim key
 * @param {Object} `state` Redux state
 * @param {string} `key` Claim key to find
 */

var getAuthClaim = function getAuthClaim(state, key) {
  var claims = getAuthClaims(state);
  return claims[key];
};
/**
 * Returns the current JWT refresh token
 * @param {Object} `state` Redux state
 */

var getAuthRefreshToken = function getAuthRefreshToken(state) {
  var authState = getAuthState(state);
  return authState.refreshToken;
};

var refreshJwtAction = function refreshJwtAction(authenticate, deauthenticate, invalidate) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
        var auth, jwtExpiry, onRefreshJwt, refreshAction, _yield$dispatch, success, response, error;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                auth = getAuthState(getState());

                if (!(auth.accessToken && auth.refreshToken && auth.expiry)) {
                  _context.next = 32;
                  break;
                }

                jwtExpiry = new JWTExpiry(auth.expiry);

                if (!(invalidate || jwtExpiry.willExpireSoon())) {
                  _context.next = 28;
                  break;
                }

                // get the refresh api action to perform
                onRefreshJwt = getOnRefreshJwt();
                refreshAction = typeof onRefreshJwt === "function" ? onRefreshJwt(auth.refreshToken) : null;

                if (refreshAction) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return dispatch(deauthenticate());

              case 9:
                reject("Unable to refresh JWT");
                return _context.abrupt("return");

              case 11:
                _context.next = 13;
                return dispatch(refreshAction);

              case 13:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                response = _yield$dispatch.response;
                error = _yield$dispatch.error;

                if (!(success && response && response.tokens)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 20;
                return dispatch(authenticate(response.tokens.access, response.tokens.refresh));

              case 20:
                resolve(response.tokens.access);
                _context.next = 26;
                break;

              case 23:
                _context.next = 25;
                return dispatch(deauthenticate());

              case 25:
                reject(error);

              case 26:
                _context.next = 30;
                break;

              case 28:
                // valid
                resolve(auth.accessToken);

                if (auth.subject && auth.identity) {
                  setUserIdentity(auth.subject, auth.identity);
                }

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.next = 34;
                return dispatch(deauthenticate());

              case 34:
                reject("Unauthorised request");

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var refreshJwtPromise = concurrentPromise();
var refreshJwt = function refreshJwt(dispatch, authenticate, deauthenticate) {
  var invalidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return refreshJwtPromise(function () {
    return dispatch(refreshJwtAction(authenticate, deauthenticate, invalidate));
  });
};

var tokenStoreProvider = null;
var getTokenStoreProvider = function getTokenStoreProvider() {
  return tokenStoreProvider;
};
var setTokenStoreProvider = function setTokenStoreProvider(provider) {
  if (_typeof(provider) === "object") {
    tokenStoreProvider = provider;
  } else {
    console.warn("Unable to set default token store provider, provider is invalid");
  }
};

var accessTokenKey = function accessTokenKey() {
  return "".concat(getTokenKey(), "-access");
};

var refreshTokenKey = function refreshTokenKey() {
  return "".concat(getTokenKey(), "-refresh");
};

var storeToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, token) {
    var provider;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.storeToken(key, token);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function storeToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
    var provider;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context2.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.getToken(key);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var clearToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
    var provider;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context3.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.clearToken(key);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function clearToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var storeAccessToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(token) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return storeToken(accessTokenKey(), token);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function storeAccessToken(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
var storeRefreshToken = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(token) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return storeToken(refreshTokenKey(), token);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function storeRefreshToken(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
var getAccessToken = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getToken(accessTokenKey());

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getAccessToken() {
    return _ref6.apply(this, arguments);
  };
}();
var getRefreshToken = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getToken(refreshTokenKey());

          case 2:
            return _context7.abrupt("return", _context7.sent);

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getRefreshToken() {
    return _ref7.apply(this, arguments);
  };
}();
var clearAllTokens = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Promise.all([clearToken(accessTokenKey()), clearToken(refreshTokenKey())]);

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function clearAllTokens() {
    return _ref8.apply(this, arguments);
  };
}();

var onApiRequest = function onApiRequest(store, action, authenticate, deauthenticate) {
  if (action.auth === true) {
    return refreshJwt(store.dispatch, authenticate, deauthenticate, false).then(function (token) {
      return Promise.resolve({
        auth: "Bearer " + token
      });
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else if (typeof action.auth === "string") {
    // legacy support to override 'Authorization' header
    return Promise.resolve({
      auth: action.auth
    });
  }

  return Promise.resolve({});
};
var onAuthenticate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, accessToken, refreshToken) {
    var authAction, jwt, config, identityClaims;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authAction = getOnAuthenticate();

            if (!authAction) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return dispatch(authAction(accessToken, refreshToken));

          case 4:
            _context.next = 6;
            return storeAccessToken(accessToken);

          case 6:
            _context.next = 8;
            return storeRefreshToken(refreshToken);

          case 8:
            jwt = accessToken ? new JWT(accessToken) : null;

            if (jwt) {
              config = getJwtClaims();
              identityClaims = jwt.parseIdentityClaims(config);
              setUserIdentity(jwt.getSubject(), identityClaims);
            }

            return _context.abrupt("return", {
              accessToken: accessToken,
              refreshToken: refreshToken,
              jwt: jwt
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onAuthenticate(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var onAuthenticated = function onAuthenticated(dispatch, result) {
  var authAction = getOnAuthenticated();
  if (authAction) dispatch(authAction(result));
};
var onDeauthenticate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
    var deauthAction;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            deauthAction = getOnDeauthenticate();

            if (!deauthAction) {
              _context2.next = 4;
              break;
            }

            _context2.next = 4;
            return dispatch(deauthAction());

          case 4:
            _context2.next = 6;
            return clearAllTokens();

          case 6:
            clearUserIdentity();

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function onDeauthenticate(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
var onDeauthenticated = function onDeauthenticated(dispatch) {
  var deauthAction = getOnDeauthenticated();
  if (deauthAction) dispatch(deauthAction());
};
var onMapAuthenticatedState = function onMapAuthenticatedState(result) {
  var jwt = result.jwt;
  var config = getJwtClaims();
  return {
    loggedIn: jwt != null,
    accessToken: result.accessToken,
    refreshToken: result.refreshToken,
    expiry: jwt ? jwt.getExpiry() : null,
    subject: jwt ? jwt.getSubject() : null,
    claims: jwt ? jwt.parseClaims(config) : {},
    identity: jwt ? jwt.parseIdentityClaims(config) : {}
  };
};
var onMapDeauthenticatedState = function onMapDeauthenticatedState() {
  return {
    loggedIn: false,
    accessToken: null,
    refreshToken: null,
    expiry: null,
    subject: null,
    claims: {},
    identity: {}
  };
};
var onReauthenticate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, authenticate, deauthenticate) {
    var accessToken, refreshToken, jwt, config, identityClaims;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAccessToken();

          case 2:
            accessToken = _context3.sent;
            _context3.next = 5;
            return getRefreshToken();

          case 5:
            refreshToken = _context3.sent;
            jwt = accessToken ? new JWT(accessToken) : null;

            if (jwt) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return");

          case 9:
            config = getJwtClaims();
            identityClaims = jwt.parseIdentityClaims(config);
            setUserIdentity(jwt.getSubject(), identityClaims);
            _context3.next = 14;
            return dispatch(authenticate(accessToken, refreshToken));

          case 14:
            _context3.next = 16;
            return refreshJwt(dispatch, authenticate, deauthenticate, false);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function onReauthenticate(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var jwtAuth = new ModuleIntegration("JwtAuth", jwtConfig);
jwtAuth.addActions({
  refreshToken: refreshJwt
});
jwtAuth.addEvents({
  onApiRequest: onApiRequest,
  onAuthenticate: onAuthenticate,
  onAuthenticated: onAuthenticated,
  onDeauthenticate: onDeauthenticate,
  onDeauthenticated: onDeauthenticated,
  onMapAuthenticatedState: onMapAuthenticatedState,
  onMapDeauthenticatedState: onMapDeauthenticatedState,
  onReauthenticate: onReauthenticate
});

var index = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': jwtAuth,
get JwtClaimType () { return JwtClaimType; }
});

var integrations = new ModuleIntegrationPipeline();
var getAuthIntegrations = function getAuthIntegrations() {
  return integrations;
};
var getJwtOptions = function getJwtOptions() {
  return jwtAuth.config.getAll();
};
var setJwtOptions = function setJwtOptions(options) {
  return jwtAuth.config.setAll(options);
};
/**
 * Configures options for the JWT token auth integration
 * @param {object} `options` Options to set
 * @param {string} `options.tokenKey` Unique key for this app for cookie and local storage of tokens
 * @param {boolean} `options.useEmailVerification` Whether to require email verification for authentication, default false
 * @param {object} `options.jwtClaims` Object describing claims to parse from JWT tokens
 * @param {function} `options.onRefreshJwt` API action creator that will be dispatched when a JWT token refresh is required, should return a new set of tokens
 * @param {function} `options.onAuthenticated` Optional, action creator that will be dispatched when a user has been successfully authenticated
 * @param {function} `options.onDeauthenticated` Optional, action creator that will be dispatched when a user has been deauthenticated
 * @param {boolean} `setDefault` Optional, if using multiple auth integrations whether to make this the default
 */

var enableJwtAuth = function enableJwtAuth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  integrations.add(jwtAuth, setDefault);
  jwtAuth.config.setAll(options);
};
/**
 * Configures a custom auth integration
 * @param {ModuleIntegration} `integration` Instance of the auth module integration
 * @param {boolean} `setDefault` Optional, if using multiple auth integrations whether to make this the default
 */

var enableCustomAuth = function enableCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  integrations.add(integration, setDefault);
}; // --- legacy methods ---

/**
 * @deprecated replaced by getJwtOptions
 */

var getAuthOptions = function getAuthOptions() {
  return getJwtOptions();
};
/**
 * @deprecated replaced by enableJwtAuth
 */

var setAuthOptions = function setAuthOptions(options) {
  return enableJwtAuth(options);
};
/**
 * @deprecated replaced by enableJwtAuth
 */

var useJwtAuth = function useJwtAuth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return enableJwtAuth(options, setDefault);
};
/**
 * @deprecated replaced by enableCustomAuth
 */

var useCustomAuth = function useCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return enableCustomAuth(integration, setDefault);
};

var AuthIntegrationAction;

(function (AuthIntegrationAction) {
  AuthIntegrationAction["RefreshToken"] = "refreshToken";
})(AuthIntegrationAction || (AuthIntegrationAction = {}));

var AuthIntegrationEvent;

(function (AuthIntegrationEvent) {
  AuthIntegrationEvent["ApiRequest"] = "onApiRequest";
  AuthIntegrationEvent["Authenticate"] = "onAuthenticate";
  AuthIntegrationEvent["Deauthenticate"] = "onDeauthenticate";
  AuthIntegrationEvent["Authenticated"] = "onAuthenticated";
  AuthIntegrationEvent["Deauthenticated"] = "onDeauthenticated";
  AuthIntegrationEvent["MapAuthenticatedState"] = "onMapAuthenticatedState";
  AuthIntegrationEvent["MapDeauthenticatedState"] = "onMapDeauthenticatedState";
  AuthIntegrationEvent["Reauthenticate"] = "onReauthenticate";
  AuthIntegrationEvent["Restore"] = "onRestore";
})(AuthIntegrationEvent || (AuthIntegrationEvent = {}));

// (in future multiple auth integrations should be supported)

var integrations$1 = getAuthIntegrations(); // action types

var NAMESPACE$2 = "AUTH";
var AUTHENTICATE = "".concat(NAMESPACE$2, "/AUTHENTICATE");
var DEAUTHENTICATE = "".concat(NAMESPACE$2, "/DEAUTHENTICATE");

/**
 * Action creator for authenticating access to the app (using JWT tokens)
 * @param {string} `accessToken` JWT access token to be stored
 * @param {string} `refreshToken` JWT refresh token to be stored
 */
var authenticate = function authenticate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var integration, authEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              authEvent = integration.findEvent(AuthIntegrationEvent.Authenticate);

              if (authEvent) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return authEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t0 = {};

            case 11:
              result = _context.t0;
              dispatch({
                type: AUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Authenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for deauthenticating access to the app (using JWT tokens)
 */

var deauthenticate = function deauthenticate() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var integration, deauthEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              deauthEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticate);

              if (deauthEvent) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return deauthEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 11;
                break;
              }

              _context2.t0 = {};

            case 11:
              result = _context2.t0;
              dispatch({
                type: DEAUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for ensuring the current JWT token is still valid and refreshing if required
 * @param {boolean} `invalidate` Whether the existing token should be invalidated, if true a new JWT token will always be requested, otherwise a new token will only be obtained if the current one has expired, default true
 * @returns {string} Returns a promise that when resolved gives the current JWT token
 */

var refreshJwt$1 = function refreshJwt() {
  var invalidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch) {
    var refreshAction = jwtAuth.findAction(AuthIntegrationAction.RefreshToken);
    if (!refreshAction) return;
    return refreshAction(dispatch, authenticate, deauthenticate, invalidate);
  };
};
var reauthenticate = function reauthenticate() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var integration, restoreEvent, restoreSuccess, reauthenticateEvent;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              // legacy support for OnRestore event
              restoreEvent = integration.findEvent(AuthIntegrationEvent.Restore);

              if (!restoreEvent) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return restoreEvent(dispatch, authenticate, deauthenticate);

            case 7:
              restoreSuccess = _context3.sent;

              if (restoreSuccess) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return");

            case 10:
              reauthenticateEvent = integration.findEvent(AuthIntegrationEvent.Reauthenticate);

              if (reauthenticateEvent) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return");

            case 13:
              _context3.next = 15;
              return reauthenticateEvent.apply(void 0, [dispatch, authenticate, deauthenticate].concat(args));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var actions = /*#__PURE__*/Object.freeze({
__proto__: null,
AUTHENTICATE: AUTHENTICATE,
DEAUTHENTICATE: DEAUTHENTICATE,
authenticate: authenticate,
deauthenticate: deauthenticate,
refreshJwt: refreshJwt$1,
reauthenticate: reauthenticate
});

// currently only a single 'default' integration can be used
// (in future multiple auth integrations should be supported)
var integrations$2 = getAuthIntegrations();
var onApiRequest$1 = function onApiRequest(store, action) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.ApiRequest);
    if (event) return event(store, action, authenticate, deauthenticate);
  }

  return Promise.resolve({});
};
var onMapAuthenticatedState$1 = function onMapAuthenticatedState(result) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapAuthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: true
  };
};
var onMapDeauthenticatedState$1 = function onMapDeauthenticatedState(result) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapDeauthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: false
  };
};

var events = /*#__PURE__*/Object.freeze({
__proto__: null,
onApiRequest: onApiRequest$1,
onMapAuthenticatedState: onMapAuthenticatedState$1,
onMapDeauthenticatedState: onMapDeauthenticatedState$1
});

/**
 * A hook to return Redux state for parsed JWT claim data
 * @returns {object} JWT claim data
 */

var useAuthClaims = function useAuthClaims() {
  return useSelector(getAuthClaims);
};

/**
 * Wrapper component that will only render its children when authorisation claim conditions are met
 */
var ClaimCheck = function ClaimCheck(props) {
  var claim = props.claim,
      value = props.value,
      renderFailure = props.renderFailure,
      children = props.children;

  var _useAuthClaims = useAuthClaims(),
      claimData = _useAuthClaims[claim];

  var _ref = getAuthOptions().jwtClaims || {},
      claimOptions = _ref[claim];

  var claimWarning = useRef(false);

  if (!claimOptions && !claimWarning.current) {
    console.warn("".concat(claim, " does not exist in claim options for ClaimCheck"));
    claimWarning.current = true;
  }

  if (!claimData || !claimOptions) return null;
  var valid = false;
  var testValue = Array.isArray(value) ? value : [value];
  valid = testValue.every(function (test) {
    // custom value check callback
    if (typeof test === "function") {
      return test(claimData);
    } // for objects/arrays check key/values, otherwise direct value comparison


    if (claimOptions.type === "object") {
      return claimData.hasOwnProperty(test.key) && claimData[test.key] === test.value;
    }

    if (claimOptions.type === "array") {
      return claimData.some(function (x) {
        return x.key === test.key && x.value === test.value;
      });
    }

    return claimData === test;
  });

  if (!valid) {
    return renderFailure ? renderFailure() : null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};
});

unwrapExports(reactIs_production_min);
reactIs_production_min.typeOf;
reactIs_production_min.AsyncMode;
reactIs_production_min.ConcurrentMode;
reactIs_production_min.ContextConsumer;
reactIs_production_min.ContextProvider;
reactIs_production_min.Element;
reactIs_production_min.ForwardRef;
reactIs_production_min.Fragment;
reactIs_production_min.Lazy;
reactIs_production_min.Memo;
reactIs_production_min.Portal;
reactIs_production_min.Profiler;
reactIs_production_min.StrictMode;
reactIs_production_min.Suspense;
reactIs_production_min.isValidElementType;
reactIs_production_min.isAsyncMode;
reactIs_production_min.isConcurrentMode;
reactIs_production_min.isContextConsumer;
reactIs_production_min.isContextProvider;
reactIs_production_min.isElement;
reactIs_production_min.isForwardRef;
reactIs_production_min.isFragment;
reactIs_production_min.isLazy;
reactIs_production_min.isMemo;
reactIs_production_min.isPortal;
reactIs_production_min.isProfiler;
reactIs_production_min.isStrictMode;
reactIs_production_min.isSuspense;

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
// TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
reactIs_development.typeOf;
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isValidElementType;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var DefaultAuthLoadable = function DefaultAuthLoadable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

DefaultAuthLoadable.propTypes = {
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any,
  fluid: propTypes.bool
};
var authLoadable = DefaultAuthLoadable;
var getDefaultAuthLoadable = function getDefaultAuthLoadable() {
  return authLoadable;
};
var setDefaultAuthLoadable = function setDefaultAuthLoadable(component) {
  if (typeof component === "function") {
    authLoadable = component;
  } else {
    console.warn("Unable to set default auth loadable, component is invalid");
  }
};

/**
 * A hook to return Redux state for auth data
 * @returns {object} Auth data
 * @returns {boolean} `loggedIn` Whether the current user is logged in
 * @returns {string} `accessToken` JWT access token (when logged in using JWT authentication)
 * @returns {string} `refreshToken` JWT refresh token (when logged in using JWT authentication)
 * @returns {number} `expiry` JWT expiry date (when logged in using JWT authentication)
 * @returns {string} `subject` JWT subject claim (when logged in using JWT authentication)
 * @returns {object} `claims` JWT claim data (when logged in using JWT authentication)
 * @returns {object} `identity` JWT data for claims with an 'identity' tag (when logged in using JWT authentication)
 */

var useAuthState = function useAuthState() {
  return useSelector(getAuthState);
};

/**
 * A hook to return the authenticated status of the current user
 * @returns {boolean} Whether the current user is logged in
 */

var useLoggedIn = function useLoggedIn() {
  var _useAuthState = useAuthState(),
      loggedIn = _useAuthState.loggedIn;

  return loggedIn;
};

/**
 * High level wrapper component that forces a JWT refresh if not logged in
 * and will only render its children if logged in
 */
var AuthenticatedApp = function AuthenticatedApp(props) {
  var loggedIn = useLoggedIn();
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasAttemptedReauthentication = _useState2[0],
      sethasAttemptedReauthentication = _useState2[1];

  useEffect(function () {
    var attemptReauthenticate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (loggedIn) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return dispatch(reauthenticate());

              case 3:
                sethasAttemptedReauthentication(true);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function attemptReauthenticate() {
        return _ref.apply(this, arguments);
      };
    }();

    attemptReauthenticate();
  }, []);
  var LoadableComponent = props.loadable || getDefaultAuthLoadable();
  return hasAttemptedReauthentication ? /*#__PURE__*/React.createElement(React.Fragment, null, props.children) : /*#__PURE__*/React.createElement(LoadableComponent, {
    fluid: true,
    loading: true
  });
};

var DefaultBuilderLoadable = function DefaultBuilderLoadable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

DefaultBuilderLoadable.propTypes = {
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any
};
var builderLoadable = DefaultBuilderLoadable;
var getDefaultBuilderLoadable = function getDefaultBuilderLoadable() {
  return builderLoadable;
};
var setDefaultBuilderLoadable = function setDefaultBuilderLoadable(component) {
  if (typeof component === "function") {
    builderLoadable = component;
  } else {
    console.warn("Unable to set default builder loadable, component is invalid");
  }
};

var ContentBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentBase, _React$Component);

  var _super = _createSuper(ContentBase);

  function ContentBase(_props) {
    var _this;

    _classCallCheck(this, ContentBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props) {
      var resetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetData ? _this.defaultDataState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _data, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;

              if (onLoad) {
                _data = onLoad(loadParams);

                _this.setState({
                  data: _data
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultResetState(_this.props);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      var defaultState = _this.defaultResetState(_this.props, false);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass(ContentBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          error = _this$state.error,
          data = _this$state.data;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ContentBase;
}(React.Component);

_defineProperty(ContentBase, "propTypes", {
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  render: propTypes.func.isRequired,
  dispatch: propTypes.any.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase = function connectBase() {
  return connect$1(null, mapDispatchToProps)(ContentBase);
};

var ContentBaseComponent = connectBase();
var ContentBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(ContentBaseComponent, props);
});

var FormBuilderResetStateType;

(function (FormBuilderResetStateType) {
  FormBuilderResetStateType["Data"] = "data";
  FormBuilderResetStateType["ReadOnly"] = "readOnly";
})(FormBuilderResetStateType || (FormBuilderResetStateType = {}));

var ListBuilderResetStateType;

(function (ListBuilderResetStateType) {
  ListBuilderResetStateType["Data"] = "data";
  ListBuilderResetStateType["Filters"] = "filters";
  ListBuilderResetStateType["Pagination"] = "pagination";
  ListBuilderResetStateType["Selection"] = "selection";
})(ListBuilderResetStateType || (ListBuilderResetStateType = {}));

var ALL_FORM_RESET_OPTIONS = [FormBuilderResetStateType.Data, FormBuilderResetStateType.ReadOnly];

var FormBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBase, _React$Component);

  var _super = _createSuper(FormBase);

  function FormBase(_props) {
    var _this;

    _classCallCheck(this, FormBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        formData: props.value || props.initialData,
        readOnlyData: props.value || props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultReadOnlyState", function (props) {
      return {
        readOnly: !!props.initialReadOnly
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, _this.defaultCommonState()), _this.defaultDataState(props)), _this.defaultReadOnlyState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetOptions.includes(FormBuilderResetStateType.Data) ? _this.defaultDataState(props) : {}), resetOptions.includes(FormBuilderResetStateType.ReadOnly) ? _this.defaultReadOnlyState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_FORM_RESET_OPTIONS;
      return _typeof(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          value = _this$props.value,
          loadParams = _this$props.loadParams;

      if (value && value !== prevProps.value) {
        _this.setState({
          formData: value
        });
      }

      if (!compareParams(loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _formData, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;

              if (onLoad) {
                _formData = onLoad(loadParams);

                _this.setState({
                  formData: _formData,
                  readOnlyData: _formData
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  formData: loadResponse,
                  readOnlyData: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onFormChange", function (field, data, applyChanges) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state.formData);
        }
      };

      _this.setState(function (state) {
        return {
          formData: applyChanges(state.formData),
          dirty: true
        };
      }, onStateUpdated);
    });

    _defineProperty(_assertThisInitialized(_this), "onFormValidated", function (formValid) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onValidated) {
          _this.props.onValidated(formValid);
        }
      };

      _this.setState({
        formValid: formValid
      }, onStateUpdated);
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options) {
        var _this$props3, submitAction, _submitParams, submitSlowDelay, onSubmit, onSubmitted, loadAction, _loadParams, loadTransform, onLoad, onLoaded, reloadOnSubmit, _dispatch, slowTimeout, _submitResponse, submittingAction, _yield$_dispatch, success, error, response, reloadOption, resetOptions, resetState, defaultState, _formData2, _loadResponse, loadingKey, loadingAction, _yield$_dispatch2, _success, _error, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.formValid) {
                  _context2.next = 4;
                  break;
                }

                _this.setState({
                  showErrors: true
                });

                _context2.next = 59;
                break;

              case 4:
                _this$props3 = _this.props, submitAction = _this$props3.submitAction, _submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, loadAction = _this$props3.loadAction, _loadParams = _this$props3.loadParams, loadTransform = _this$props3.loadTransform, onLoad = _this$props3.onLoad, onLoaded = _this$props3.onLoaded, reloadOnSubmit = _this$props3.reloadOnSubmit, _dispatch = _this$props3.dispatch;
                slowTimeout = null;

                if (onSubmit) {
                  onSubmit(_this.state.formData, _submitParams);
                }

                _submitResponse = undefined;

                if (!submitAction) {
                  _context2.next = 28;
                  break;
                }

                submittingAction = abortableApi(submitAction(_this.state.formData, _submitParams));

                _this.setState({
                  submittingAbort: submittingAction.abort,
                  submitting: true,
                  error: undefined
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 14;
                return _dispatch(submittingAction);

              case 14:
                _yield$_dispatch = _context2.sent;
                success = _yield$_dispatch.success;
                error = _yield$_dispatch.error;
                response = _yield$_dispatch.response;
                if (!loadAction || !_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 21;
                  break;
                }

                return _context2.abrupt("return");

              case 21:
                if (success) {
                  _context2.next = 26;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 26:
                _submitResponse = response;

                _this.setState({
                  readOnlyData: _this.state.formData
                });

              case 28:
                if (onSubmitted) onSubmitted(_submitResponse, _submitParams); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 31;
                  break;
                }

                return _context2.abrupt("return");

              case 31:
                reloadOption = _this.parseReloadOption(options, !!reloadOnSubmit); // for legacy compatibility

                resetOptions = _this.parseResetOptions(options, []);

                if (reloadOption) {
                  _context2.next = 40;
                  break;
                }

                if (!(resetOptions.length > 0)) {
                  _context2.next = 38;
                  break;
                }

                resetState = _this.defaultResetState(_this.props, resetOptions);

                _this.setState(function (prevState) {
                  return _objectSpread2(_objectSpread2({}, prevState), resetState);
                });

                return _context2.abrupt("return");

              case 38:
                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  dirty: false
                });

                return _context2.abrupt("return");

              case 40:
                // re-load the form with latest data
                defaultState = _this.defaultResetState(_this.props, resetOptions.length > 0 ? resetOptions : ALL_FORM_RESET_OPTIONS);

                if (onLoad) {
                  _formData2 = onLoad(_loadParams);

                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      formData: _formData2,
                      readOnlyData: _formData2
                    });
                  });
                }

                _loadResponse = undefined;

                if (!loadAction) {
                  _context2.next = 58;
                  break;
                }

                loadingKey = _this._loadingKey = Date.now();
                loadingAction = abortableApi(loadAction(_loadParams));
                _context2.next = 48;
                return _dispatch(loadingAction);

              case 48:
                _yield$_dispatch2 = _context2.sent;
                _success = _yield$_dispatch2.success;
                _error = _yield$_dispatch2.error;
                _response = _yield$_dispatch2.response;
                if (slowTimeout) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 55;
                  break;
                }

                return _context2.abrupt("return");

              case 55:
                if (!(loadingKey !== _this._loadingKey)) {
                  _context2.next = 57;
                  break;
                }

                return _context2.abrupt("return");

              case 57:
                if (!_success) {
                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      error: _error
                    });
                  });
                } else {
                  if (_response) {
                    _loadResponse = loadTransform(_response);
                  }

                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      formData: _loadResponse !== undefined ? _loadResponse : prevState.formData,
                      readOnlyData: _loadResponse !== undefined ? _loadResponse : prevState.readOnlyData
                    });
                  });
                }

              case 58:
                if (onLoaded) onLoaded(_loadResponse, _loadParams);

              case 59:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleReadOnly", function () {
      var _this$state = _this.state,
          readOnly = _this$state.readOnly,
          readOnlyData = _this$state.readOnlyData,
          formData = _this$state.formData;

      if (readOnly) {
        _this.setState({
          readOnly: false,
          readOnlyData: formData
        });
      } else {
        // revert to data when previously read-only if known
        _this.setState({
          readOnly: true,
          formData: readOnlyData || formData
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass(FormBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          submitting = _this$state2.submitting,
          slowSubmitting = _this$state2.slowSubmitting,
          formData = _this$state2.formData,
          formValid = _this$state2.formValid,
          error = _this$state2.error,
          showErrors = _this$state2.showErrors,
          dirty = _this$state2.dirty,
          readOnly = _this$state2.readOnly;
      var formProps = {
        value: formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors && !readOnly,
        readOnly: readOnly
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        formValid: formValid,
        error: error,
        dirty: dirty,
        readOnly: readOnly
      };
      var events = {
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onToggleReadOnly: this.onToggleReadOnly,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(formProps, state, events);
    }
  }]);

  return FormBase;
}(React.Component);

_defineProperty(FormBase, "propTypes", {
  initialData: propTypes.any.isRequired,
  initialReadOnly: propTypes.bool.isRequired,
  value: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  reloadOnSubmit: propTypes.bool,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onChange: propTypes.func,
  onValidated: propTypes.func,
  render: propTypes.func.isRequired,
  abortSubmitOnUnmount: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$1 = function connectBase() {
  return connect$1(null, mapDispatchToProps$1)(FormBase);
};

var FormBaseComponent = connectBase$1();
var FormBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(FormBaseComponent, props);
});

var PreferenceSource;

(function (PreferenceSource) {
  PreferenceSource["None"] = "None";
  PreferenceSource["LocalStorage"] = "LocalStorage";
  PreferenceSource["Api"] = "Api";
})(PreferenceSource || (PreferenceSource = {}));

var source = PreferenceSource.None;
var options = {};
var defaults = {};
var getPreferenceSource = function getPreferenceSource() {
  return source;
};
var getPreferenceOptions = function getPreferenceOptions() {
  return _objectSpread2({}, options);
};
var getPreferenceDefaults = function getPreferenceDefaults() {
  return _objectSpread2({}, defaults);
};
/**
 * Sets default preference values that will be used initially, or when preferences are reset
 * @param {object} `values` Default values to set
 */

var setPreferenceDefaults = function setPreferenceDefaults(values) {
  defaults = _objectSpread2({}, values);
};
/**
 * Configures preferences to be saved and loaded from browser local storage
 * @param {string} `key` Local storage key for where to store the data
 */

var enablePreferencesFromLocalStorage = function enablePreferencesFromLocalStorage(key) {
  source = PreferenceSource.LocalStorage;
  options = {
    key: key
  };
};
/**
 * Configures preferences to be saved and loaded from an external API
 * @param {function} `loadAction` API action creator for loading preferences data
 * @param {function} `saveAction` API action creator for saving preferences data
 */

var enablePreferencesFromApi = function enablePreferencesFromApi(loadAction, saveAction) {
  source = PreferenceSource.Api;
  options = {
    loadAction: loadAction,
    saveAction: saveAction
  };
}; // --- legacy methods ---

/**
 * @deprecated replaced by enablePreferencesFromLocalStorage
 */

var usePreferencesFromLocalStorage = function usePreferencesFromLocalStorage(key) {
  return enablePreferencesFromLocalStorage(key);
};
/**
 * @deprecated replaced by enablePreferencesFromApi
 */

var usePreferencesFromApi = function usePreferencesFromApi(loadAction, saveAction) {
  return enablePreferencesFromApi(loadAction, saveAction);
};

var getPreferenceState = function getPreferenceState(state) {
  return state.preferences;
};
/**
 * Selects Redux state for a single preference value
 * @param {object} `state` Redux state
 * @param {string} `key` Preference key to find
 */

var getPreferenceValue = function getPreferenceValue(state, key) {
  var preferenceState = getPreferenceState(state);
  return preferenceState[key];
};

var UPDATE_PREFERENCE = "PREFERENCES/UPDATE";
var RESET_PREFERENCES = "PREFERENCES/RESET";
var LOAD_PREFERENCES = "PREFERENCES/LOAD";
/**
 * Action creator for updating a single preference value
 * @param {string} `key` Preference key to update
 * @param {*} `value` New preference value
 */

var updatePreference = function updatePreference(key, value) {
  return {
    type: UPDATE_PREFERENCE,
    key: key,
    value: value
  };
};
/**
 * Action creator for resetting all preferences to default values
 */

var resetPreferences = function resetPreferences() {
  return {
    type: RESET_PREFERENCES
  };
};

/**
 * Action creator to load preferences from previously saved data (if configured)
 */
var loadPreferences = function loadPreferences() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var source, options, value, data, _options, _yield$dispatch, success, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source = getPreferenceSource();
              _context.t0 = source;
              _context.next = _context.t0 === PreferenceSource.LocalStorage ? 4 : _context.t0 === PreferenceSource.Api ? 11 : 21;
              break;

            case 4:
              options = getPreferenceOptions();
              value = localStorage.getItem(options.key);

              if (!(value === null)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              data = JSON.parse(value);
              dispatch({
                type: LOAD_PREFERENCES,
                values: data
              });
              return _context.abrupt("return", true);

            case 11:
              _options = getPreferenceOptions();
              _context.next = 14;
              return dispatch(typeof _options.loadAction === "function" ? _options.loadAction() : _options.loadAction);

            case 14:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              response = _yield$dispatch.response;

              if (!(success && response)) {
                _context.next = 20;
                break;
              }

              dispatch({
                type: LOAD_PREFERENCES,
                values: response
              });
              return _context.abrupt("return", true);

            case 20:
              return _context.abrupt("return", false);

            case 21:
              console.error("loadPreferences not supported by the current preference source");
              return _context.abrupt("return", false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator to save preferences for re-loading later (if configured)
 */

var savePreferences = function savePreferences() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var source, state, options, _options2, _yield$dispatch2, success;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              source = getPreferenceSource();
              state = getPreferenceState(getState());
              _context2.t0 = source;
              _context2.next = _context2.t0 === PreferenceSource.LocalStorage ? 5 : _context2.t0 === PreferenceSource.Api ? 8 : 14;
              break;

            case 5:
              options = getPreferenceOptions();
              localStorage.setItem(options.key, JSON.stringify(state));
              return _context2.abrupt("return", true);

            case 8:
              _options2 = getPreferenceOptions();
              _context2.next = 11;
              return dispatch(_options2.saveAction(state));

            case 11:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              return _context2.abrupt("return", success);

            case 14:
              console.error("savePreferences not supported by the current preference source");
              return _context2.abrupt("return", false);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var RESET_LIST = "BUILDERS/RESET_LIST";
var CHANGE_FILTERS = "BUILDERS/CHANGE_FILTERS";
var CHANGE_PAGINATION = "BUILDERS/CHANGE_PAGINATION";
var CHANGE_SELECTION = "BUILDERS/CHANGE_SELECTION";
var CLEAR_STATE = "BUILDERS/CLEAR_STATE";
var resetList = function resetList(id, filters, pagination, selection) {
  return {
    type: RESET_LIST,
    id: id,
    filters: filters,
    pagination: pagination,
    selection: selection
  };
};
var changeFilters = function changeFilters(id, filters) {
  var resetPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: CHANGE_FILTERS,
    id: id,
    filters: filters,
    resetPage: resetPage
  };
};
var changePagination = function changePagination(id, pagination) {
  return {
    type: CHANGE_PAGINATION,
    id: id,
    pagination: pagination
  };
};
var changeSelection = function changeSelection(id, selection) {
  return {
    type: CHANGE_SELECTION,
    id: id,
    selection: selection
  };
};
var clearState = function clearState(id) {
  return {
    type: CLEAR_STATE,
    id: id
  };
};

var getBuilderState = function getBuilderState(state) {
  return state.builders;
};
var getBuilderData = function getBuilderData(state, id) {
  var builderState = getBuilderState(state);
  return builderState[id] || {};
};

var ALL_LIST_RESET_OPTIONS = [ListBuilderResetStateType.Data, ListBuilderResetStateType.Filters, ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection];

var ListBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ListBase, _React$Component);

  var _super = _createSuper(ListBase);

  function ListBase(_props) {
    var _this;

    _classCallCheck(this, ListBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData !== undefined && props.initialData !== null ? props.dataTransform(props.initialData) : [],
        total: props.initialData !== undefined && props.initialData !== null ? props.totalTransform(props.initialData) : 0,
        loading: false,
        slowLoading: false,
        loadingMore: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetOptions.includes(ListBuilderResetStateType.Data) ? _this.defaultDataState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "resetReduxState", function (props, resetOptions) {
      var resetList = props.resetList,
          filters = props.filters,
          pagination = props.pagination,
          selection = props.selection,
          initialFilterCalc = props.initialFilterCalc,
          initialPaginationCalc = props.initialPaginationCalc,
          initialSelectionCalc = props.initialSelectionCalc;
      resetList(resetOptions.includes(ListBuilderResetStateType.Filters) ? initialFilterCalc : filters, resetOptions.includes(ListBuilderResetStateType.Pagination) ? initialPaginationCalc : pagination, resetOptions.includes(ListBuilderResetStateType.Selection) ? initialSelectionCalc : selection);
    });

    _defineProperty(_assertThisInitialized(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_LIST_RESET_OPTIONS;
      return _typeof(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      _this.props.clearState();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, dataTransform, totalTransform, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, filters, pagination, selection, _data, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, dataTransform = _this$props.dataTransform, totalTransform = _this$props.totalTransform, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch, filters = _this$props.filters, pagination = _this$props.pagination, selection = _this$props.selection;

              if (onLoad) {
                _data = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: dataTransform(_data),
                  total: totalTransform(_data)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: dataTransform(loadResponse),
                  total: totalTransform(loadResponse)
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadMore", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props2, dataTransform, totalTransform, loadAction, loadParams, loadTransform, onLoad, onLoaded, dispatch, filters, selection, _this$state, data, total, prevPagination, pagination, response, loadResponse, loadingKey, loadingAction, _yield$dispatch2, success, error, _response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, dataTransform = _this$props2.dataTransform, totalTransform = _this$props2.totalTransform, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch, filters = _this$props2.filters, selection = _this$props2.selection; // work out pagination required to get more data

              _this$state = _this.state, data = _this$state.data, total = _this$state.total;

              if (!(data.length >= total)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              prevPagination = _this.props.pagination;
              pagination = _objectSpread2(_objectSpread2({}, prevPagination), {}, {
                pageNumber: (prevPagination.pageNumber || 0) + 1
              });

              _this.props.changePagination(pagination);

              if (onLoad) {
                response = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: [].concat(_toConsumableArray(data), _toConsumableArray(dataTransform(response))),
                  total: totalTransform(response)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context2.next = 25;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loadingMore: true,
                error: undefined
              });

              _context2.next = 16;
              return dispatch(loadingAction);

            case 16:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              _response = _yield$dispatch2.response;

              if (_this._isMounted) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return");

            case 22:
              if (!(loadingKey !== _this._loadingKey)) {
                _context2.next = 24;
                break;
              }

              return _context2.abrupt("return");

            case 24:
              if (!success || !_response) {
                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  error: error
                }); // revert state to allow retries


                _this.props.changePagination(prevPagination);
              } else {
                loadResponse = loadTransform(_response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  data: [].concat(_toConsumableArray(data), _toConsumableArray(dataTransform(loadResponse))),
                  total: totalTransform(loadResponse)
                });
              }

            case 25:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      _this.resetReduxState(_this.props, resetOptions);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: [ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeFilters", function (filters) {
      _this.props.changeFilters(filters);

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "onChangePagination", function (pagination) {
      _this.props.changePagination(pagination);

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeSelection", function (selection) {
      _this.props.changeSelection(selection);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    _this.onChangeFilters = debounce(_this.onChangeFilters, _props.debounceFilters);
    _this.onChangePagination = debounce(_this.onChangePagination, _props.debouncePagination);

    _this.resetReduxState(_props, ALL_LIST_RESET_OPTIONS);

    return _this;
  }

  _createClass(ListBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          loadingMore = _this$state2.loadingMore,
          error = _this$state2.error,
          data = _this$state2.data,
          total = _this$state2.total;
      var _this$props3 = this.props,
          filters = _this$props3.filters,
          pagination = _this$props3.pagination,
          selection = _this$props3.selection;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error,
        filters: filters,
        pagination: pagination,
        selection: selection,
        total: total,
        hasMore: data && data.length < total,
        loadingMore: loadingMore
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onChangeFilters: this.onChangeFilters,
        onChangePagination: this.onChangePagination,
        onChangeSelection: this.onChangeSelection,
        onLoadMore: this.loadMore,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ListBase;
}(React.Component);

_defineProperty(ListBase, "propTypes", {
  initialData: propTypes.any,
  initialFilters: propTypes.any.isRequired,
  initialPagination: propTypes.any.isRequired,
  initialSelection: propTypes.any.isRequired,
  dataTransform: propTypes.func.isRequired,
  totalTransform: propTypes.func.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  persistFilters: propTypes.string,
  debounceFilters: propTypes.number.isRequired,
  debouncePagination: propTypes.number.isRequired,
  render: propTypes.func.isRequired,
  id: propTypes.string.isRequired,
  initialFilterCalc: propTypes.any.isRequired,
  initialPaginationCalc: propTypes.any.isRequired,
  initialSelectionCalc: propTypes.any.isRequired,
  filters: propTypes.any.isRequired,
  pagination: propTypes.any.isRequired,
  selection: propTypes.any.isRequired,
  dispatch: propTypes.any.isRequired,
  resetList: propTypes.func.isRequired,
  changeFilters: propTypes.func.isRequired,
  changePagination: propTypes.func.isRequired,
  changeSelection: propTypes.func.isRequired,
  clearState: propTypes.func.isRequired
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var data = getBuilderData(state, ownProps.id);
  var preferenceFilters = ownProps.persistFilters ? getPreferenceValue(state, ownProps.persistFilters) : null;
  var initialFilterCalc = preferenceFilters || ownProps.initialFilters;
  var initialPaginationCalc = ownProps.initialPagination;
  var initialSelectionCalc = ownProps.initialSelection;
  return {
    initialFilterCalc: initialFilterCalc,
    initialPaginationCalc: initialPaginationCalc,
    initialSelectionCalc: initialSelectionCalc,
    filters: data.filters || initialFilterCalc,
    pagination: data.pagination || initialPaginationCalc,
    selection: data.selection || initialSelectionCalc
  };
};

var mapDispatchToProps$2 = function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch: dispatch,
    resetList: function resetList$1(filters, pagination, selection) {
      return dispatch(resetList(ownProps.id, filters, pagination, selection));
    },
    changeFilters: function changeFilters$1(filters) {
      dispatch(changeFilters(ownProps.id, filters));

      if (ownProps.persistFilters) {
        dispatch(updatePreference(ownProps.persistFilters, filters));
      }
    },
    changePagination: function changePagination$1(pagination) {
      return dispatch(changePagination(ownProps.id, pagination));
    },
    changeSelection: function changeSelection$1(selection) {
      return dispatch(changeSelection(ownProps.id, selection));
    },
    clearState: function clearState$1() {
      return dispatch(clearState(ownProps.id));
    }
  };
};

var connectBase$2 = function connectBase() {
  return connect$1(mapStateToProps, mapDispatchToProps$2)(ListBase);
};

var ListBaseComponent = connectBase$2();
var ListBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(ListBaseComponent, props);
});

var ModalFormBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalFormBase, _React$Component);

  var _super = _createSuper(ModalFormBase);

  function ModalFormBase(_props) {
    var _this;

    _classCallCheck(this, ModalFormBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        formData: props.initialData,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      if (_this.props.visible) {
        _this.loadData();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          loadParams = _this$props.loadParams;

      if (visible && !prevProps.visible) {
        var defaultState = _this.defaultState(_this.props);

        _this.setState(defaultState, _this.loadData);
      } else if (visible && !compareParams(loadParams, prevProps.loadParams)) {
        _this.onReset();
      } else if (!visible && prevProps.visible) {
        _this.onAbortLoad();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "preventErrorNotification", function () {
      var _getApiOptions = getApiOptions(),
          preventErrorNotification = _getApiOptions.preventErrorNotification;

      if (_this.props.preventErrorNotification) {
        setApiOptions({
          preventErrorNotification: true
        });
      }

      return preventErrorNotification;
    });

    _defineProperty(_assertThisInitialized(_this), "resetErrorNotification", function (preventErrorNotification) {
      setApiOptions({
        preventErrorNotification: preventErrorNotification
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _formData, loadResponse, loadingKey, loadingAction, slowTimeout, notification, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;

              if (onLoad) {
                _formData = onLoad(loadParams);

                _this.setState({
                  formData: _formData
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 23;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              notification = _this.preventErrorNotification();
              _context.next = 12;
              return dispatch(loadingAction);

            case 12:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  formData: loadResponse
                });
              }

            case 23:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onFormChange", function (field, data, applyChanges) {
      _this.setState(function (state) {
        return {
          formData: applyChanges(state.formData),
          dirty: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFormValidated", function (formValid) {
      return _this.setState({
        formValid: formValid
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, _submitParams, submitSlowDelay, onSubmit, onSubmitted, _dispatch, _submitResponse, submittingAction, slowTimeout, notification, _yield$_dispatch, success, error, response, defaultState;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.formValid) {
                _context2.next = 4;
                break;
              }

              _this.setState({
                showErrors: true
              });

              _context2.next = 31;
              break;

            case 4:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, _submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, _dispatch = _this$props3.dispatch;

              if (onSubmit) {
                onSubmit(_this.state.formData, _submitParams);
              }

              _submitResponse = undefined;

              if (!submitAction) {
                _context2.next = 30;
                break;
              }

              submittingAction = abortableApi(submitAction(_this.state.formData, _submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              notification = _this.preventErrorNotification();
              _context2.next = 14;
              return _dispatch(submittingAction);

            case 14:
              _yield$_dispatch = _context2.sent;
              success = _yield$_dispatch.success;
              error = _yield$_dispatch.error;
              response = _yield$_dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return");

            case 22:
              if (success) {
                _context2.next = 27;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 27:
              defaultState = _this.defaultState(_this.props);

              _this.setState(defaultState);

              _submitResponse = response;

            case 30:
              if (onSubmitted) onSubmitted(_submitResponse, _submitParams);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var _this$props4 = _this.props,
          onCancel = _this$props4.onCancel,
          onCancelled = _this$props4.onCancelled,
          abortSubmitOnCancel = _this$props4.abortSubmitOnCancel;

      if (onCancel) {
        var stop = onCancel();
        if (stop) return;
      }

      _this.onAbortLoad();

      if (abortSubmitOnCancel) _this.onAbortSubmit();
      if (onCancelled) onCancelled();
    });

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass(ModalFormBase, [{
    key: "render",
    value: function render() {
      if (!this.props.visible) return null;
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          formData = _this$state.formData,
          formValid = _this$state.formValid,
          error = _this$state.error,
          showErrors = _this$state.showErrors,
          dirty = _this$state.dirty;
      var modalProps = {
        open: true,
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit
      };
      var formProps = {
        value: formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        formValid: formValid,
        error: error,
        dirty: dirty
      };
      var events = {
        onReset: this.onReset,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(modalProps, formProps, state, events);
    }
  }]);

  return ModalFormBase;
}(React.Component);

_defineProperty(ModalFormBase, "propTypes", {
  visible: propTypes.bool.isRequired,
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  render: propTypes.func.isRequired,
  preventErrorNotification: propTypes.bool.isRequired,
  abortSubmitOnCancel: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$3 = function connectBase() {
  return connect$1(null, mapDispatchToProps$3)(ModalFormBase);
};

var ConnectedModalFormBase = connectBase$3();
var ModalFormBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(ConnectedModalFormBase, props);
});

var ModalBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBase, _React$Component);

  var _super = _createSuper(ModalBase);

  function ModalBase(_props) {
    var _this;

    _classCallCheck(this, ModalBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        data: props.initialData
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      if (_this.props.visible) {
        _this.loadData();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          loadParams = _this$props.loadParams;

      if (visible && !prevProps.visible) {
        var defaultState = _this.defaultState(_this.props);

        _this.setState(defaultState, _this.loadData);
      } else if (visible && !compareParams(loadParams, prevProps.loadParams)) {
        _this.onReset();
      } else if (!visible && prevProps.visible) {
        _this.onAbortLoad();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "preventErrorNotification", function () {
      var _getApiOptions = getApiOptions(),
          preventErrorNotification = _getApiOptions.preventErrorNotification;

      if (_this.props.preventErrorNotification) {
        setApiOptions({
          preventErrorNotification: true
        });
      }

      return preventErrorNotification;
    });

    _defineProperty(_assertThisInitialized(_this), "resetErrorNotification", function (preventErrorNotification) {
      setApiOptions({
        preventErrorNotification: preventErrorNotification
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, loadResponse, loadingKey, loadingAction, slowTimeout, notification, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;
              if (onLoad) onLoad(loadParams);
              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 23;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              notification = _this.preventErrorNotification();
              _context.next = 12;
              return dispatch(loadingAction);

            case 12:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: loadResponse
                });
              }

            case 23:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, submittingAction, slowTimeout, notification, _yield$dispatch2, success, error, response, defaultState;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, dispatch = _this$props3.dispatch;
              if (onSubmit) onSubmit(submitParams);
              submitResponse = undefined;

              if (!submitAction) {
                _context2.next = 26;
                break;
              }

              submittingAction = abortableApi(submitAction(submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              notification = _this.preventErrorNotification();
              _context2.next = 10;
              return dispatch(submittingAction);

            case 10:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              response = _yield$dispatch2.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return");

            case 18:
              if (success) {
                _context2.next = 23;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 23:
              defaultState = _this.defaultState(_this.props);

              _this.setState(defaultState);

              submitResponse = response;

            case 26:
              if (onSubmitted) onSubmitted(submitResponse, submitParams);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var _this$props4 = _this.props,
          onCancel = _this$props4.onCancel,
          onCancelled = _this$props4.onCancelled,
          abortSubmitOnCancel = _this$props4.abortSubmitOnCancel;

      if (onCancel) {
        var stop = onCancel();
        if (stop) return;
      }

      _this.onAbortLoad();

      if (abortSubmitOnCancel) _this.onAbortSubmit();
      if (onCancelled) onCancelled();
    });

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass(ModalBase, [{
    key: "render",
    value: function render() {
      if (!this.props.visible) return null;
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error,
          data = _this$state.data;
      var modalProps = {
        open: true,
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(modalProps, data, state, events);
    }
  }]);

  return ModalBase;
}(React.Component);

_defineProperty(ModalBase, "propTypes", {
  visible: propTypes.bool.isRequired,
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  render: propTypes.func.isRequired,
  preventErrorNotification: propTypes.bool.isRequired,
  abortSubmitOnCancel: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$4 = function connectBase() {
  return connect$1(null, mapDispatchToProps$4)(ModalBase);
};

var ConnectedModalBase = connectBase$4();
var ModalBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(ConnectedModalBase, props);
});

var TriggerBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TriggerBase, _React$Component);

  var _super = _createSuper(TriggerBase);

  function TriggerBase(props) {
    var _this;

    _classCallCheck(this, TriggerBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        submitting: false,
        slowSubmitting: false,
        success: false,
        error: undefined,
        data: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, data, submitResponse, submittingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, submitAction = _this$props.submitAction, submitParams = _this$props.submitParams, submitSlowDelay = _this$props.submitSlowDelay, onSubmit = _this$props.onSubmit, onSubmitted = _this$props.onSubmitted, dispatch = _this$props.dispatch;

              if (onSubmit) {
                data = onSubmit(submitParams);

                _this.setState({
                  success: true,
                  data: data
                });
              }

              submitResponse = undefined;

              if (!submitAction) {
                _context.next = 23;
                break;
              }

              submittingAction = abortableApi(submitAction(submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              _context.next = 9;
              return dispatch(submittingAction);

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              if (success) {
                _context.next = 21;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: false,
                error: error
              });

              return _context.abrupt("return");

            case 21:
              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: true,
                data: response
              });

              submitResponse = response;

            case 23:
              if (onSubmitted) onSubmitted(submitResponse, submitParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass(TriggerBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          success = _this$state.success,
          error = _this$state.error,
          data = _this$state.data;
      var fireTrigger = this.onSubmit;
      var state = {
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        success: success,
        error: error,
        data: data
      };
      var events = {
        onReset: this.onReset,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(fireTrigger, state, events);
    }
  }]);

  return TriggerBase;
}(React.Component);

_defineProperty(TriggerBase, "propTypes", {
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  render: propTypes.func.isRequired,
  abortSubmitOnUnmount: propTypes.bool.isRequired,
  dispatch: propTypes.any.isRequired
});

var mapDispatchToProps$5 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$5 = function connectBase() {
  return connect$1(null, mapDispatchToProps$5)(TriggerBase);
};

var TriggerBaseComponent = connectBase$5();
var TriggerBase$1 = (function (props) {
  return /*#__PURE__*/React.createElement(TriggerBaseComponent, props);
});

var WizardBaseContext = /*#__PURE__*/React.createContext({});

var WizardBase = /*#__PURE__*/function (_React$Component) {
  _inherits(WizardBase, _React$Component);

  var _super = _createSuper(WizardBase);

  function WizardBase(_props) {
    var _this;

    _classCallCheck(this, WizardBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null,
        steps: props.initialSteps,
        childContext: {
          getStepData: _this.getStepData,
          setStepData: _this.setStepData
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "mapDataToSteps", function (data, steps, dataKey) {
      var _this$props = _this.props,
          mapDataToSteps = _this$props.mapDataToSteps,
          initialSteps = _this$props.initialSteps; // component consumer override

      if (mapDataToSteps) return mapDataToSteps(data, steps, dataKey); // only data arrays currently supported

      if (!Array.isArray(data)) return steps; // default mapping implementations

      if (initialSteps.length > 0) {
        // append data when steps known
        return steps.map(function (s, i) {
          return data[i] ? _objectSpread2(_objectSpread2({}, s), {}, _defineProperty({}, dataKey, data[i])) : s;
        });
      } else {
        // use data for steps
        return _toConsumableArray(data);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getStepData", function (stepIndex) {
      var dataKey = _this.props.dataKey;
      var steps = _this.state.steps;
      var step = steps[stepIndex] || {};
      return step[dataKey];
    });

    _defineProperty(_assertThisInitialized(_this), "setStepData", function (stepIndex, data) {
      var dataKey = _this.props.dataKey;

      var steps = _toConsumableArray(_this.state.steps);

      if (stepIndex < 0 || stepIndex >= steps.length) return;
      steps[stepIndex] = _objectSpread2(_objectSpread2({}, steps[stepIndex]), {}, _defineProperty({}, dataKey, data));

      _this.setState({
        steps: steps
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onReset();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dataKey, dispatch, data, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadTransform = _this$props2.loadTransform, loadParams = _this$props2.loadParams, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dataKey = _this$props2.dataKey, dispatch = _this$props2.dispatch;

              if (onLoad) {
                data = onLoad(loadParams);

                _this.setState({
                  steps: _this.mapDataToSteps(data, _this.state.steps, dataKey)
                });
              }

              loadResponse = null;

              if (!loadAction) {
                _context.next = 19;
                break;
              }

              loadingKey = Date.now();

              _this.setState({
                loadingKey: loadingKey,
                loading: true,
                error: null
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 9;
              return dispatch(loadAction(loadParams));

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              if (!(loadingKey !== _this.state.loadingKey)) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!success) {
                _this.setState({
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loading: false,
                  slowLoading: false,
                  steps: _this.mapDataToSteps(loadResponse, _this.state.steps, dataKey)
                });
              }

            case 19:
              if (onLoaded) {
                onLoaded(loadResponse, loadParams);
              }

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, steps, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, dispatch = _this$props3.dispatch;
              steps = _this.state.steps;

              if (onSubmit) {
                onSubmit(steps, submitParams);
              }

              submitResponse = null;

              if (!submitAction) {
                _context2.next = 23;
                break;
              }

              _this.setState({
                submitting: true,
                error: null
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              _context2.next = 9;
              return dispatch(submitAction(steps, submitParams));

            case 9:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              response = _yield$dispatch2.response;
              // prevent state changes after unmounting
              if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return");

            case 16:
              if (success) {
                _context2.next = 21;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 21:
              submitResponse = response;

              _this.setState({
                submitting: false,
                slowSubmitting: false
              });

            case 23:
              if (onSubmitted) onSubmitted(submitResponse, submitParams, steps);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass(WizardBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error,
          steps = _this$state.steps,
          childContext = _this$state.childContext;
      var wizardProps = {
        steps: steps
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onSubmit: this.onSubmit
      };
      return /*#__PURE__*/React.createElement(WizardBaseContext.Provider, {
        value: childContext
      }, this.props.render(wizardProps, state, events));
    }
  }]);

  return WizardBase;
}(React.Component);

_defineProperty(WizardBase, "propTypes", {
  initialSteps: propTypes.arrayOf(propTypes.object),
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  dataKey: propTypes.string,
  mapDataToSteps: propTypes.func,
  render: propTypes.func.isRequired
});

_defineProperty(WizardBase, "defaultProps", {
  initialSteps: [],
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  dataKey: "data"
});

var mapDispatchToProps$6 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardBase$1 = connect$1(null, mapDispatchToProps$6)(WizardBase);

var WizardStepBase = /*#__PURE__*/function (_React$Component) {
  _inherits(WizardStepBase, _React$Component);

  var _super = _createSuper(WizardStepBase);

  function WizardStepBase(props) {
    var _this;

    _classCallCheck(this, WizardStepBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_stepIndex", null);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "getData", function () {
      var getStepData = _this.context.getStepData;
      if (!getStepData || _this._stepIndex === null) return null;
      return getStepData(_this._stepIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "setData", function (data) {
      var setStepData = _this.context.setStepData;
      if (!setStepData || _this._stepIndex === null) return;
      setStepData(_this._stepIndex, data);
    });

    _defineProperty(_assertThisInitialized(_this), "onActivate", function (newStepIndex) {
      _this._stepIndex = newStepIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "onDeactivate", function () {
      _this._stepIndex = null;
    });

    _defineProperty(_assertThisInitialized(_this), "onLoad", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stepIndex, step) {
        var _this$props, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dispatch, data, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, loadAction = _this$props.loadAction, loadTransform = _this$props.loadTransform, loadParams = _this$props.loadParams, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;
                _this._stepIndex = stepIndex;

                if (onLoad) {
                  data = onLoad(loadParams);

                  _this.setData(data);
                }

                loadResponse = null;

                if (!loadAction) {
                  _context.next = 20;
                  break;
                }

                loadingKey = Date.now();

                _this.setState({
                  loadingKey: loadingKey,
                  loading: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowLoading: true
                  });
                }, loadSlowDelay);
                _context.next = 10;
                return dispatch(loadAction(loadParams));

              case 10:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                error = _yield$dispatch.error;
                response = _yield$dispatch.response;
                clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                if (!(loadingKey !== _this.state.loadingKey)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return");

              case 19:
                if (!success) {
                  _this.setState({
                    loading: false,
                    slowLoading: false,
                    error: error
                  });
                } else {
                  loadResponse = loadTransform(response);

                  _this.setState({
                    loading: false,
                    slowLoading: false
                  });

                  _this.setData(loadResponse);
                }

              case 20:
                if (onLoaded) {
                  onLoaded(loadResponse, loadParams);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(stepIndex, step) {
        var _this$props2, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, submitAction = _this$props2.submitAction, submitParams = _this$props2.submitParams, submitSlowDelay = _this$props2.submitSlowDelay, onSubmit = _this$props2.onSubmit, onSubmitted = _this$props2.onSubmitted, dispatch = _this$props2.dispatch;

                if (onSubmit) {
                  onSubmit(step, submitParams);
                }

                submitResponse = null;

                if (!submitAction) {
                  _context2.next = 22;
                  break;
                }

                _this.setState({
                  submitting: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 8;
                return dispatch(submitAction(step, submitParams));

              case 8:
                _yield$dispatch2 = _context2.sent;
                success = _yield$dispatch2.success;
                error = _yield$dispatch2.error;
                response = _yield$dispatch2.response;
                // prevent state changes after unmounting
                if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                if (success) {
                  _context2.next = 20;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 20:
                submitResponse = response;

                _this.setState({
                  submitting: false,
                  slowSubmitting: false
                });

              case 22:
                if (onSubmitted) {
                  onSubmitted(submitResponse, submitParams, step);
                }

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass(WizardStepBase, [{
    key: "data",
    get: function get() {
      return this.getData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error;
      var data = this.data;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onLoad: this.onLoad,
        onSubmit: this.onSubmit,
        onUpdateData: this.setData
      };
      var stepProps = {
        error: error,
        loading: loading,
        slowLoading: slowLoading,
        onLoad: this.onLoad,
        nextLoading: submitting,
        onNext: this.onSubmit,
        onActivate: this.onActivate,
        onDeactivate: this.onDeactivate,
        passThruProps: {
          data: data,
          state: state,
          events: events
        }
      };
      return this.props.render(stepProps, data, state, events);
    }
  }]);

  return WizardStepBase;
}(React.Component);

_defineProperty(WizardStepBase, "propTypes", {
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  render: propTypes.func.isRequired
});

_defineProperty(WizardStepBase, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});

_defineProperty(WizardStepBase, "contextType", WizardBaseContext);

var mapDispatchToProps$7 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardStepBase$1 = connect$1(null, mapDispatchToProps$7)(WizardStepBase);

var WizardStepFormBase = /*#__PURE__*/function (_React$Component) {
  _inherits(WizardStepFormBase, _React$Component);

  var _super = _createSuper(WizardStepFormBase);

  function WizardStepFormBase(props) {
    var _this;

    _classCallCheck(this, WizardStepFormBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_stepIndex", null);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "getData", function () {
      var getStepData = _this.context.getStepData;
      if (!getStepData || _this._stepIndex === null) return {};
      return getStepData(_this._stepIndex) || {};
    });

    _defineProperty(_assertThisInitialized(_this), "setData", function (data) {
      var setStepData = _this.context.setStepData;
      if (!setStepData || _this._stepIndex === null) return;
      setStepData(_this._stepIndex, data);
    });

    _defineProperty(_assertThisInitialized(_this), "onActivate", function (newStepIndex) {
      _this._stepIndex = newStepIndex;

      _this.setState({
        showErrors: false,
        dirty: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDeactivate", function (stepIndex) {
      _this._stepIndex = null;
    });

    _defineProperty(_assertThisInitialized(_this), "onLoad", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stepIndex, step) {
        var _this$props, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dispatch, formData, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, loadAction = _this$props.loadAction, loadTransform = _this$props.loadTransform, loadParams = _this$props.loadParams, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;
                _this._stepIndex = stepIndex;

                if (onLoad) {
                  formData = onLoad(loadParams);

                  _this.setData(formData);
                }

                loadResponse = null;

                if (!loadAction) {
                  _context.next = 20;
                  break;
                }

                loadingKey = Date.now();

                _this.setState({
                  loadingKey: loadingKey,
                  loading: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowLoading: true
                  });
                }, loadSlowDelay);
                _context.next = 10;
                return dispatch(loadAction(loadParams));

              case 10:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                error = _yield$dispatch.error;
                response = _yield$dispatch.response;
                clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                if (!(loadingKey !== _this.state.loadingKey)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return");

              case 19:
                if (!success) {
                  _this.setState({
                    loading: false,
                    slowLoading: false,
                    error: error
                  });
                } else {
                  loadResponse = loadTransform(response);

                  _this.setState({
                    loading: false,
                    slowLoading: false
                  });

                  _this.setData(loadResponse);
                }

              case 20:
                if (onLoaded) {
                  onLoaded(loadResponse, loadParams);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(stepIndex, step) {
        var _this$props2, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.formValid) {
                  _context2.next = 5;
                  break;
                }

                _this.setState({
                  showErrors: true
                });

                return _context2.abrupt("return", false);

              case 5:
                _this$props2 = _this.props, submitAction = _this$props2.submitAction, submitParams = _this$props2.submitParams, submitSlowDelay = _this$props2.submitSlowDelay, onSubmit = _this$props2.onSubmit, onSubmitted = _this$props2.onSubmitted, dispatch = _this$props2.dispatch;

                if (onSubmit) {
                  onSubmit(step, submitParams);
                }

                submitResponse = null;

                if (!submitAction) {
                  _context2.next = 27;
                  break;
                }

                _this.setState({
                  submitting: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 13;
                return dispatch(submitAction(step, submitParams));

              case 13:
                _yield$dispatch2 = _context2.sent;
                success = _yield$dispatch2.success;
                error = _yield$dispatch2.error;
                response = _yield$dispatch2.response;
                // prevent state changes after unmounting
                if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 20;
                  break;
                }

                return _context2.abrupt("return");

              case 20:
                if (success) {
                  _context2.next = 25;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 25:
                submitResponse = response;

                _this.setState({
                  submitting: false,
                  slowSubmitting: false
                });

              case 27:
                if (onSubmitted) {
                  onSubmitted(submitResponse, submitParams, step);
                }

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFormChange", function (field, data, applyChanges) {
      var newData = applyChanges(_this.getData());

      _this.setData(newData);

      _this.setState({
        dirty: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFormValidated", function (formValid) {
      return _this.setState({
        formValid: formValid
      });
    });

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass(WizardStepFormBase, [{
    key: "formData",
    get: function get() {
      return this.getData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          formValid = _this$state.formValid,
          error = _this$state.error,
          showErrors = _this$state.showErrors,
          dirty = _this$state.dirty;
      var formProps = {
        value: this.formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        formValid: formValid,
        dirty: dirty
      };
      var events = {
        onLoad: this.onLoad,
        onSubmit: this.onSubmit,
        onUpdateData: this.setData
      };
      var stepProps = {
        error: error,
        loading: loading,
        slowLoading: slowLoading,
        onLoad: this.onLoad,
        nextLoading: submitting,
        onNext: this.onSubmit,
        onActivate: this.onActivate,
        onDeactivate: this.onDeactivate,
        passThruProps: {
          formProps: formProps,
          state: state,
          events: events
        }
      };
      return this.props.render(stepProps, formProps, state, events);
    }
  }]);

  return WizardStepFormBase;
}(React.Component);

_defineProperty(WizardStepFormBase, "propTypes", _objectSpread2({}, WizardStepBase$1.propTypes));

_defineProperty(WizardStepFormBase, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});

_defineProperty(WizardStepFormBase, "contextType", WizardBaseContext);

var mapDispatchToProps$8 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardStepFormBase$1 = connect$1(null, mapDispatchToProps$8)(WizardStepFormBase);

/**
 * A helper to load data and display content
 */
var ContentBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentBuilder, _React$Component);

  var _super = _createSuper(ContentBuilder);

  function ContentBuilder() {
    var _this;

    _classCallCheck(this, ContentBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoadableContent", function (data, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderContent = _this$props.renderContent,
          renderLoading = _this$props.renderLoading,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderContent(data, state, events));
    });

    return _this;
  }

  _createClass(ContentBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.loadable;
          var renderContent = _this$props2.renderContent,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties(_this$props2, ["loadable", "renderContent", "renderLoading", "renderError"]);

      return /*#__PURE__*/React.createElement(ContentBase$1, _extends({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderError === false ? renderContent.apply(void 0, arguments) : _this2.renderLoadableContent.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ContentBuilder;
}(React.Component);

_defineProperty(ContentBuilder, "propTypes", {
  renderContent: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  loadable: propTypes.elementType
});

_defineProperty(ContentBuilder, "defaultProps", {
  initialData: {},
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200
});

/**
 * A helper to load and save data, and manage state for a form
 */
var FormBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBuilder, _React$Component);

  var _super = _createSuper(FormBuilder);

  function FormBuilder() {
    var _this;

    _classCallCheck(this, FormBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoadableForm", function (formProps, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderForm = _this$props.renderForm,
          renderLoading = _this$props.renderLoading,
          renderSubmitting = _this$props.renderSubmitting,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.submitting) {
        if (renderSubmitting) return renderSubmitting(state.slowSubmitting);

        if (renderSubmitting !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = loadableProps.slowLoading || state.slowSubmitting;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderForm(formProps, state, events));
    });

    return _this;
  }

  _createClass(FormBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.loadable;
          var renderForm = _this$props2.renderForm,
          renderLoading = _this$props2.renderLoading,
          renderSubmitting = _this$props2.renderSubmitting,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties(_this$props2, ["loadable", "renderForm", "renderLoading", "renderSubmitting", "renderError"]);

      return /*#__PURE__*/React.createElement(FormBase$1, _extends({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderSubmitting === false && renderError === false ? renderForm.apply(void 0, arguments) : _this2.renderLoadableForm.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return FormBuilder;
}(React.Component);

_defineProperty(FormBuilder, "propTypes", {
  renderForm: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderSubmitting: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  initialReadOnly: propTypes.bool,
  value: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  loadable: propTypes.elementType,
  onChange: propTypes.func,
  onValidated: propTypes.func,
  abortSubmitOnUnmount: propTypes.bool
});

_defineProperty(FormBuilder, "defaultProps", {
  initialData: {},
  initialReadOnly: false,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  abortSubmitOnUnmount: false
});

/**
 * A helper to load data and manage state for a list or table
 */
var ListBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ListBuilder, _React$Component);

  var _super = _createSuper(ListBuilder);

  function ListBuilder(props) {
    var _this;

    _classCallCheck(this, ListBuilder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listWithData", function (data, state, events) {
      var _ref = _this.props,
          renderList = _ref.renderList;
      return renderList(data, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "listWithTable", function (tableProps, state, events) {
      var _ref2 = _this.props,
          renderList = _ref2.renderList;
      return renderList(tableProps, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "listWithTiles", function (tileProps, state, events) {
      var _ref3 = _this.props,
          renderList = _ref3.renderList;
      return renderList(tileProps, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDefaultList", function (data, state, events) {
      var _this$props = _this.props,
          withTable = _this$props.withTable,
          withTiles = _this$props.withTiles;

      if (withTable) {
        return _this.listWithTable({
          data: data
        }, state, events);
      }

      if (withTiles) {
        return _this.listWithTiles({
          data: data
        }, state, events);
      }

      return _this.listWithData(data, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLoadableList", function (data, state, events) {
      var _this$props2 = _this.props,
          withTable = _this$props2.withTable,
          withTiles = _this$props2.withTiles,
          loadable = _this$props2.loadable,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      if (withTable) {
        return _this.listWithTable(_objectSpread2(_objectSpread2({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      if (withTiles) {
        return _this.listWithTiles(_objectSpread2(_objectSpread2({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, _this.listWithData(data, state, events));
    });

    var id = props.id;

    if (!id) {
      id = createAutoName("list/");
    }

    _this.state = {
      id: id
    };
    return _this;
  }

  _createClass(ListBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props;
          _this$props3.withTable;
          _this$props3.loadable;
          _this$props3.renderList;
          var renderLoading = _this$props3.renderLoading,
          renderError = _this$props3.renderError,
          otherProps = _objectWithoutProperties(_this$props3, ["withTable", "loadable", "renderList", "renderLoading", "renderError"]);

      return /*#__PURE__*/React.createElement(ListBase$1, _extends({}, otherProps, {
        id: this.state.id,
        render: function render() {
          return renderLoading === false && renderError === false ? _this2.renderDefaultList.apply(_this2, arguments) : _this2.renderLoadableList.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ListBuilder;
}(React.Component);

_defineProperty(ListBuilder, "propTypes", {
  id: propTypes.string,
  withTable: propTypes.any,
  withTiles: propTypes.any,
  renderList: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  initialFilters: propTypes.any,
  initialPagination: propTypes.any,
  initialSelection: propTypes.any,
  dataTransform: propTypes.func,
  totalTransform: propTypes.func,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  loadable: propTypes.elementType,
  persistFilters: propTypes.string,
  debounceFilters: propTypes.number,
  debouncePagination: propTypes.number
});

_defineProperty(ListBuilder, "defaultProps", {
  withTable: false,
  withTiles: false,
  initialFilters: {},
  initialPagination: {
    pageSize: 10,
    pageNumber: 1
  },
  initialSelection: {},
  dataTransform: function dataTransform(data) {
    return data;
  },
  totalTransform: function totalTransform(data) {
    return data.length;
  },
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  debounceFilters: 250,
  debouncePagination: -250
});

/**
 * A helper to load and save data, and manage state for a modal
 */
var ModalBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBuilder, _React$Component);

  var _super = _createSuper(ModalBuilder);

  function ModalBuilder() {
    var _this;

    _classCallCheck(this, ModalBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "showModal", function () {
      return _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitModal", function (response, params) {
      _this.setState({
        active: false
      });

      var onSubmitted = _this.props.onSubmitted;
      if (onSubmitted) onSubmitted(response, params);
    });

    _defineProperty(_assertThisInitialized(_this), "cancelModal", function () {
      _this.setState({
        active: false
      });

      var onCancelled = _this.props.onCancelled;
      if (onCancelled) onCancelled();
    });

    _defineProperty(_assertThisInitialized(_this), "modalWithData", function () {
      var _ref = _this.props;
          _ref.withForm;
          var renderTrigger = _ref.renderTrigger,
          onSubmitted = _ref.onSubmitted,
          onCancelled = _ref.onCancelled,
          renderModal = _ref.renderModal,
          otherProps = _objectWithoutProperties(_ref, ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"]);

      return /*#__PURE__*/React.createElement(ModalBase$1, _extends({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "modalWithForm", function () {
      var _ref2 = _this.props;
          _ref2.withForm;
          var renderTrigger = _ref2.renderTrigger,
          onSubmitted = _ref2.onSubmitted,
          onCancelled = _ref2.onCancelled,
          renderModal = _ref2.renderModal,
          otherProps = _objectWithoutProperties(_ref2, ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"]);

      return /*#__PURE__*/React.createElement(ModalFormBase$1, _extends({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    return _this;
  }

  _createClass(ModalBuilder, [{
    key: "render",
    value: function render() {
      var active = this.state.active;
      var _this$props = this.props,
          withForm = _this$props.withForm,
          renderTrigger = _this$props.renderTrigger;
      var modal = withForm ? this.modalWithForm() : this.modalWithData();

      if (renderTrigger) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger(this.showModal), active && modal);
      }

      return modal;
    }
  }]);

  return ModalBuilder;
}(React.Component);

_defineProperty(ModalBuilder, "propTypes", {
  submitAction: propTypes.func,
  onSubmit: propTypes.func,
  withForm: propTypes.any,
  renderTrigger: propTypes.func,
  renderModal: propTypes.func.isRequired,
  visible: propTypes.bool,
  initialData: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  preventErrorNotification: propTypes.bool,
  abortSubmitOnCancel: propTypes.bool
});

_defineProperty(ModalBuilder, "defaultProps", {
  withForm: false,
  visible: true,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  initialData: {},
  preventErrorNotification: true,
  abortSubmitOnCancel: true
});

/**
 * A helper to submit data from a trigger and display the response
 */
var TriggerBuilder = function TriggerBuilder(props) {
  var renderTrigger = props.renderTrigger,
      renderSubmitting = props.renderSubmitting,
      renderError = props.renderError,
      otherProps = _objectWithoutProperties(props, ["renderTrigger", "renderSubmitting", "renderError"]);

  return /*#__PURE__*/React.createElement(TriggerBase$1, _extends({}, otherProps, {
    render: function render(fireTrigger, state, events) {
      if (state.submitting && renderSubmitting) {
        return renderSubmitting(state.slowSubmitting);
      }

      if (state.error && renderError) {
        return renderError(state.error);
      }

      return renderTrigger(fireTrigger, state, events);
    }
  }));
};

TriggerBuilder.propTypes = {
  renderTrigger: propTypes.func.isRequired,
  renderSubmitting: propTypes.func,
  renderError: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  abortSubmitOnUnmount: propTypes.bool
};
TriggerBuilder.defaultProps = {
  submitSlowDelay: 200,
  abortSubmitOnUnmount: false
};

/**
 * A helper to manage data and state for a single step within a WizardBuilder
 */

var WizardBuilderStep = /*#__PURE__*/function (_React$Component) {
  _inherits(WizardBuilderStep, _React$Component);

  var _super = _createSuper(WizardBuilderStep);

  function WizardBuilderStep() {
    _classCallCheck(this, WizardBuilderStep);

    return _super.apply(this, arguments);
  }

  _createClass(WizardBuilderStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withForm = _this$props.withForm,
          renderStep = _this$props.renderStep,
          otherProps = _objectWithoutProperties(_this$props, ["withForm", "renderStep"]);

      var BaseComponent = withForm ? WizardStepFormBase$1 : WizardStepBase$1;
      return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, otherProps, {
        render: renderStep
      }));
    }
  }]);

  return WizardBuilderStep;
}(React.Component);

_defineProperty(WizardBuilderStep, "propTypes", {
  /**
   * Whether the step should manage state for a form internally, defaults to false
   */
  withForm: propTypes.bool,

  /**
   * Render function for displaying the step
   * @param {Object} `stepProps` Props to be passed to a <Wizard.Step /> component. When <Wizard.Step /> is used with the 'component' prop, then 'formProps/data/state/events' will all be passed into the step component as props.
   * @param {*} `formProps/data` If withForm is true then props to be passed to a <Form/> component, otherwise the current step data
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.loading` Whether the step is currently loading
   * @param {boolean} `state.slowLoading` Whether the step is taking longer than expected to load
   * @param {boolean} `state.submitting` Whether the step is currently submitting
   * @param {boolean} `state.slowSubmitting` Whether the step is taking longer than expected to submit
   * @param {boolean} `state.formValid` If withForm is true, whether the entire step form is valid or not
   * @param {*} `state.error` Error when the step fails to load or submit
   * @param {boolean} `state.dirty` If withForm is true, whether any fields have been edited in the form since it was loaded or submitted
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `onLoad` Loads the data for the step
   * @param {function} `onSubmit` Submits the step
   * @param {function} `onUpdateData` Updates the data for the step
   */
  renderStep: propTypes.func.isRequired,

  /**
   * API action creator that should be dispatched to get the step data
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {Object|function} API action
   */
  loadAction: propTypes.func,

  /**
   * Optional additional parameters to supply to loadAction
   */
  loadParams: propTypes.any,

  /**
   * Transform function applied to the response of loadAction, to modify step data as required
   * Override this to manipulate the structure of loaded data
   * @param {*} `data` Input response data
   * @returns {*} Output transformed data
   */
  loadTransform: propTypes.func,

  /**
   * Delay before the step indicates it is taking a long time to load
   */
  loadSlowDelay: propTypes.number,

  /**
   * Callback function when the step is about to be loaded
   * (can be used as an alternative to loadAction by returning the step data)
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {*} Step data
   */
  onLoad: propTypes.func,

  /**
   * Callback function when the step has finished loading
   * @param {*} `loadResponse` API response from loadAction
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   */
  onLoaded: propTypes.func,

  /**
   * API action creator that should be dispatched to save the step data
   * @param {Array} `step` The current state of the step
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @returns {Object|function} API action
   */
  submitAction: propTypes.func,

  /**
   * Optional additional parameters to supply to submitAction
   */
  submitParams: propTypes.any,

  /**
   * Delay before the step indicates it is taking a long time to save
   */
  submitSlowDelay: propTypes.number,

  /**
   * Callback function when the step is about to be submitted
   * (can be used as an alternative to submitAction)
   * @param {Array} `step` The current state of the step
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   */
  onSubmit: propTypes.func,

  /**
   * Callback function when the step has finished saving
   * @param {*} `submitResponse` API response from submitAction
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @param {Array} `step` The current state of the step
   */
  onSubmitted: propTypes.func
});

_defineProperty(WizardBuilderStep, "defaultProps", {
  withForm: false,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});

/**
 * A helper to load and save data, and manage state for a wizard
 */

var WizardBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(WizardBuilder, _React$Component);

  var _super = _createSuper(WizardBuilder);

  function WizardBuilder() {
    var _this;

    _classCallCheck(this, WizardBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoadableWizard", function (wizardProps, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderWizard = _this$props.renderWizard,
          renderLoading = _this$props.renderLoading,
          renderSubmitting = _this$props.renderSubmitting,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.submitting) {
        if (renderSubmitting) return renderSubmitting(state.slowSubmitting);

        if (renderSubmitting !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = loadableProps.slowLoading || state.slowSubmitting;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderWizard(wizardProps, state, events));
    });

    return _this;
  }

  _createClass(WizardBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.loadable;
          var renderWizard = _this$props2.renderWizard,
          renderLoading = _this$props2.renderLoading,
          renderSubmitting = _this$props2.renderSubmitting,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties(_this$props2, ["loadable", "renderWizard", "renderLoading", "renderSubmitting", "renderError"]);

      return /*#__PURE__*/React.createElement(WizardBase$1, _extends({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderSubmitting === false && renderError === false ? renderWizard.apply(void 0, arguments) : _this2.renderLoadableWizard.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return WizardBuilder;
}(React.Component);

_defineProperty(WizardBuilder, "propTypes", {
  /**
   * Render function for displaying the wizard
   * @param {Object} `wizardProps` Props to be passed to a <Wizard/> component
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.loading` Whether the wizard is currently loading
   * @param {boolean} `state.slowLoading` Whether the wizard is taking longer than expected to load
   * @param {boolean} `state.submitting` Whether the wizard is currently submitting
   * @param {boolean} `state.slowSubmitting` Whether the wizard is taking longer than expected to submit
   * @param {*} `state.error` Error when the wizard fails to load or submit
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onSubmit` Submits the wizard
   * @param {function} `events.onReset` Resets the builder and reloads wizard data
   */
  renderWizard: propTypes.func.isRequired,

  /**
   * Optional render function when the wizard is in a loading state
   * If not supplied a default loading renderer will be used, alternatively can be set to false to disable completely
   * @param {boolean} `slowLoading` Whether the wizard is taking longer than expected to load
   */
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Optional render function when the wizard is in a submitting state
   * If not supplied a default submitting renderer will be used, alternatively can be set to false to disable completely
   * @param {boolean} `slowSubmitting` Whether the wizard is taking longer than expected to submit
   */
  renderSubmitting: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Optional render function when the wizard is in an error state
   * If not supplied a default error renderer will be used, alternatively can be set to false to disable completely
   * @param {*} `error` Error when the wizard fails to load or submit
   */
  renderError: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Initial steps for the wizard.
   * If not specified, steps will be loaded dynamically using the response from loadAction/onLoad
   */
  initialSteps: propTypes.arrayOf(propTypes.object),

  /**
   * API action creator that should be dispatched to get the wizard data
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {Object|function} API action
   */
  loadAction: propTypes.func,

  /**
   * Optional additional parameters to supply to loadAction
   */
  loadParams: propTypes.any,

  /**
   * Transform function applied to the response of loadAction, to modify wizard data as required
   * Override this to manipulate the structure of loaded data
   * @param {*} `data` Input response data
   * @returns {*} Output transformed data
   */
  loadTransform: propTypes.func,

  /**
   * Delay before the wizard indicates it is taking a long time to load
   */
  loadSlowDelay: propTypes.number,

  /**
   * Callback function when the wizard is about to be loaded
   * (can be used as an alternative to loadAction by returning the wizard data)
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {*} Wizard data
   */
  onLoad: propTypes.func,

  /**
   * Callback function when the wizard has finished loading
   * @param {*} `loadResponse` API response from loadAction
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   */
  onLoaded: propTypes.func,

  /**
   * Allows the default component used for rendering loading and error state to be overridden
   * (when renderLoading/renderError are not specified)
   * Will receive the output of renderList as its children
   */
  loadable: propTypes.elementType,

  /**
   * API action creator that should be dispatched to save the wizard data
   * @param {Array} `steps` The current state of the wizard steps
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @returns {Object|function} API action
   */
  submitAction: propTypes.func,

  /**
   * Optional additional parameters to supply to submitAction
   */
  submitParams: propTypes.any,

  /**
   * Delay before the wizard indicates it is taking a long time to save
   */
  submitSlowDelay: propTypes.number,

  /**
   * Callback function when the wizard is about to be submitted
   * (can be used as an alternative to submitAction)
   * @param {Array} `steps` The current state of the wizard steps
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   */
  onSubmit: propTypes.func,

  /**
   * Callback function when the wizard has finished saving
   * @param {*} `submitResponse` API response from submitAction
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @param {Array} `steps` The current state of the wizard steps
   */
  onSubmitted: propTypes.func,

  /**
   * Name of a key property in step objects that step data should be stored against
   */
  dataKey: propTypes.string,

  /**
   * Optional, transform function applied when wizard data is loaded, to map it against the step state.
   * If not supplied and data is an array, each data item will be assigned to the corresponding step index, against the key specified by the 'dataKey' prop.
   * @param {*} `data` The data that was loaded
   * @param {Array} `steps` The current state of the wizard steps
   * @param {string} `dataKey` The current value of the dataKey prop
   * @returns {Array} The new state for the wizard steps
   */
  mapDataToSteps: propTypes.func
});

_defineProperty(WizardBuilder, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  dataKey: "data"
});

WizardBuilder.Step = WizardBuilderStep;

var PropagateUpdatesMethod;

(function (PropagateUpdatesMethod) {
  PropagateUpdatesMethod["Never"] = "never";
  PropagateUpdatesMethod["Parent"] = "parent";
  PropagateUpdatesMethod["Always"] = "always";
})(PropagateUpdatesMethod || (PropagateUpdatesMethod = {}));

var TriggerEvent;

(function (TriggerEvent) {
  TriggerEvent["OnChange"] = "onChange";
  TriggerEvent["OnClear"] = "onClear";
  TriggerEvent["OnSet"] = "onSet";
  TriggerEvent["OnMatch"] = "onMatch";
})(TriggerEvent || (TriggerEvent = {}));

var TriggerAction;

(function (TriggerAction) {
  TriggerAction["Change"] = "change";
  TriggerAction["Clear"] = "clear";
  TriggerAction["Set"] = "set";
})(TriggerAction || (TriggerAction = {}));

var omitProps = function omitProps(props, filterArray) {
  return filterArray.reduce(function (acc, p) {
    acc[p];
        var filtered = _objectWithoutProperties(acc, [p].map(_toPropertyKey));

    return filtered;
  }, _objectSpread2({}, props));
};
var fieldErrors = function fieldErrors(errors) {
  var showErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var allErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!showErrors || !errors || !errors.length) return [];
  return allErrors ? errors : [errors[0]];
};
var countErrors = function countErrors(errors) {
  return Object.values(errors).reduce(function (total, e) {
    if (Array.isArray(e) && _typeof(e[0]) === "object") return total + e.reduce(function (subtotal, f) {
      return subtotal + countErrors(f);
    }, 0);
    if (Array.isArray(e)) return total + e.length;
    if (_typeof(e) === "object") return total + countErrors(e);
    return total;
  }, 0);
};
var shallowCompareObjects = function shallowCompareObjects(a, b) {
  for (var key in a) {
    if (!(key in b) || a[key] !== b[key]) return false;
  }

  for (var _key in b) {
    if (!(_key in a) || a[_key] !== b[_key]) return false;
  }

  return true;
};
var shallowCompareArrays = function shallowCompareArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};
var shouldFieldUpdate = function shouldFieldUpdate(currentProps, nextProps) // pass through updates for parent value changes (arrays/objects)
{
  var propagateUpdates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (propagateUpdates === PropagateUpdatesMethod.Always) {
    return true;
  }

  var propagateParent = propagateUpdates === PropagateUpdatesMethod.Parent || propagateUpdates === true; // update on props change

  if (currentProps && nextProps) {
    var removeChildrenProp = function removeChildrenProp(props) {
      // ignore these props
      if (props.children || props.passThruProps || props.parentValue || props.formValue || props.formState) {
        if (propagateParent) {
          props.children;
              props.passThruProps;
              var rest = _objectWithoutProperties(props, ["children", "passThruProps"]);

          return rest;
        } else {
          props.children;
              props.passThruProps;
              props.parentValue;
              props.formValue;
              props.formState;
              var _rest = _objectWithoutProperties(props, ["children", "passThruProps", "parentValue", "formValue", "formState"]);

          return _rest;
        }
      }

      return props;
    };

    var currentPropsToCompare = removeChildrenProp(currentProps);
    var nextPropsToCompare = removeChildrenProp(nextProps);

    if (!shallowCompareObjects(currentPropsToCompare, nextPropsToCompare)) {
      return true;
    }
  }

  return false;
};
var fieldFormState = function fieldFormState(context) {
  var value = context.value,
      errors = context.errors,
      parentValue = context.parentValue,
      formValue = context.formValue,
      arrayIndex = context.arrayIndex;
  return {
    fields: value,
    errors: errors,
    parentFields: parentValue,
    formFields: formValue,
    arrayIndex: arrayIndex
  };
};
var prettifyField = function prettifyField(field) {
  return field.replace(/([A-Z])/g, " $1").replace(/^./, function (c) {
    return c.toUpperCase();
  });
};
var isValueSet = function isValueSet(value) {
  return value !== undefined && value !== null && (!Array.isArray(value) || value.length > 0) && (_typeof(value) !== "object" || Object.values(value).some(function (el) {
    return isValueSet(el);
  })) && (typeof value !== "string" || value.trim() !== "");
};

var utils = /*#__PURE__*/Object.freeze({
__proto__: null,
omitProps: omitProps,
fieldErrors: fieldErrors,
countErrors: countErrors,
shallowCompareObjects: shallowCompareObjects,
shallowCompareArrays: shallowCompareArrays,
shouldFieldUpdate: shouldFieldUpdate,
fieldFormState: fieldFormState,
prettifyField: prettifyField,
isValueSet: isValueSet
});

var FormContext = /*#__PURE__*/React.createContext({
  value: {},
  onChange: function onChange() {},
  errors: {},
  onError: function onError() {},
  showErrors: false,
  allErrors: false,
  animateErrors: false,
  disabled: false,
  readOnly: false
});
FormContext.displayName = "FormContext";

var getDefaultOptions = function getDefaultOptions() {
  return {
    defaultProps: {},
    displayName: function displayName(props) {
      return props.field;
    },
    validators: []
  };
};

var connectForm = function connectForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions();
  return function (FieldComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions();
    var validators = options.validators || defaultOptions.validators || [];
    var validatorPropTypes = validators.reduce(function (acc, v) {
      return v.propTypes ? _objectSpread2(_objectSpread2({}, acc), v.propTypes) : acc;
    }, {});
    var validatorDefaultProps = validators.reduce(function (acc, v) {
      return v.defaultProps ? _objectSpread2(_objectSpread2({}, acc), v.defaultProps) : acc;
    }, {});
    var fieldDefaultProps = options.defaultProps || defaultOptions.defaultProps;

    var FieldProvider = /*#__PURE__*/function (_React$Component) {
      _inherits(FieldProvider, _React$Component);

      var _super = _createSuper(FieldProvider);

      function FieldProvider() {
        _classCallCheck(this, FieldProvider);

        return _super.apply(this, arguments);
      }

      _createClass(FieldProvider, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          return shouldFieldUpdate(this.props, nextProps);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(FieldComponent, this.props);
        }
      }]);

      return FieldProvider;
    }(React.Component);

    _defineProperty(FieldProvider, "propTypes", {
      value: propTypes.any,
      onChange: propTypes.func.isRequired,
      errors: propTypes.arrayOf(propTypes.string),
      passThruProps: propTypes.any.isRequired,
      formState: propTypes.any.isRequired
    });

    _defineProperty(FieldProvider, "defaultProps", {
      value: undefined
    });

    _defineProperty(FieldProvider, "displayName", "".concat(FieldComponent.displayName || FieldComponent.name, "Provider"));

    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits(FieldWrapper, _React$Component2);

      var _super2 = _createSuper(FieldWrapper);

      function FieldWrapper() {
        var _this;

        _classCallCheck(this, FieldWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "_prevContext", void 0);

        _defineProperty(_assertThisInitialized(_this), "onChange", function (data) {
          var additionalFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var field = _this.props.field;

          var applyChanges = function applyChanges(prevValue) {
            return _objectSpread2(_objectSpread2(_objectSpread2({}, prevValue), additionalFormData), {}, _defineProperty({}, field, data));
          };

          if (_this.context.onChange) {
            _this.context.onChange(field, data, applyChanges);
          }
        });

        _defineProperty(_assertThisInitialized(_this), "validate", function (props, context) {
          var comparePreviousErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var field = props.field;
          var contextValue = context.value || {};
          var fieldValue = contextValue[field];
          var fieldName = options.displayName ? options.displayName(props) : defaultOptions.displayName ? defaultOptions.displayName(props) : "";

          if (props.customValidator) {
            props.customValidator(fieldName, fieldValue, props, context);
          }

          var errors = validators.reduce(function (acc, v) {
            if (!v.getErrors) return acc;
            if (v.shouldValidate && !v.shouldValidate(props, context)) return acc;
            return [].concat(_toConsumableArray(acc), _toConsumableArray(v.getErrors(fieldName, fieldValue, props, context)));
          }, []);

          if (comparePreviousErrors) {
            // stop if errors unchanged
            if (shallowCompareArrays(context.errors && context.errors[field] ? context.errors[field] : [], errors)) {
              return;
            }
          }

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, errors));
          };

          if (_this.context.onError) {
            _this.context.onError(field, errors, applyErrors);
          }
        });

        return _this;
      }

      _createClass(FieldWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.validate(this.props, this.context);
          this._prevContext = this.context;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clear validation errors so unmounted components don't invalidate forms
          var field = this.props.field;
          var errors = [];

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, errors));
          };

          if (this.context.onError) {
            this.context.onError(field, errors, applyErrors);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$_prevContext,
              _this2 = this;

          var currentContextValue = this.context.value || {};
          var prevContextValue = ((_this$_prevContext = this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
          var validate = currentContextValue[this.props.field] !== prevContextValue[prevProps.field];

          if (!validate) {
            // run validators if any validator props have changed
            var validatorPropKeys = Object.keys(validatorPropTypes);
            validate = validatorPropKeys.some(function (k) {
              return _this2.props[k] !== prevProps[k];
            });
          }

          if (!validate) {
            // run validators if need notification of other field changes
            var notifiedFields = validators.reduce(function (acc, v) {
              if (!v.getNotifiedFields) return acc;
              return [].concat(_toConsumableArray(acc), _toConsumableArray(v.getNotifiedFields(_this2.props)));
            }, this.props.notifiedFields || []);
            validate = notifiedFields.some(function (f) {
              return currentContextValue[f] !== prevContextValue[f];
            });
          }

          if (validate) {
            this.validate(this.props, this.context, true);
          }

          this._prevContext = this.context;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              field = _this$props.field,
              showErrors = _this$props.showErrors,
              allErrors = _this$props.allErrors,
              animateErrors = _this$props.animateErrors,
              disabled = _this$props.disabled,
              readOnly = _this$props.readOnly,
              customErrors = _this$props.customErrors;
          var contextValue = this.context.value || {};
          var contextErrors = this.context.errors || {};
          var passThruProps = omitProps(this.props, Object.keys(FieldWrapper.propTypes));
          var fieldErrors = contextErrors[field];

          if (customErrors && customErrors.length) {
            fieldErrors = customErrors.concat(fieldErrors || []);
          }

          var formState = fieldFormState(this.context);
          return /*#__PURE__*/React.createElement(FieldProvider, _extends({}, this.props, {
            value: contextValue[field],
            onChange: this.onChange,
            errors: fieldErrors,
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly,
            passThruProps: passThruProps,
            formState: formState
          }));
        }
      }]);

      return FieldWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", _objectSpread2({}, validatorPropTypes)), _defineProperty(_class, "defaultProps", _objectSpread2(_objectSpread2({}, fieldDefaultProps), validatorDefaultProps)), _defineProperty(_class, "contextType", FormContext), _defineProperty(_class, "displayName", "connectForm(".concat(FieldComponent.displayName || FieldComponent.name, ")")), _temp;
  };
};

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var getDefaultOptions$1 = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};

var withForm = function withForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$1();
  return function (FormComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$1();
    var formDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inherits(FormWrapper, _React$Component);

      var _super = _createSuper(FormWrapper);

      function FormWrapper() {
        var _this;

        _classCallCheck(this, FormWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "defaultOnError", function (field, errors, applyErrors) {
          var onStateUpdated = function onStateUpdated() {
            if (!_this.props.onValidated) return;
            var totalErrors = countErrors(_this.state.errors);

            _this.props.onValidated(totalErrors === 0);
          };

          _this.setState(function (state) {
            return {
              errors: applyErrors(state.errors)
            };
          }, onStateUpdated);
        });

        _defineProperty(_assertThisInitialized(_this), "state", {
          errors: {}
        });

        _defineProperty(_assertThisInitialized(_this), "getFormContext", memoizeOne(function (value, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly) {
          return {
            value: value,
            onChange: onChange,
            errors: errors,
            onError: onError,
            showErrors: showErrors,
            allErrors: allErrors,
            animateErrors: animateErrors,
            disabled: disabled,
            readOnly: readOnly
          };
        }));

        return _this;
      }

      _createClass(FormWrapper, [{
        key: "render",
        value: function render() {
          var _ref = this.props,
              value = _ref.value,
              onChange = _ref.onChange,
              errors = _ref.errors,
              onError = _ref.onError,
              showErrors = _ref.showErrors,
              allErrors = _ref.allErrors,
              animateErrors = _ref.animateErrors,
              disabled = _ref.disabled,
              readOnly = _ref.readOnly,
              children = _ref.children;
          var passThruProps = omitProps(this.props, Object.keys(FormWrapper.propTypes));
          var formContext = this.getFormContext(value, onChange, errors !== null && errors !== void 0 ? errors : this.state.errors, onError !== null && onError !== void 0 ? onError : this.defaultOnError, showErrors, allErrors, animateErrors, disabled, readOnly);
          return /*#__PURE__*/React.createElement(FormComponent, _extends({}, this.props, {
            errors: errors || this.state.errors,
            onErrors: onError || this.defaultOnError,
            passThruProps: passThruProps
          }), /*#__PURE__*/React.createElement(FormContext.Provider, {
            value: formContext
          }, typeof children === "function" ? children(value, errors || this.state.errors) : children));
        }
      }]);

      return FormWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({
      value: {},
      onChange: function onChange() {},
      showErrors: false,
      allErrors: false,
      animateErrors: false,
      disabled: false,
      readOnly: false
    }, formDefaultProps)), _defineProperty(_class, "displayName", "withForm(".concat(FormComponent.displayName || FormComponent.name, ")")), _temp;
  };
};

var confirmField = function confirmField() {
  return {
    propTypes: {
      confirmField: propTypes.string,
      confirmFieldError: propTypes.string
    },
    getNotifiedFields: function getNotifiedFields(props) {
      // we want to be notified if this field changes
      return props.confirmField ? [props.confirmField] : [];
    },
    shouldValidate: function shouldValidate(props) {
      return !!props.confirmField;
    },
    getErrors: function getErrors(field, value, props, context) {
      if (context.value && props.confirmField) {
        var otherField = context.value[props.confirmField];

        if (value && otherField && value !== otherField) {
          return [props.confirmFieldError || "".concat(field, " does not match")];
        }
      }

      return [];
    }
  };
};

// source: https://emailregex.com/
var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
var emailAddress = function emailAddress(validationDefault) {
  return {
    propTypes: {
      emailValidation: propTypes.bool.isRequired,
      emailError: propTypes.string
    },
    defaultProps: {
      emailValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.emailValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" && value.length > 0 && !regex.test(value)) {
        return [props.emailError || "".concat(field, " is not a valid email address")];
      }

      return [];
    }
  };
};

var isFileType = function isFileType(value) {
  return _typeof(value) === "object" && value !== null && ("name" in value || "type" in value);
};

var validateFile = function validateFile(value, props) {
  var _value$name = value.name,
      name = _value$name === void 0 ? "" : _value$name,
      _value$type = value.type,
      type = _value$type === void 0 ? "" : _value$type;
  var _props$fileMimeTypes = props.fileMimeTypes,
      fileMimeTypes = _props$fileMimeTypes === void 0 ? [] : _props$fileMimeTypes,
      _props$fileExtensionT = props.fileExtensionTypes,
      fileExtensionTypes = _props$fileExtensionT === void 0 ? [] : _props$fileExtensionT;
  var extensionValid = !fileExtensionTypes || fileExtensionTypes.length === 0 || fileExtensionTypes.some(function (t) {
    var ext = t.startsWith(".") ? t : "." + t;
    return name.toLowerCase().endsWith(ext.toLowerCase());
  });
  var mimeValid = !fileMimeTypes || fileMimeTypes.length === 0 || fileMimeTypes.some(function (t) {
    return type.toLowerCase() === t.toLowerCase();
  });
  return {
    extensionValid: extensionValid,
    mimeValid: mimeValid
  };
};

var fileTypes = function fileTypes() {
  return {
    propTypes: {
      fileMimeTypes: propTypes.arrayOf(propTypes.string.isRequired),
      fileExtensionTypes: propTypes.arrayOf(propTypes.string.isRequired),
      fileTypesError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return Array.isArray(props.fileMimeTypes) && props.fileMimeTypes.length > 0 || Array.isArray(props.fileExtensionTypes) && props.fileExtensionTypes.length > 0;
    },
    getErrors: function getErrors(field, value, props) {
      var values = Array.isArray(value) ? value : [value];
      var validation = values.map(function (v) {
        if (!isFileType(v) || !v.name) return null;
        return validateFile(v, props);
      });
      var extensionValid = validation.every(function (v) {
        return !v || v.extensionValid;
      });
      var mimeValid = validation.every(function (v) {
        return !v || v.mimeValid;
      });
      var isNotValid = !extensionValid || !mimeValid;

      if (isNotValid) {
        var _props$fileMimeTypes2 = props.fileMimeTypes,
            fileMimeTypes = _props$fileMimeTypes2 === void 0 ? [] : _props$fileMimeTypes2,
            _props$fileExtensionT2 = props.fileExtensionTypes,
            fileExtensionTypes = _props$fileExtensionT2 === void 0 ? [] : _props$fileExtensionT2,
            fileTypesError = props.fileTypesError;
        if (fileTypesError) return [fileTypesError];
        var errors = [];

        if (!extensionValid) {
          errors.push(fileExtensionTypes.length === 1 ? "".concat(field, " must be of type ").concat(fileExtensionTypes[0]) : "".concat(field, " must be one of the following file types: \n      ").concat(fileExtensionTypes.join(", ")));
        }

        if (!mimeValid) {
          errors.push(fileMimeTypes.length === 1 ? "".concat(field, " must be of type ").concat(fileMimeTypes[0]) : "".concat(field, " must be one of the following file types: \n      ").concat(fileMimeTypes.join(", ")));
        }

        return errors;
      }

      return [];
    }
  };
};

var maxLength = function maxLength() {
  return {
    propTypes: {
      maxLength: propTypes.number,
      maxLengthError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.maxLength === "number" && props.maxLength > 0;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" || Array.isArray(value)) {
        var length = value.length;

        if (props.maxLength !== undefined && length > props.maxLength) {
          var subject = typeof value === "string" ? "character" : "item";
          return [props.maxLengthError || "".concat(field, " cannot have more than ").concat(props.maxLength, " ").concat(subject).concat(props.maxLength === 1 ? "" : "s")];
        }
      }

      return [];
    }
  };
};

var maxValue = function maxValue() {
  return {
    propTypes: {
      maxValue: propTypes.number,
      maxValueError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.maxValue === "number";
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "number" || typeof value === "string") {
        if (props.maxValue !== undefined && parseFloat(value.toString()) > props.maxValue) {
          return [props.maxValueError || "".concat(field, " cannot be more than ").concat(props.maxValue)];
        }
      }

      return [];
    }
  };
};

var minLength = function minLength() {
  return {
    propTypes: {
      minLength: propTypes.number,
      minLengthError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.minLength === "number" && props.minLength > 0;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" || Array.isArray(value)) {
        var length = value.length;

        if (props.minLength !== undefined && length < props.minLength) {
          var subject = typeof value === "string" ? "character" : "item";
          return [props.minLengthError || "".concat(field, " must have at least ").concat(props.minLength, " ").concat(subject).concat(props.minLength === 1 ? "" : "s")];
        }
      }

      return [];
    }
  };
};

var minValue = function minValue() {
  return {
    propTypes: {
      minValue: propTypes.number,
      minValueError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.minValue === "number";
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "number" || typeof value === "string") {
        if (props.minValue !== undefined && parseFloat(value.toString()) < props.minValue) {
          return [props.minValueError || "".concat(field, " must be at least ").concat(props.minValue)];
        }
      }

      return [];
    }
  };
};

// source: https://stackoverflow.com/questions/2811031/decimal-or-numeric-values-in-regular-expression-validation
var regex$1 = new RegExp(/^-?(((0|[1-9]\d*)(\.\d+)?)|(\.\d+))$/);
var number = function number(validationDefault) {
  return {
    propTypes: {
      numberValidation: propTypes.bool.isRequired,
      numberError: propTypes.string
    },
    defaultProps: {
      numberValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.numberValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (value === null || value === undefined || value === "" || typeof value === "number") {
        return [];
      }

      if (typeof value === "string" && !Number.isNaN(value) && regex$1.test(value)) {
        return [];
      }

      return [props.numberError || "".concat(field, " is not a valid number")];
    }
  };
};

var requiredField = function requiredField(defaultValue) {
  var getComparisonValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v;
  };
  return {
    propTypes: {
      required: propTypes.bool.isRequired,
      requiredError: propTypes.string
    },
    defaultProps: {
      required: defaultValue
    },
    shouldValidate: function shouldValidate(props) {
      return props.required === true;
    },
    getErrors: function getErrors(field, value, props) {
      var comparison = getComparisonValue(value);

      if (comparison === null || comparison === undefined || comparison === "" || comparison === false || Array.isArray(comparison) && comparison.length === 0 || typeof comparison === "string" && !/\S/.test(comparison) // String does not contain any characters that are not whitespace
      ) {
          return [props.requiredError || "".concat(field, " is required")];
        }

      return [];
    }
  };
};

var index$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
confirmField: confirmField,
emailAddress: emailAddress,
fileTypes: fileTypes,
maxLength: maxLength,
maxValue: maxValue,
minLength: minLength,
minValue: minValue,
number: number,
requiredField: requiredField
});

var ArrayItemProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayItemProvider, _React$Component);

  var _super = _createSuper(ArrayItemProvider);

  function ArrayItemProvider() {
    var _this;

    _classCallCheck(this, ArrayItemProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getArrayContext", memoizeOne(function (arrayIndex, value, parentValue, formValue, onChange, errors, onError, onRemove, showErrors, allErrors, animateErrors, disabled, readOnly) {
      return {
        arrayIndex: arrayIndex,
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        onRemove: onRemove,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (field, data, applyChanges) {
      _this.props.onChange(_this.props.value, field, data, applyChanges);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      if (_this.props.index === undefined) return;

      _this.props.onRemove(_this.props.index);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function (field, errors, applyErrors) {
      _this.props.onError(_this.props.value, field, errors, applyErrors);
    });

    return _this;
  }

  _createClass(ArrayItemProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps, this.props.propagateUpdates);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          children = _this$props.children;
      var arrayContext = this.getArrayContext(index, value, parentValue, formValue, this.onChange, errors, this.onError, this.onRemove, showErrors, allErrors, animateErrors, disabled, readOnly);
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: arrayContext
      }, typeof children === "function" ? children(fieldFormState(arrayContext)) : children);
    }
  }]);

  return ArrayItemProvider;
}(React.Component);

_defineProperty(ArrayItemProvider, "propTypes", {
  index: propTypes.number,
  value: propTypes.any.isRequired,
  parentValue: propTypes.any.isRequired,
  formValue: propTypes.any.isRequired,
  onChange: propTypes.func.isRequired,
  errors: propTypes.any.isRequired,
  onError: propTypes.func.isRequired,
  showErrors: propTypes.bool.isRequired,
  allErrors: propTypes.bool.isRequired,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]).isRequired,
  disabled: propTypes.bool.isRequired,
  readOnly: propTypes.bool.isRequired,
  propagateUpdates: propTypes.oneOfType([propTypes.any, propTypes.bool]),
  onRemove: propTypes.func.isRequired
});

var validators = [minLength(), maxLength()];
var validatorPropTypes = validators.reduce(function (acc, v) {
  return v.propTypes ? _objectSpread2(_objectSpread2({}, acc), v.propTypes) : acc;
}, {});

var getDefaultOptions$2 = function getDefaultOptions() {
  return {
    defaultProps: {},
    displayName: function displayName(props) {
      return props.field;
    }
  };
};
/**
 * Higher-order function to create a form-connected array higher-order component
 * @param {Object} `options` Array options
 * @returns Array HOC
 */


var withFormArray = function withFormArray() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$2();
  return function (FormArrayComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$2();
    var arrayDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits(ArrayWrapper, _React$Component2);

      var _super2 = _createSuper(ArrayWrapper);

      function ArrayWrapper() {
        var _this2;

        _classCallCheck(this, ArrayWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this2), "_prevContext", void 0);

        _defineProperty(_assertThisInitialized(_this2), "_hasInnerObjectError", false);

        _defineProperty(_assertThisInitialized(_this2), "_validateOnUpdate", false);

        _defineProperty(_assertThisInitialized(_this2), "validate", function (props, context) {
          var comparePreviousErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var field = props.field,
              arrayKey = props.arrayKey;
          var contextValue = context.value || {};
          var contextErrors = context.errors || {};
          var fieldValue = contextValue[field] || [];
          var fieldErrors = contextErrors[field] || [];
          var fieldName = options.displayName ? options.displayName(props) : defaultOptions.displayName ? defaultOptions.displayName(props) : ""; // remove previous 'array' errors

          var itemErrors = fieldErrors.filter(function (e) {
            return fieldValue.some(function (v) {
              return v[arrayKey] === e[arrayKey];
            });
          });
          var arrayErrors = validators.reduce(function (acc, v) {
            if (!v.getErrors) return acc;
            if (v.shouldValidate && !v.shouldValidate(props, context)) return acc;
            return [].concat(_toConsumableArray(acc), _toConsumableArray(v.getErrors(fieldName, fieldValue, props, context)));
          }, []);
          var newErrors = [].concat(_toConsumableArray(arrayErrors), _toConsumableArray(itemErrors));

          if (comparePreviousErrors) {
            // stop if errors unchanged
            if (shallowCompareArrays(fieldErrors, newErrors)) return;
          }

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, newErrors));
          };

          if (_this2.context.onError) {
            _this2.context.onError(field, newErrors, applyErrors);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnChange", function (object, field, data, applyChanges) {
          var _ref;

          var _this2$props = _this2.props,
              arrayField = _this2$props.field,
              arrayKey = _this2$props.arrayKey,
              autoRemove = _this2$props.autoRemove;
          var arrayData = [(_ref = {}, _defineProperty(_ref, arrayKey, object[arrayKey]), _defineProperty(_ref, "field", field), _defineProperty(_ref, "data", data), _ref)];

          var arrayApplyChanges = function arrayApplyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray(prevArrayValue);

            var objectIndex = newArray.findIndex(function (v) {
              return v[arrayKey] === object[arrayKey];
            });

            if (objectIndex >= 0) {
              var updatedObject = applyChanges(newArray[objectIndex]);
              newArray[objectIndex] = updatedObject;

              if (autoRemove) {
                updatedObject[arrayKey];
                    var otherObjectValues = _objectWithoutProperties(updatedObject, [arrayKey].map(_toPropertyKey));

                if (Object.values(otherObjectValues).every(function (v) {
                  return !isValueSet(v);
                })) {
                  newArray.splice(objectIndex, 1);
                }
              }
            } else {
              newArray.push(applyChanges(object)); // at the point of adding an auto item apply any errors

              if (_this2._nextAutoItem && Object.keys(_this2._nextAutoItemErrors).length > 0) {
                // ignore errors for the field(s) just changed, as the change will trigger re-validation
                var fieldArray = Array.isArray(field) ? field : [field];
                var autoItemErrors = fieldArray.reduce(function (acc, f) {
                  acc[f];
                      var remaining = _objectWithoutProperties(acc, [f].map(_toPropertyKey));

                  return remaining;
                }, _objectSpread2({}, _this2._nextAutoItemErrors));
                var arrayErrors = [_objectSpread2(_defineProperty({}, arrayKey, object[arrayKey]), autoItemErrors)];

                var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
                  var prevArrayErrors = prevErrors[arrayField] || [];
                  return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, arrayField, [].concat(_toConsumableArray(prevArrayErrors), arrayErrors)));
                };

                if (_this2.context.onError) {
                  _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
                }
              }

              _this2._nextAutoItem = null;
              _this2._nextAutoItemErrors = {};
            }

            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, arrayField, newArray));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(arrayField, arrayData, arrayApplyChanges);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnRemove", function (index) {
          var arrayField = _this2.props.field;

          var applyChanges = function applyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray(prevArrayValue);

            newArray.splice(index, 1);
            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, arrayField, newArray));
          };

          if (_this2.context.onChange) {
            var contextValue = _this2.context.value || {};

            _this2.context.onChange(arrayField, applyChanges(contextValue)[arrayField], applyChanges);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnError", function (object, field, errors, applyErrors) {
          var _ref2;

          var _this2$props2 = _this2.props,
              arrayField = _this2$props2.field,
              arrayKey = _this2$props2.arrayKey;
          _this2._hasInnerObjectError = true; // hold back auto item errors until item is actually added

          if (_this2._nextAutoItem && object[arrayKey] === _this2._nextAutoItem[arrayKey]) {
            _this2._nextAutoItemErrors = applyErrors(_this2._nextAutoItemErrors);
            return;
          }

          var arrayErrors = [(_ref2 = {}, _defineProperty(_ref2, arrayKey, object[arrayKey]), _defineProperty(_ref2, "field", field), _defineProperty(_ref2, "errors", errors), _ref2)];

          var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
            var prevArrayErrors = prevErrors[arrayField] || [];

            var newArray = _toConsumableArray(prevArrayErrors);

            var objectIndex = newArray.findIndex(function (v) {
              return _typeof(v) === "object" && v[arrayKey] === object[arrayKey];
            });

            if (objectIndex >= 0) {
              var foundItem = newArray[objectIndex];
              newArray[objectIndex] = applyErrors(foundItem);
            } else {
              var newItem = _defineProperty({}, arrayKey, object[arrayKey]);

              newArray.push(applyErrors(newItem));
            }

            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, arrayField, newArray));
          };

          if (_this2.context.onError) {
            _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "getObjectErrorsByKey", memoizeOne(function (errors, arrayKey) {
          var objectErrors = errors.filter(function (e) {
            return _typeof(e) === "object";
          });
          return objectErrors.reduce(function (acc, e) {
            acc[e[arrayKey]] = e;
            return acc;
          }, {});
        }));

        _defineProperty(_assertThisInitialized(_this2), "_nextAutoItem", null);

        _defineProperty(_assertThisInitialized(_this2), "_nextAutoItemErrors", {});

        _defineProperty(_assertThisInitialized(_this2), "_defaultItemErrors", {});

        return _this2;
      }

      _createClass(ArrayWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this._hasInnerObjectError) this._validateOnUpdate = true;else this.validate(this.props, this.context);
          this._prevContext = this.context;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clear validation errors so unmounted components don't invalidate forms
          var field = this.props.field;
          var errors = [];

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, errors));
          };

          if (this.context.onError) {
            this.context.onError(field, errors, applyErrors);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$_prevContext,
              _this3 = this;

          var currentContextValue = this.context.value || {};
          var prevContextValue = ((_this$_prevContext = this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
          var validate = currentContextValue[this.props.field] !== prevContextValue[prevProps.field] || this._validateOnUpdate;

          if (!validate) {
            // run validators if any validator props have changed
            var validatorPropKeys = Object.keys(validatorPropTypes);
            validate = validatorPropKeys.some(function (k) {
              return _this3.props[k] !== prevProps[k];
            });
          }

          if (validate) {
            this.validate(this.props, this.context, true);
          }

          this._prevContext = this.context;
          this._validateOnUpdate = false;
        }
      }, {
        key: "render",
        value: function render() {
          var _this4 = this;

          var _ref3 = this.props,
              field = _ref3.field,
              arrayKey = _ref3.arrayKey,
              showErrors = _ref3.showErrors,
              allErrors = _ref3.allErrors,
              animateErrors = _ref3.animateErrors,
              disabled = _ref3.disabled,
              readOnly = _ref3.readOnly,
              autoAdd = _ref3.autoAdd,
              autoAddPopulate = _ref3.autoAddPopulate,
              propagateUpdates = _ref3.propagateUpdates,
              children = _ref3.children;
          var contextValue = this.context.value || {};
          var contextErrors = this.context.errors || {};
          var values = contextValue[field] || [];
          var errors = contextErrors[field] || [];
          var arrayErrors = errors.filter(function (e) {
            return typeof e === "string";
          });
          var objectErrors = this.getObjectErrorsByKey(errors, arrayKey);

          if (autoAdd) {
            if (!this._nextAutoItem) {
              this._nextAutoItem = autoAddPopulate(arrayKey);
            }

            values = [].concat(_toConsumableArray(values), [this._nextAutoItem]);
          }

          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly
          };
          var passThruProps = omitProps(this.props, Object.keys(ArrayWrapper.propTypes));
          return /*#__PURE__*/React.createElement(FormArrayComponent, _extends({}, this.props, contextProps, {
            value: values,
            errors: arrayErrors,
            passThruChildren: children,
            passThruProps: passThruProps
          }), values.map(function (v, i) {
            var _objectErrors$v$array;

            if (v[arrayKey] === undefined) {
              throw new Error("ArrayField object missing ".concat(arrayKey, " property for ").concat(field, "[").concat(i, "]"));
            }

            return /*#__PURE__*/React.createElement(ArrayItemProvider, _extends({}, contextProps, {
              key: v[arrayKey],
              index: _this4._nextAutoItem && v[arrayKey] === _this4._nextAutoItem[arrayKey] ? undefined : i,
              value: v,
              parentValue: contextValue,
              formValue: _this4.context.formValue || contextValue,
              onChange: _this4.objectOnChange,
              onRemove: _this4.objectOnRemove,
              errors: (_objectErrors$v$array = objectErrors[v[arrayKey]]) !== null && _objectErrors$v$array !== void 0 ? _objectErrors$v$array : _this4._defaultItemErrors,
              onError: _this4.objectOnError,
              propagateUpdates: propagateUpdates
            }), children);
          }));
        }
      }]);

      return ArrayWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({
      arrayKey: "key",
      autoAdd: false,
      autoAddPopulate: function autoAddPopulate(arrayKey) {
        return _defineProperty({}, arrayKey, Date.now());
      },
      autoRemove: false
    }, arrayDefaultProps)), _defineProperty(_class, "contextType", FormContext), _defineProperty(_class, "displayName", "withFormArray(".concat(FormArrayComponent.displayName || FormArrayComponent.name, ")")), _temp;
  };
};

var ObjectDataProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ObjectDataProvider, _React$Component);

  var _super = _createSuper(ObjectDataProvider);

  function ObjectDataProvider() {
    var _this;

    _classCallCheck(this, ObjectDataProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getObjectContext", memoizeOne(function (value, parentValue, formValue, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly) {
      return {
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly
      };
    }));

    return _this;
  }

  _createClass(ObjectDataProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps, this.props.propagateUpdates);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          onError = _this$props.onError,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          children = _this$props.children;
      var objectContext = this.getObjectContext(value, parentValue, formValue, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly);
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: objectContext
      }, typeof children === "function" ? children(fieldFormState(objectContext)) : children);
    }
  }]);

  return ObjectDataProvider;
}(React.Component);

_defineProperty(ObjectDataProvider, "propTypes", {
  value: propTypes.any.isRequired,
  parentValue: propTypes.any.isRequired,
  formValue: propTypes.any.isRequired,
  onChange: propTypes.any.isRequired,
  errors: propTypes.any.isRequired,
  onError: propTypes.any.isRequired,
  showErrors: propTypes.bool.isRequired,
  allErrors: propTypes.bool.isRequired,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]).isRequired,
  disabled: propTypes.bool.isRequired,
  readOnly: propTypes.bool.isRequired,
  propagateUpdates: propTypes.oneOfType([propTypes.any, propTypes.bool])
});

var getDefaultOptions$3 = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};
/**
 * Higher-order function to create a form-connected object higher-order component
 * @param {Object} `options` Object options
 * @returns Object HOC
 */


var withFormObject = function withFormObject() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$3();
  return function (FormObjectComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$3();
    var objectDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits(ObjectWrapper, _React$Component2);

      var _super2 = _createSuper(ObjectWrapper);

      function ObjectWrapper() {
        var _this2;

        _classCallCheck(this, ObjectWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this2), "_defaultChildValue", {});

        _defineProperty(_assertThisInitialized(_this2), "_defaultChildErrors", {});

        _defineProperty(_assertThisInitialized(_this2), "getChildValue", function () {
          var contextValue = _this2.context.value || {};
          return contextValue[_this2.props.field] || _this2._defaultChildValue;
        });

        _defineProperty(_assertThisInitialized(_this2), "onChildChange", function (field, data, applyChanges) {
          var objectField = _this2.props.field;
          var objectData = {
            field: field,
            data: data
          };

          var objectApplyChanges = function objectApplyChanges(prevValue) {
            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, objectField, applyChanges(prevValue[objectField] || {})));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(objectField, objectData, objectApplyChanges);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "getChildErrors", function () {
          var contentErrors = _this2.context.errors || {};
          return contentErrors[_this2.props.field] || _this2._defaultChildErrors;
        });

        _defineProperty(_assertThisInitialized(_this2), "onChildError", function (field, errors, applyErrors) {
          var objectField = _this2.props.field;
          var objectErrors = {
            field: field,
            errors: errors
          };

          var objectApplyErrors = function objectApplyErrors(prevErrors) {
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, objectField, applyErrors(prevErrors[objectField] || {})));
          };

          if (_this2.context.onError) {
            _this2.context.onError(objectField, objectErrors, objectApplyErrors);
          }
        });

        return _this2;
      }

      _createClass(ObjectWrapper, [{
        key: "render",
        value: function render() {
          var _ref = this.props,
              children = _ref.children,
              showErrors = _ref.showErrors,
              allErrors = _ref.allErrors,
              animateErrors = _ref.animateErrors,
              disabled = _ref.disabled,
              readOnly = _ref.readOnly,
              propagateUpdates = _ref.propagateUpdates;
          var contextValue = this.context.value || {};
          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly
          };
          return /*#__PURE__*/React.createElement(FormObjectComponent, _extends({}, this.props, contextProps), /*#__PURE__*/React.createElement(ObjectDataProvider, _extends({}, contextProps, {
            value: this.getChildValue(),
            parentValue: contextValue,
            formValue: this.context.formValue || contextValue,
            onChange: this.onChildChange,
            errors: this.getChildErrors(),
            onError: this.onChildError,
            propagateUpdates: propagateUpdates
          }), children));
        }
      }]);

      return ObjectWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({}, objectDefaultProps)), _defineProperty(_class, "contextType", FormContext), _defineProperty(_class, "displayName", "withFormObject(".concat(FormObjectComponent.displayName || FormObjectComponent.name, ")")), _temp;
  };
};

/**
 * A form hook to trigger actions upon field events
 */
var FieldTrigger = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldTrigger, _React$Component);

  var _super = _createSuper(FieldTrigger);

  function FieldTrigger() {
    var _this;

    _classCallCheck(this, FieldTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_prevContext", void 0);

    _defineProperty(_assertThisInitialized(_this), "_matchWarning", false);

    _defineProperty(_assertThisInitialized(_this), "_targetWarning", false);

    _defineProperty(_assertThisInitialized(_this), "_valueWarning", false);

    _defineProperty(_assertThisInitialized(_this), "validateProps", function () {
      var _this$props = _this.props,
          event = _this$props.event,
          match = _this$props.match,
          action = _this$props.action,
          target = _this$props.target,
          value = _this$props.value;

      if (!match && !_this._matchWarning && event === TriggerEvent.OnMatch) {
        console.warn("Trigger match prop is required for ".concat(event, " events"));
        _this._matchWarning = true;
      }

      if (!target && !_this._targetWarning && (action === TriggerAction.Change || action === TriggerAction.Clear || action === TriggerAction.Set)) {
        console.warn("Trigger target prop is required for ".concat(action, " actions"));
        _this._targetWarning = true;
      }

      if (!value && !_this._valueWarning && (action === TriggerAction.Change || action === TriggerAction.Set)) {
        console.warn("Trigger value prop is required for ".concat(action, " actions"));
        _this._valueWarning = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$_prevContext;

      var currentContextValue = _this.context.value || {};
      var prevContextValue = ((_this$_prevContext = _this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
      _this._prevContext = _this.context;
      var currentValue = currentContextValue[_this.props.field];
      var prevValue = prevContextValue[prevProps.field];

      _this.validateProps();

      switch (_this.props.event) {
        // field value has changed
        case TriggerEvent.OnChange:
          if (currentValue !== prevValue) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value was set but has now been cleared

        case TriggerEvent.OnClear:
          if (currentValue !== prevValue && !isValueSet(currentValue)) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value was not set but is now

        case TriggerEvent.OnSet:
          if (currentValue !== prevValue && !isValueSet(prevValue)) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value changed and equals match prop

        case TriggerEvent.OnMatch:
          if (currentValue !== prevValue) {
            var hasMatch = typeof _this.props.match === "function" ? _this.props.match(fieldFormState(_this.context)) : currentValue === _this.props.match;
            if (hasMatch) _this.handleEvent(_this.props, _this.context);
          }

          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEvent", function (props, context) {
      switch (props.action) {
        // updating the target field
        case TriggerAction.Change:
        case TriggerAction.Set:
          {
            if (props.target === undefined) break; // for set action, ensure not previously set

            if (props.action === TriggerAction.Set) {
              var targetValue = context.value[props.target];
              if (isValueSet(targetValue)) break;
            }

            var newValue = typeof props.value === "function" ? props.value(fieldFormState(context)) : props.value;

            var applyChanges = function applyChanges(prevValue) {
              return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, props.target, newValue));
            };

            context.onChange(props.target, newValue, applyChanges);
            break;
          }
        // clear the target field

        case TriggerAction.Clear:
          {
            if (props.target === undefined) break;
            var _targetValue = context.value[props.target];
            if (_targetValue === undefined) break;

            var _applyChanges = function _applyChanges(prevValue) {
              var _ref = props.target;
                  prevValue[_ref];
                  var otherValues = _objectWithoutProperties(prevValue, [_ref].map(_toPropertyKey));

              return otherValues;
            };

            context.onChange(props.target, undefined, _applyChanges);
            break;
          }
        // perform a custom function

        default:
          if (typeof props.action === "function") {
            var _formState = fieldFormState(context);

            props.action(_formState);
          }

      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass(FieldTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._prevContext = this.context;
      this.validateProps();
    }
  }]);

  return FieldTrigger;
}(React.Component);

_defineProperty(FieldTrigger, "propTypes", {
  field: propTypes.string.isRequired,
  event: propTypes.string,
  match: propTypes.any,
  action: propTypes.oneOfType([propTypes.any, propTypes.func]).isRequired,
  target: propTypes.string,
  value: propTypes.any
});

_defineProperty(FieldTrigger, "defaultProps", {
  event: TriggerEvent.OnChange
});

_defineProperty(FieldTrigger, "contextType", FormContext);

/**
 * A hook to run an effect when form fields change
 * @param {function} `effect` Effect function, can optionally return a 'clean-up' function
 * @param {string[]} `triggerFields` Array of field names to trigger the effect on, or an empty array to fire on form initialisation, or omit to trigger on any field change
 */

var useFormEffect = function useFormEffect(effect, triggerFields) {
  var context = useContext(FormContext);
  var prevContext = useRef();
  var cleanup = useRef();
  useEffect(function () {
    var triggered = !triggerFields || triggerFields.some(function (f) {
      var _prevContext$current;

      return prevContext.current && context.value[f] !== ((_prevContext$current = prevContext.current) === null || _prevContext$current === void 0 ? void 0 : _prevContext$current.value[f]);
    });

    if (triggered) {
      if (cleanup.current) {
        var _prevContext$current2;

        cleanup.current(fieldFormState((_prevContext$current2 = prevContext.current) !== null && _prevContext$current2 !== void 0 ? _prevContext$current2 : context));
      }

      cleanup.current = effect(fieldFormState(context));
    }

    prevContext.current = context;
  }, [context.value]);
  useEffect(function () {
    if ((triggerFields === null || triggerFields === void 0 ? void 0 : triggerFields.length) === 0) {
      cleanup.current = effect(fieldFormState(context));
    }

    return function () {
      if (cleanup.current) {
        var _prevContext$current3;

        cleanup.current(fieldFormState((_prevContext$current3 = prevContext.current) !== null && _prevContext$current3 !== void 0 ? _prevContext$current3 : context));
      }
    };
  }, []);
};

/**
 * A hook to get or set a single field value
 * @param {string} `field` The name of the field
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current field value
 * @returns {function} `setValue` A function to update the field value, takes a single parameter for the new field value
 */

var useFormField = function useFormField(field) {
  var context = useContext(FormContext);
  return [context.value[field], function (value) {
    return context.onChange(field, value, function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, field, value));
    });
  }];
};

/**
 * A hook to return form state data
 * @returns {object} The current state of the form relative to this hook
 * @returns {object} `fields` Form field data, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `errors` Form field errors, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `parentFields` Form field data for the parent level when Object/Array fields are used
 * @returns {object} `formFields` Form field data for the entire form when Object/Array fields are used
 * @returns {number} `arrayIndex` Index of the current row when used inside an Array field
 *
 */
var useFormState = function useFormState() {
  var context = useContext(FormContext);
  return fieldFormState(context);
};

var lookupName = function lookupName(lookup) {
  return typeof lookup === "string" ? lookup : lookup.name;
};

var utils$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
lookupName: lookupName
});

var LOOKUP_REQUEST = "LOOKUPS/REQUEST";
var LOOKUP_RESET = "LOOKUPS/RESET";
var LOOKUP_SET = "LOOKUPS/SET";
var SAVE_LOOKUP_STATE = "LOOKUPS/SAVE";

/**
 * Action creator for requesting lookup data
 * @param {string|object} `lookup` A previously registered lookup or its name
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 */
var lookupRequest = function lookupRequest(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = options.key,
      otherOptions = _objectWithoutProperties(options, ["key"]);

  return {
    type: LOOKUP_REQUEST,
    name: lookupName(lookup),
    params: params,
    key: key !== undefined ? key : getParamsKey(params),
    options: otherOptions || {}
  };
};
/**
 * Action creator for clearing cached lookup data
 * @param {string|object} `lookup` Optional, the lookup to reset or its name. If not specified then all lookups will be reset
 * @param {*} `params` Optional, parameters that were used for the lookup request to reset. If omitted (and no key is specified) then all cached data for the lookup will be cleared
 * @param {object} `options` Additional options for the reset
 * @param {number} `options.key` Optional, unique key for the lookup to reset. If omitted will be automatically generated from params, otherwise all cached data for the lookup will be cleared
 */

var lookupReset = function lookupReset(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: LOOKUP_RESET,
    name: lookup !== undefined ? lookupName(lookup) : undefined,
    params: params,
    key: options.key !== undefined ? options.key : params !== undefined && params !== null ? getParamsKey(params) : undefined
  };
};
/**
 * Action creator for manually updating cached lookup data
 * @param {string|object} `lookup` A previously registered lookup or its name
 * @param {*} `data` Data to be stored in the lookup cache
 * @param {*} `params` Optional, parameters that were used for the lookup request to update
 * @param {object} `options` Additional options for the update
 * @param {number} `options.key` Optional, unique key for the lookup to update. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 */

var lookupSet = function lookupSet(lookup, data, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var state = {
    loading: false,
    slowLoading: false,
    params: params,
    date: Date.now(),
    response: data,
    error: undefined
  };
  return {
    type: LOOKUP_SET,
    name: lookupName(lookup),
    key: options.key !== undefined ? options.key : getParamsKey(params),
    limit: undefined,
    state: state
  };
}; // internal action creators

var saveLookupState = function saveLookupState(name, key, limit) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: SAVE_LOOKUP_STATE,
    name: name,
    key: key,
    limit: limit,
    state: state
  };
};

var defaultOptions$5 = {
  cache: true,
  transform: function transform(data) {
    return data;
  }
};
var lookups = {};
var getLookupAction = function getLookupAction(name) {
  return lookups[name].config.action;
};
var getLookupOptions = function getLookupOptions(name) {
  return lookups[name].config.options;
};
/**
 * Determines whether a lookup has been registered
 * @param {string} `name` The name of a lookup to check
 * @returns {boolean} True if the lookup has been registered, otherwise false
 */

var lookupExists = function lookupExists(name) {
  return lookups.hasOwnProperty(name);
};
/**
 * Finds a previously registered lookup if it exists
 * @param {string} `name` The name of a lookup to check
 * @returns {object|null} The registered lookup, or null if it does not exist
 */

var findLookup = function findLookup(name) {
  if (lookupExists(name)) {
    return lookups[name];
  }

  return null;
};
/**
 * Registers a new lookup
 * @param {string} `name` Name of the lookup to register
 * @param {function} `action` API action creator for requesting lookup data, receives lookup parameters
 * @param {object} `options` Default options for requesting lookup data
 * @param {boolean} `options.cache` Whether lookup requests should save and retrieve their data from cached state, default true
 * @param {number} `options.cacheExpiry` Time in milliseconds that cached data should be kept before being invalidated, or null for indefinite, default null
 * @param {number} `options.cacheLimit` Number of copies of cached data for different request parameters that should be kept, or null for unlimited, default null
 * @param {function} `options.transform` Transform function to apply when lookup data is retrieved successfully, receives the original data and lookup parameters, and returns the transformed data
 * @returns {object} The registered lookup
 * @returns {string} `name` The registered name of the lookup
 * @returns {number} `registeredAt` Timestamp when the lookup was registered
 * @returns {object} `config` The configuration of the lookup when it was registered
 * @returns {function} `unregister` A function to unregister this lookup
 * @returns {number} `unregisteredAt` If unregistered, the timestamp when this occurred
 */

var registerLookup = function registerLookup(name, action) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (lookupExists(name)) {
    console.warn("Lookup has already been registered: ".concat(name));
  }

  var config = {
    action: action,
    options: _objectSpread2(_objectSpread2({}, defaultOptions$5), options)
  };
  var lookup = {
    name: name,
    registeredAt: Date.now(),
    config: config,
    unregister: function unregister() {
      return unregisterLookup(name);
    }
  };
  lookups[name] = lookup;
  return lookup;
};
/**
 * Unregisters an existing lookup
 * @param {string|object} `lookup` A previously registered lookup or its name
 */

var unregisterLookup = function unregisterLookup(lookup) {
  var name = lookupName(lookup);
  var found = findLookup(name);

  if (found) {
    found.unregistedAt = Date.now();
    delete lookups[name];
  }
};

var getLookupState = function getLookupState(state) {
  return state.lookups;
};
var getLookupCache = function getLookupCache(state, lookup) {
  var name = lookupName(lookup);
  var lookupState = getLookupState(state);
  return lookupState[name] || {};
};
/**
 * Selects Redux state data for a single lookup
 * @param {object} `state` Redux state
 * @param {string|object} `lookup`  A previously registered lookup or its name
 * @param {*} `params` Optional, parameters that were used for the lookup request to find
 * @param {object} `options` Additional options for the selector
 * @param {number} `options.key` Optional, unique key for the lookup request to find. If omitted will be automatically generated from params
 */

var getLookupData = function getLookupData(state, lookup, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cacheState = getLookupCache(state, lookup);
  var key = options.key !== undefined ? options.key : getParamsKey(params);
  return cacheState[key] || {};
};

var defaultOptions$6 = {
  required: true,
  autoNamePrefix: "withLookup/"
};

var withLookup = function withLookup() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (LookupComponent) {
    var _options = _objectSpread2(_objectSpread2({}, defaultOptions$6), options);

    var LookupWrapper = /*#__PURE__*/function (_React$Component) {
      _inherits(LookupWrapper, _React$Component);

      var _super = _createSuper(LookupWrapper);

      function LookupWrapper() {
        var _this;

        _classCallCheck(this, LookupWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "_autoLookup", void 0);

        _defineProperty(_assertThisInitialized(_this), "_lookupWarning", false);

        _defineProperty(_assertThisInitialized(_this), "getLookup", function () {
          var _this$props = _this.props,
              lookup = _this$props.lookup,
              lookupAction = _this$props.lookupAction,
              lookupOptions = _this$props.lookupOptions;
          if (_this._autoLookup) return _this._autoLookup;

          if (lookupAction) {
            var name = createAutoName(_options.autoNamePrefix);
            _this._autoLookup = registerLookup(name, lookupAction, lookupOptions);
            return _this._autoLookup;
          }

          if (lookup) return lookup;

          if (!_this._lookupWarning && _options.required) {
            console.warn("".concat(LookupWrapper.displayName, " props lookup/lookupAction have not been defined"));
            _this._lookupWarning = true;
          }

          return null;
        });

        return _this;
      }

      _createClass(LookupWrapper, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this._autoLookup) {
            this.props.lookupReset(this._autoLookup);
            unregisterLookup(this._autoLookup);
            this._autoLookup = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props;
              _this$props2.lookupReset;
              var otherProps = _objectWithoutProperties(_this$props2, ["lookupReset"]);

          var lookup = this.getLookup();
          return /*#__PURE__*/React.createElement(LookupComponent, _extends({}, otherProps, {
            lookup: lookup
          }));
        }
      }]);

      return LookupWrapper;
    }(React.Component);

    _defineProperty(LookupWrapper, "propTypes", {
      lookupReset: propTypes.any.isRequired
    });

    _defineProperty(LookupWrapper, "displayName", "withLookup(".concat(LookupComponent.displayName || LookupComponent.name, ")"));

    return connect$1(null, {
      lookupReset: lookupReset
    })(LookupWrapper);
  };
};

var LookupBase = /*#__PURE__*/function (_React$Component) {
  _inherits(LookupBase, _React$Component);

  var _super = _createSuper(LookupBase);

  function LookupBase() {
    var _this;

    _classCallCheck(this, LookupBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          lookupRequest = _this$props.lookupRequest,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          lookupOptions = _this$props.lookupOptions,
          lookupData = _this$props.lookupData,
          onLoad = _this$props.onLoad; // re-request if lookup was reset or params changed

      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams))) {
        if (onLoad) onLoad();
        lookupRequest(lookup, lookupParams, lookupOptions).then(_this.onRequestCompleted);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _this$props2 = _this.props,
          lookupReset = _this$props2.lookupReset,
          lookup = _this$props2.lookup,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions,
          onReset = _this$props2.onReset;
      if (!lookup) return;
      lookupReset(lookup, lookupParams, lookupOptions);
      if (onReset) onReset(); // re-requesting handled in componentDidUpdate
    });

    _defineProperty(_assertThisInitialized(_this), "onRequestCompleted", function () {
      if (!_this._isMounted) return;
      var _this$props3 = _this.props,
          onLoaded = _this$props3.onLoaded,
          lookupData = _this$props3.lookupData;
      if (onLoaded) onLoaded(lookupData);
    });

    return _this;
  }

  _createClass(LookupBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          lookupRequest = _this$props4.lookupRequest,
          lookupReset = _this$props4.lookupReset,
          lookup = _this$props4.lookup,
          lookupParams = _this$props4.lookupParams,
          lookupOptions = _this$props4.lookupOptions,
          resetOnMount = _this$props4.resetOnMount,
          onLoad = _this$props4.onLoad,
          onReset = _this$props4.onReset;
      this._isMounted = true;
      if (!lookup) return;

      if (resetOnMount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }

      if (onLoad) onLoad();
      lookupRequest(lookup, lookupParams, lookupOptions).then(this.onRequestCompleted);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props5 = this.props,
          lookupReset = _this$props5.lookupReset,
          lookup = _this$props5.lookup,
          lookupParams = _this$props5.lookupParams,
          lookupOptions = _this$props5.lookupOptions,
          resetOnUnmount = _this$props5.resetOnUnmount,
          onReset = _this$props5.onReset;
      this._isMounted = false;

      if (lookup && resetOnUnmount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          render = _this$props6.render,
          children = _this$props6.children,
          lookupData = _this$props6.lookupData;
      var resetLookup = this.reset;

      if (render) {
        return render(lookupData, resetLookup) || null;
      }

      if (children) {
        return children(lookupData, resetLookup) || null;
      }

      return null;
    }
  }]);

  return LookupBase;
}(React.Component);

_defineProperty(LookupBase, "propTypes", {
  render: propTypes.func,
  resetOnMount: propTypes.bool,
  resetOnUnmount: propTypes.bool,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  onReset: propTypes.func,
  children: propTypes.func,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any,
  lookupData: propTypes.any.isRequired,
  lookupRequest: propTypes.func.isRequired,
  lookupReset: propTypes.any.isRequired
});

_defineProperty(LookupBase, "defaultProps", {
  resetOnMount: false,
  resetOnUnmount: false
});

var mapStateToProps$1 = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: getLookupData(state, lookup, lookupParams, lookupOptions)
  };
};

var actions$1 = {
  lookupRequest: lookupRequest,
  lookupReset: lookupReset
};

var connectBase$6 = function connectBase() {
  return connect$1(mapStateToProps$1, actions$1);
};

var LookupBaseComponent = compose(withLookup({
  autoNamePrefix: "Lookup/"
}), connectBase$6())(LookupBase);
/**
 * A helper to load and display lookup data
 */

var Lookup = function Lookup(props) {
  return /*#__PURE__*/React.createElement(LookupBaseComponent, props);
};

Lookup.propTypes = {
  render: propTypes.func,
  resetOnMount: propTypes.bool,
  resetOnUnmount: propTypes.bool,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  onReset: propTypes.func,
  children: propTypes.func,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any
};

/**
 * A hook to return lookup data for a previously registered lookup
 * @param {string|object} `lookup` A lookup that has already been registered
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 * @param {boolean} `options.resetOnMount` Optional, whether lookup data should be reset when the component is mounted
 * @param {boolean} `options.resetOnUnmount` Optional, whether lookup data should be reset when the component is unmounted
 * @returns {[]} An array in the format: [lookupData, resetLookup]
 * @returns {object} `lookupData` The current data for the lookup: { loading, slowLoading, params, date, response, error }
 * @returns {function} `resetLookup` A function to reset the lookup and re-request new data
 */
var useLookup = function useLookup(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lookupData = useSelector(function (state) {
    return getLookupData(state, lookup, params, options);
  });
  var dispatch = useDispatch();
  useEffect(function () {
    if (options.resetOnMount) {
      dispatch(lookupReset(lookup, params, options));
    }

    dispatch(lookupRequest(lookup, params, options));
    return function () {
      if (options.resetOnUnmount) {
        dispatch(lookupReset(lookup, params, options));
      }
    };
  }, []);
  var date = lookupData.date;
  var prevDate = useRef(date);
  var prevParams = useRef(params);
  useEffect(function () {
    // re-request if lookup was reset or params changed
    if (!date && prevDate || !compareParams(params, prevParams.current)) {
      dispatch(lookupRequest(lookup, params, options));
    }

    prevDate.current = date;
    prevParams.current = params;
  }, [date, params]);

  var resetLookup = function resetLookup() {
    dispatch(lookupReset(lookup, params, options));
    dispatch(lookupRequest(lookup, params, options));
  };

  return [lookupData, resetLookup];
};

/**
 * A hook to register a temporary lookup for an API action and return its data.
 * Useful shortcut for single instances of components where caching is not important.
 * For multiple instances or shared components, and to gain the benefits of caching, prefer useLookup instead.
 * @param {function} `action` API action creator for requesting lookup data, receives lookup parameters
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 * @returns {[]} An array in the format: [lookupData, resetLookup]
 * @returns {object} `lookupData` The current data for the lookup: { loading, slowLoading, params, date, response, error }
 * @returns {function} `resetLookup` A function to reset the lookup and re-request new data
 */

var useLookupAction = function useLookupAction(action, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lookup = useRef();

  if (!lookup.current) {
    var name = createAutoName("useLookupAction/");
    lookup.current = registerLookup(name, action, options);
  }

  var dispatch = useDispatch();
  useEffect(function () {
    return function () {
      if (!lookup.current) return;
      dispatch(lookupReset(lookup.current));
      lookup.current.unregister();
    };
  }, []);
  return useLookup(lookup.current, params, options);
};

var PreferenceLoaderBase = /*#__PURE__*/function (_React$Component) {
  _inherits(PreferenceLoaderBase, _React$Component);

  var _super = _createSuper(PreferenceLoaderBase);

  function PreferenceLoaderBase() {
    var _this;

    _classCallCheck(this, PreferenceLoaderBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onLoadPreferences", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, loadPreferences, savePreferences, onLoaded, preferences;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, loadPreferences = _this$props.loadPreferences, savePreferences = _this$props.savePreferences, onLoaded = _this$props.onLoaded, preferences = _this$props.preferences;
              _context.next = 3;
              return loadPreferences();

            case 3:
              if (onLoaded) onLoaded(preferences, savePreferences);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass(PreferenceLoaderBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoadPreferences();
    }
  }]);

  return PreferenceLoaderBase;
}(React.Component);

_defineProperty(PreferenceLoaderBase, "propTypes", {
  onLoaded: propTypes.func,
  preferences: propTypes.any.isRequired,
  loadPreferences: propTypes.any.isRequired,
  savePreferences: propTypes.any.isRequired
});

var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    preferences: getPreferenceState(state)
  };
};

var actions$2 = {
  loadPreferences: loadPreferences,
  savePreferences: savePreferences
};
var connect = createTypedConnect();
var ConnectedPreferenceLoader = connect(mapStateToProps$2, actions$2)(PreferenceLoaderBase);
/**
 * A helper to load app preferences
 * (loading occurs when the component is mounted)
 */

var PreferenceLoader = function PreferenceLoader(props) {
  return /*#__PURE__*/React.createElement(ConnectedPreferenceLoader, props);
};

PreferenceLoader.propTypes = {
  onLoaded: propTypes.func
};

var PreferenceSaverBase = /*#__PURE__*/function (_React$Component) {
  _inherits(PreferenceSaverBase, _React$Component);

  var _super = _createSuper(PreferenceSaverBase);

  function PreferenceSaverBase(props) {
    var _this;

    _classCallCheck(this, PreferenceSaverBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "debouncedSavePreferences", void 0);

    _defineProperty(_assertThisInitialized(_this), "onSavePreferences", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, savePreferences, onSaved;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, savePreferences = _this$props.savePreferences, onSaved = _this$props.onSaved;
              _context.next = 3;
              return savePreferences();

            case 3:
              if (onSaved) onSaved();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.debouncedSavePreferences = debounce(_this.onSavePreferences, props.debounce);
    return _this;
  }

  _createClass(PreferenceSaverBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var saveOnMount = this.props.saveOnMount;
      if (saveOnMount) this.onSavePreferences();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var saveOnUnmount = this.props.saveOnUnmount;
      if (saveOnUnmount) this.onSavePreferences();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === "function" ? children(this.debouncedSavePreferences) : children;
    }
  }]);

  return PreferenceSaverBase;
}(React.Component);

_defineProperty(PreferenceSaverBase, "propTypes", {
  saveOnMount: propTypes.bool.isRequired,
  saveOnUnmount: propTypes.bool.isRequired,
  debounce: propTypes.number.isRequired,
  onSaved: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]).isRequired,
  savePreferences: propTypes.any.isRequired
});

var actions$3 = {
  savePreferences: savePreferences
};
var ConnectedPreferenceSaver = createTypedConnect()(undefined, actions$3)(PreferenceSaverBase);
/**
 * A helper to save app preferences
 */

var PreferenceSaver = function PreferenceSaver(props) {
  return /*#__PURE__*/React.createElement(ConnectedPreferenceSaver, props);
};

PreferenceSaver.propTypes = {
  saveOnMount: propTypes.bool,
  saveOnUnmount: propTypes.bool,
  debounce: propTypes.number,
  onSaved: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]).isRequired
};
PreferenceSaver.defaultProps = {
  saveOnMount: false,
  saveOnUnmount: false,
  debounce: 1000
};

/**
 * A hook to retrieve and manage preferences
 * @returns {object} An object with the following properties:
 * @returns {object} `preferences` Current preference values
 * @returns {function} `updatePreference` A function to update a single preference value, takes 2 arguments for the name and value to set
 * @returns {function} `resetPreferences` A function to reset all preferences to default values
 * @returns {function} `loadPreferences` A function to load preferences from previously saved data (if configured)
 * @returns {function} `savePreferences` A function to save preferences for re-loading later (if configured)
 */

var usePreferences = function usePreferences() {
  var dispatch = useDispatch();
  var preferences = useSelector(getPreferenceState);
  return {
    preferences: preferences,
    updatePreference: function updatePreference$1(key, value) {
      return dispatch(updatePreference(key, value));
    },
    resetPreferences: function resetPreferences$1() {
      return dispatch(resetPreferences());
    },
    loadPreferences: function loadPreferences$1() {
      return dispatch(loadPreferences());
    },
    savePreferences: function savePreferences$1() {
      return dispatch(savePreferences());
    }
  };
};

/**
 * A hook to retrieve or update a single preference value
 * @param {string} `key` Preference key to find
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current preference value, or undefined if the key does not exist
 * @returns {function} `setValue` A function to update the preference value, takes a single argument for the new value to set
 */

var usePreferenceValue = function usePreferenceValue(key) {
  var dispatch = useDispatch();
  var value = useSelector(function (state) {
    return getPreferenceValue(state, key);
  });

  var setValue = function setValue(newValue) {
    dispatch(updatePreference(key, newValue));
  };

  return [value, setValue];
};

var ScreenSize;

(function (ScreenSize) {
  ScreenSize["Small"] = "small";
  ScreenSize["Medium"] = "medium";
  ScreenSize["Large"] = "large";
})(ScreenSize || (ScreenSize = {}));

var _screenSizes;
var defaultOptions$7 = {
  screenSizes: (_screenSizes = {}, _defineProperty(_screenSizes, ScreenSize.Small, {
    max: 767
  }), _defineProperty(_screenSizes, ScreenSize.Medium, {
    min: 768,
    max: 1199
  }), _defineProperty(_screenSizes, ScreenSize.Large, {
    min: 1200
  }), _screenSizes)
};
var config$2 = new ModuleConfig(defaultOptions$7);
var getResponsiveOptions = function getResponsiveOptions() {
  return config$2.getAll();
};
/**
 * Configures options for the responsive module
 * @param {Object} `options` Options to set
 * @param {Object} `options.screenSizes` Defined screen breakpoints for the app, in the form of a key-object collection, where each key is the screen name, and the object the screen configuration. For example: { "small": { min:400, max:700 } }
 */

var setResponsiveOptions = function setResponsiveOptions(options) {
  return config$2.setAll(options);
}; // internal module helpers

var getScreenSizes = function getScreenSizes() {
  return config$2.get("screenSizes");
};

/**
 * Selects Redux state for responsive data
 * @param {object} `state` Redux state
 */
var getResponsiveState = function getResponsiveState(state) {
  return state.responsive;
};
/**
 * Returns state/config for the current screen size
 * @param {object|null} `state` Redux state, or null if the screen size has not been determined
 */

var getResponsiveScreen = function getResponsiveScreen(state) {
  var _getResponsiveState = getResponsiveState(state),
      screenSize = _getResponsiveState.screenSize;

  if (!screenSize) return null;
  var screenSizes = getScreenSizes();
  return {
    screenSize: screenSize,
    screenConfig: screenSizes[screenSize]
  };
};

var RESPONSIVE_RESIZE = "RESPONSIVE/RESIZE";
var updateScreenSize = function updateScreenSize(size) {
  return function (dispatch, getState) {
    var _getResponsiveState = getResponsiveState(getState()),
        screenSize = _getResponsiveState.screenSize;

    var screenSizes = getScreenSizes();
    var newScreenSize = Object.keys(screenSizes).find(function (key) {
      var _screenSizes$key = screenSizes[key],
          min = _screenSizes$key.min,
          max = _screenSizes$key.max;
      return (min === undefined || size >= min) && (max === undefined || size <= max);
    });

    if (newScreenSize && newScreenSize !== screenSize) {
      dispatch({
        type: RESPONSIVE_RESIZE,
        screenSize: newScreenSize
      });
    }
  };
};

/**
 * A hook to make components responsive
 * @returns {object|null} Current screen state/config, or null if the screen size has not been determined
 * @returns {string} `screenSize` The current screen size
 * @returns {object} `screenConfig` The current screen configuration
 */

var useResponsive = function useResponsive() {
  return useSelector(getResponsiveScreen);
};

var defaultOptions$8 = {
  reducers: {},
  middleware: [],
  reduxDevTools: false
};
var store = undefined;
var reducers = {};

// manipulation function to prevent build minification obscuring
// raw config value when using deployment string substitution
var useReduxDevTools = function useReduxDevTools(value) {
  if (typeof value === "string") {
    return value.toUpperCase() === "TRUE";
  }

  return !!value;
};
/**
 * Creates a new Redux store for state management
 * @param {Object} `options` Configuration options for the store
 * @param {Object} `options.reducers` Object containing the initial reducers for the store
 * @param {Array} `options.middleware` Redux middleware to apply to the store
 * @param {boolean|string} `options.reduxDevTools` Whether the Redux developer tools browser extension should be enabled, default false
 * @returns {Store} The newly created Store object
 */


var createReduxStore = function createReduxStore() {
  var _storeOptions$middlew;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var storeOptions = _objectSpread2(_objectSpread2({}, defaultOptions$8), options);

  reducers = _objectSpread2({}, storeOptions.reducers);
  var composeEnhancer = compose;

  if (storeOptions.reduxDevTools && useReduxDevTools(storeOptions.reduxDevTools) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }

  var storeEnhancer = composeEnhancer(applyMiddleware.apply(void 0, _toConsumableArray((_storeOptions$middlew = storeOptions.middleware) !== null && _storeOptions$middlew !== void 0 ? _storeOptions$middlew : [])));
  var newStore = createStore(combineReducers(reducers), storeEnhancer);
  store = newStore;
  return newStore;
};
/**
 * Updates the Redux store with new reducers.
 * Existing reducers with the same name will be replaced
 * @param {Object} `newReducers` Object containing the new reducers to apply
 */

var updateReducers = function updateReducers(newReducers) {
  if (!store) return;
  reducers = _objectSpread2(_objectSpread2({}, reducers), newReducers);
  store.replaceReducer(combineReducers(reducers));
};

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

var getInitialState = function getInitialState() {
  return {
    loggedIn: false
  };
};

var auth = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AUTHENTICATE:
      return _objectSpread2(_objectSpread2({}, state), onMapAuthenticatedState$1(action.result));

    case DEAUTHENTICATE:
      return _objectSpread2(_objectSpread2({}, state), onMapDeauthenticatedState$1(action.result));

    default:
      return state;
  }
});

var initialState = {};
var builders = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case RESET_LIST:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, {
        filters: _objectSpread2({}, action.filters),
        pagination: _objectSpread2({}, action.pagination),
        selection: _objectSpread2({}, action.selection)
      }));

    case CHANGE_FILTERS:
      var newListState = _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        filters: action.filters
      });

      if (action.resetPage) {
        newListState.pagination = _objectSpread2(_objectSpread2({}, newListState.pagination), {}, {
          pageNumber: 1
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, newListState));

    case CHANGE_PAGINATION:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        pagination: action.pagination
      })));

    case CHANGE_SELECTION:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        selection: action.selection
      })));

    case CLEAR_STATE:
      var _action$id = action.id;
          state[_action$id];
          var remainingState = _objectWithoutProperties(state, [_action$id].map(_toPropertyKey));

      return _objectSpread2({}, remainingState);

    default:
      return state;
  }
});

var initialState$1 = {};
var lookups$1 = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SAVE_LOOKUP_STATE:
    case LOOKUP_SET:
      {
        var oldLookupState = state[action.name] || {};
        var oldKeyState = oldLookupState.keys || [];
        var newLookupState = oldKeyState.reduce(function (acc, key) {
          if (key !== action.key && (!action.limit || acc.keys.length < action.limit)) {
            acc.keys = [].concat(_toConsumableArray(acc.keys), [key]);
            acc[key] = oldLookupState[key];
          }

          return acc;
        }, _defineProperty({
          keys: [action.key]
        }, action.key, _objectSpread2(_objectSpread2({}, oldLookupState[action.key]), action.state)));
        return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, newLookupState));
      }

    case LOOKUP_RESET:
      {
        if (!action.name) {
          // reset all lookups
          return {};
        }

        if (action.key === undefined) {
          // reset all data for a lookup
          var _action$name = action.name;
              state[_action$name];
              var otherLookups = _objectWithoutProperties(state, [_action$name].map(_toPropertyKey));

          return otherLookups;
        } // reset specified key for a lookup


        var _oldLookupState = state[action.name] || {};

        var _action$key = action.key;
            _oldLookupState[_action$key];
            var _oldLookupState$keys = _oldLookupState.keys,
            keys = _oldLookupState$keys === void 0 ? [] : _oldLookupState$keys,
            otherKeys = _objectWithoutProperties(_oldLookupState, [_action$key, "keys"].map(_toPropertyKey));

        return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, _objectSpread2(_objectSpread2({}, otherKeys), {}, {
          keys: keys.filter(function (k) {
            return k !== action.key;
          })
        })));
      }

    default:
      return state;
  }
});

var initialState$2 = {
  events: []
};
var notifications = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD:
      var newEvent = {
        id: Math.floor(Math.random() * 100000000),
        title: action.title,
        type: action.eventType,
        message: action.message,
        customData: action.customData,
        expiry: action.expiry,
        creation: Date.now()
      };

      if (action.method === AddMethod.AddOrReplaceTop) {
        // check for duplicate event on top of the stack
        var _state$events = _toArray(state.events),
            lastEvent = _state$events[0],
            otherEvents = _state$events.slice(1);

        if (lastEvent && lastEvent.type === newEvent.type && lastEvent.message === newEvent.message) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            events: [_objectSpread2(_objectSpread2({}, lastEvent), {}, {
              expiry: newEvent.expiry,
              creation: newEvent.creation
            })].concat(_toConsumableArray(otherEvents))
          });
        }
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: [newEvent].concat(_toConsumableArray(state.events))
      });

    case REMOVE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: state.events.filter(function (e) {
          return e.id !== action.id;
        })
      });

    case REMOVE_ALL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: []
      });

    default:
      return state;
  }
});

var preferences = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPreferenceDefaults();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATE_PREFERENCE:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.key, action.value));

    case RESET_PREFERENCES:
      return getPreferenceDefaults();

    case LOAD_PREFERENCES:
      return _objectSpread2(_objectSpread2({}, state), action.values);

    default:
      return state;
  }
});

var initialState$3 = {
  screenSize: null
};
var responsive = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case RESPONSIVE_RESIZE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        screenSize: action.screenSize
      });

    default:
      return state;
  }
});

var abortMiddleware = function abortMiddleware() {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === "function" || action.type !== ABORTABLE_PROVIDER) {
          return next(action);
        }

        var abort = action.abort,
            abortAction = action.action;

        if (typeof abortAction === "function") {
          // thunks can't be handled automatically
          // the abort implementation will however be available as a 3rd param
          return abortAction(dispatch, getState, abort);
        }

        var abortableAction = _objectSpread2(_objectSpread2({}, abortAction), {}, {
          abort: abort
        });

        return dispatch(abortableAction);
      };
    };
  };
};

var apiRequest$1 = function apiRequest(method, url) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      body = options.body,
      contentType = options.contentType,
      auth = options.auth,
      abort = options.abort,
      other = _objectWithoutProperties(options, ["headers", "body", "contentType", "auth", "abort"]);

  return new Promise(function (resolve, reject) {
    var object = _objectSpread2(_objectSpread2({}, other), {}, {
      method: method.toUpperCase(),
      headers: _objectSpread2({}, headers),
      body: undefined,
      signal: abort === null || abort === void 0 ? void 0 : abort.signal
    });

    if (contentType !== null && contentType !== undefined) {
      object.headers["Content-Type"] = contentType;
    }

    if (auth !== null && auth !== undefined) {
      object.headers["Authorization"] = auth;
    }

    if (body !== null && body !== undefined) {
      if (contentType && contentType.includes("application/json")) {
        object.body = JSON.stringify(body);
      } else {
        object.body = body;
      }
    }

    var rejected = false;

    if (abort !== undefined) {
      if (abort.aborted) {
        // aborted before request started
        reject(abort.reason);
        return;
      }

      if (!abort.signal) {
        // manually handle aborts where AbortSignal not supported
        var onAbort = function onAbort(reason) {
          rejected = true;
          abort.removeListener(onAbort);
          reject(reason);
        };

        abort.addListener(onAbort);
      }
    }

    fetch(url, object).then(function (response) {
      if (rejected) return;

      if (!response.ok) {
        var onErrorResponse = getOnErrorResponse();
        onErrorResponse(response).then(function (error) {
          return reject(error);
        });
        return;
      }

      var handleResponse = function handleResponse(r) {
        resolve(r);
      };

      var responseType = response.headers.get("Content-Type");

      if (!responseType || options.preventResponseHandling) {
        handleResponse(response);
      } else if (responseType.includes("application/json")) {
        // json response (silently catch errors caused by no data being returned by server)
        response.json().then(function (data) {
          return handleResponse(data);
        }).catch(function (error) {
          return handleResponse(null);
        });
      } else if (responseType.includes("application/zip") || responseType.includes("application/pdf") || responseType.includes("application/octet-stream") || responseType.includes("image/")) {
        // blob file types
        response.blob().then(function (data) {
          return handleResponse(data);
        });
      } else if (responseType.includes("text/")) {
        // text file types
        response.text().then(function (data) {
          return handleResponse(data);
        });
      } else {
        // unsupported type
        handleResponse(response);
      }
    }).catch(function (e) {
      if (rejected) return;
      var error = e;

      if (error.name === "AbortError" || abort !== null && abort !== void 0 && abort.aborted) {
        reject(abort === null || abort === void 0 ? void 0 : abort.reason);
      } else {
        var failureError = getFetchFailureError();
        reject(new ApiError(failureError || error.message, HttpStatus.ServiceUnavailable));
      }
    });
  });
};

var apiRequestHandler = function apiRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: action.method,
      url: action.url,
      contentType: action.contentType,
      body: action.body,
      auth: action.auth
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var requestOptions,
          response,
          error,
          onErrorNotification,
          reason,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestOptions = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              response = undefined;
              _context.prev = 2;
              _context.next = 5;
              return apiRequest$1(action.method, action.url, _objectSpread2(_objectSpread2({}, requestOptions), {}, {
                headers: _objectSpread2(_objectSpread2({}, requestOptions.headers), action.headers),
                contentType: action.contentType,
                body: action.body,
                preventResponseHandling: getPreventResponseHandling() || action.preventResponseHandling,
                abort: action.abort
              }));

            case 5:
              response = _context.sent;
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              if (_context.t0 instanceof ApiError) {
                error = _context.t0;
                onErrorNotification = getOnErrorNotification();
                store.dispatch(req.error(error));

                if (!getPreventErrorNotification() && !action.preventErrorNotification && onErrorNotification) {
                  store.dispatch(onErrorNotification(error.message));
                }

                resolve({
                  success: false,
                  error: error
                });
              } else {
                reason = typeof _context.t0 === "string" ? _context.t0 : undefined;
                store.dispatch(req.abort(reason));
                resolve({
                  success: false,
                  reason: reason
                });
              }

              return _context.abrupt("return");

            case 12:
              store.dispatch(req.success(response));
              resolve({
                success: true,
                response: response
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function dispatchRequest() {
      return _ref.apply(this, arguments);
    };
  }(); // process the api request


  beforeRequest();
  onApiRequest$1(store, action).then(function (requestOptions) {
    dispatchRequest(requestOptions);
  }).catch(function (error) {
    store.dispatch(req.error(error));
    resolve({
      success: false,
      error: error
    });
  });
};

var mockRequestHandler = function mockRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: "MOCK",
      success: action.success,
      response: action.response,
      error: action.error,
      delay: action.delay
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = function dispatchRequest() {
    if (action.success) {
      store.dispatch(req.success(action.response));
      resolve({
        success: true,
        response: action.response
      });
    } else if (action.error != undefined) {
      var errorResponse = new ApiError(action.error);
      var onErrorNotification = getOnErrorNotification();
      store.dispatch(req.error(errorResponse));

      if (!getPreventErrorNotification() && !action.preventErrorNotification && onErrorNotification) {
        store.dispatch(onErrorNotification(errorResponse.message));
      }

      resolve({
        success: false,
        error: errorResponse
      });
    }
  }; // process the api request


  beforeRequest();
  var rejected = false;

  if (action.abort !== undefined) {
    var onAbort = function onAbort(reason) {
      var _action$abort;

      rejected = true;
      (_action$abort = action.abort) === null || _action$abort === void 0 ? void 0 : _action$abort.removeListener(onAbort);
      store.dispatch(req.abort(reason));
      resolve({
        success: false,
        reason: reason
      });
    };

    action.abort.addListener(onAbort);
  }

  if (action.delay) {
    setTimeout(function () {
      if (rejected) return;
      dispatchRequest();
    }, action.delay);
  } else {
    if (rejected) return;
    dispatchRequest();
  }
}; // Redux middleware


var defaultOptions$9 = {};
var debounceMap = new DebounceMap();

var apiMiddleware = function apiMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions$9;
  return function (store) {
    return function (next) {
      return function (action) {
        var requestHandler = action.type === API_REQUEST ? apiRequestHandler : action.type === MOCK_REQUEST ? mockRequestHandler : null;

        if (requestHandler) {
          return new Promise(function (resolve) {
            var processRequest = function processRequest() {
              return requestHandler(store, action, options, resolve);
            };

            if (action.debounce && action.requestType) {
              debounceMap.debounce(action.requestType, processRequest, Math.abs(action.debounce), {
                immediate: action.debounce < 0
              });
            } else {
              processRequest();
            }
          });
        }

        return next(action);
      };
    };
  };
};

var middlewareMap = {};

var loggingMiddleware = function loggingMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        // check middlewares setup
        processLoggers(function (logger) {
          if (!middlewareMap[logger.type] && logger.getMiddleware) {
            var mw = logger.getMiddleware();

            if (mw) {
              middlewareMap[logger.type] = mw(store);
            }
          }
        }); // intercept and process each middleware

        var middlewares = Object.values(middlewareMap);
        var theNext = middlewares.reduce(function (acc, mw) {
          return mw(acc);
        }, next);
        return theNext(action);
      };
    };
  };
};

var lookupPromises = new ConcurrentPromiseMap();

var lookupMiddleware = function lookupMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === LOOKUP_REQUEST) {
          // ensure the lookup is registered
          if (!lookupExists(action.name)) {
            var error = "Lookup \"".concat(action.name, "\" has not been registered");
            console.error(error);
            return Promise.resolve({
              success: false,
              error: error
            });
          } // get required lookup info


          var lookupAction = getLookupAction(action.name);

          var lookupOptions = _objectSpread2(_objectSpread2({}, getLookupOptions(action.name)), action.options);

          var lookupState = getLookupState(store.getState());
          var promiseKey = "".concat(action.name, "/").concat(action.key); // re-use state data if caching

          if (lookupOptions.cache && lookupState[action.name] && lookupState[action.name][action.key] && lookupState[action.name][action.key].response) {
            var useCache = true;
            var dataState = lookupState[action.name][action.key];
            var cacheDate = dataState.date; // check cache hasn't expired

            if (cacheDate && lookupOptions.cacheExpiry) {
              var expiryDate = cacheDate + lookupOptions.cacheExpiry;
              if (expiryDate < Date.now()) useCache = false;
            }

            if (useCache) {
              return Promise.resolve({
                success: true,
                response: dataState.response
              });
            }
          } // the process of requesting a lookup is promise-able so if
          // multiple simultaneous requests we only perform the lookup once


          var requestLookup = function requestLookup() {
            return new Promise(function (resolve) {
              var saveFailure = false;

              var saveLookup = function saveLookup(newState) {
                // ensure the lookup is still registered
                if (!lookupExists(action.name)) {
                  if (!saveFailure) {
                    console.warn("Lookup \"".concat(action.name, "\" unregistered before request finished"));
                  }

                  saveFailure = true;
                  return;
                }

                var limit = lookupOptions.cache ? lookupOptions.cacheLimit === undefined || isNaN(lookupOptions.cacheLimit) ? undefined : lookupOptions.cacheLimit : 1;
                store.dispatch(saveLookupState(action.name, action.key, limit, newState));
              };

              saveLookup({
                loading: true,
                slowLoading: false,
                params: action.params
              });
              var slowTimeout = setTimeout(function () {
                saveLookup({
                  loading: true,
                  slowLoading: true
                });
              }, 200);
              store.dispatch(typeof lookupAction === "function" ? lookupAction(action.params) : lookupAction).then(function (_ref) {
                var success = _ref.success,
                    rawResponse = _ref.response,
                    error = _ref.error;
                clearTimeout(slowTimeout);
                var response = success && rawResponse && lookupOptions.transform ? lookupOptions.transform(rawResponse, action.params) : rawResponse;
                saveLookup({
                  loading: false,
                  slowLoading: false,
                  date: Date.now(),
                  response: response,
                  error: error
                });
                resolve({
                  success: success,
                  response: response,
                  error: error
                });
              });
            });
          };

          return lookupPromises.resolve(promiseKey, requestLookup);
        }

        return next(action);
      };
    };
  };
};

var getDefaultReducers = function getDefaultReducers() {
  return {
    auth: auth,
    builders: builders,
    lookups: lookups$1,
    notifications: notifications,
    preferences: preferences,
    responsive: responsive
  };
};
var getDefaultMiddleware = function getDefaultMiddleware() {
  return [apiMiddleware(), lookupMiddleware(), loggingMiddleware(), thunk, abortMiddleware() // must run before thunk
  ];
};
var createDefaultReduxStore = function createDefaultReduxStore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var reducers = _objectSpread2(_objectSpread2({}, options.reducers || {}), getDefaultReducers());

  var middleware = [].concat(_toConsumableArray(options.middleware || []), _toConsumableArray(getDefaultMiddleware()));
  return createReduxStore(_objectSpread2(_objectSpread2({}, options), {}, {
    reducers: reducers,
    middleware: middleware
  }));
};

export { ADD, AJAX_ABORT, AJAX_ERROR, AJAX_RESET, AJAX_SLOW, AJAX_START, AJAX_SUCCESS, API_REQUEST, AddMethod, ApiError, ApiRequestMethod, ApiRequestsErrorPriority, actions as AuthActions, events as AuthEvents, AuthIntegrationAction, AuthIntegrationEvent, AuthenticatedApp, ClaimCheck, ConcurrentPromiseMap, ContentBuilder, DebounceMap, EventType, FieldTrigger, FormBuilder, FormBuilderResetStateType, FormContext, utils as FormUtils, index$1 as FormValidators, index as JwtAuthIntegration, ListBuilder, ListBuilderResetStateType, LoggerType, Lookup, utils$1 as LookupUtils, MOCK_REQUEST, MockArrayData, ModalBuilder, ModuleConfig, ModuleIntegration, ModuleIntegrationPipeline, PreferenceLoader, PreferenceSaver, PropagateUpdatesMethod, REMOVE, REMOVE_ALL, ScreenSize, TriggerAction, TriggerBuilder, TriggerEvent, WizardBuilder, WizardBuilderStep, addLogger, addNotification, ajaxActionsFor, apiDelete, apiGet, apiPatch, apiPost, apiPut, apiRequest, apiRequests, actions as authActions, events as authEvents, authenticate, clearUserIdentity, compareParams, concurrentPromise, connectForm, createAutoName, createDefaultReduxStore, createReduxStore, createTypedConnect, deauthenticate, debounce, enableCustomAuth, enableCustomLogger, enableJwtAuth, enablePreferencesFromApi, enablePreferencesFromLocalStorage, findLookup, utils as formUtils, index$1 as formValidators, getApiOptions, getAuthClaim, getAuthClaims, getAuthIntegrations, getAuthOptions, getAuthRefreshToken, getAuthState, getDefaultAuthLoadable, getDefaultBuilderLoadable, getDefaultMiddleware, getDefaultReducers, getJwtOptions, getLoggingOptions, getLookupCache, getLookupData, getLookupState, getNotificationState, getParamsKey, getPreferenceDefaults, getPreferenceOptions, getPreferenceSource, getPreferenceState, getPreferenceValue, getResponsiveOptions, getResponsiveScreen, getResponsiveState, getTokenStoreProvider, isAjaxAbort, isAjaxError, isAjaxReset, isAjaxSlow, isAjaxStart, isAjaxSuccess, loadPreferences, logError, logNavigation, loggerExists, lookupExists, lookupRequest, lookupReset, lookupSet, mockError, mockRequest, mockSuccess, notifyError, notifyInfo, notifySuccess, notifyWarning, refreshJwt$1 as refreshJwt, registerLookup, removeAllNotifications, removeNotification, requestAbortedAt, requestError, requestErrorHasCode, requestIsAborted, requestIsBusy, requestIsSlow, requestIsSuccess, requestReceivedAt, requestResponse, requestSentAt, requestStatus, resetPreferences, savePreferences, setApiOptions, setAuthOptions, setDefaultAuthLoadable, setDefaultBuilderLoadable, setJwtOptions, setLoggingOptions, setPreferenceDefaults, setResponsiveOptions, setTokenStoreProvider, setUserIdentity, unregisterLookup, updatePreference, updateReducers, updateScreenSize, useApiAction, useApiDelete, useApiGet, useApiPatch, useApiPost, useApiPut, useApiRequest, useAuthClaims, useAuthState, useCustomAuth, useFormEffect, useFormField, useFormState, useJwtAuth, useLoggedIn, useLookup, useLookupAction, usePreferenceValue, usePreferences, usePreferencesFromApi, usePreferencesFromLocalStorage, useResponsive, withForm, withFormArray, withFormObject, withLookup };
